import { create } from "@mui/material/styles/createTransitions";
import { reject } from "q";

export const StringBundle = {
  purchase: {
    purchaseOrder: {
      status: "Status",
      reports: "Reports",
      purchaseOrder: "Purchase Order",
      selectPoType: "Select Purchase Order Type",
      ormType: "ORM type *",
      rcType: "RC type *",
      greenCoffeeType: "Green coffee type *",
      purchaseOrderLogisticCost: 'Purchase Order Logistic Costs',
      submitForReview : "Submit For Review",
      pendingReview : "Pending Review",
      requestApproval : "Request Approval",
      approve: "Approve",
      inProgress: "In Progress",
      shipped: "Shipped",
      dispatched:"Dispatched",
      partiallyDelivered:"Partially Delivered",
      closeOrder: "Close Order",
      forms: {
        group: 'Group',
        quotesForAllocation: "Quote for allocation",
        selectQuotesForAllocation: "Select Quote for Allocation",
        taxDetails: "Tax Details",
        taxes: "Taxes",
        taxPercentage: "Tax(%)",
        add: "Add",
        import: "Import",
        reviewed: "Review",
        domestic: "Domestic",
        comments: "Comments",
        percentage: "Percentage",
        amount: "Amount",
        termsOfPayment: "Terms of Payment",
        new: "New",
        pendingWithApproval: "Pending Approval",
        inprogress: "InProgress",
        shipped: "Shipped",
        approved: "Approved",
        partiallyDelivered: "Partially Delivered",
        delivered: "Delivered",
        completed: "Completed",
        closed: "Closed",
        currency: "Currency",
        indianRupees: "Indian Rupees",
        vietnamese: "Vietnamese",
        paymentTerms: "Payment Terms",
        advanceType: "Advance Type",
        advance: "Advance",
        noOfDaysIOM: "No of days IOM can  be generated from date of invoice",
        noOfDays: " No of days from the date of receipt of material",
        paymentAgainstDelivery: "Payment Against Delivery",
        paymentTermsRemarks: "Payment Terms Remarks",
        purchasePriceVND: "Purchase price (VND/KG)",
        purchasePriceINR: "Purchase price (INR/KG)",
        grossPriceCVND: "Gross price (VND/KG)",
        grossPriceCINR: "Gross price (INR/KG)",
        grossPriceCurrency: "Gross price",
        pocurrencyCodeVal:"PO value",
        poCurrencyPrice: "Purchase price",
        totalValue: "Total value",
        poValueINR: "PO value (INR)",
        poValueVND: "PO value (VND)",
        poCategory: "PO category",
        ormInformation: "ORM Information",
        rcInformation: "RC Information",
        greenCoffeeInformation: "Green coffee information",
        shipmentMonthFrom: "From",
        shipmentMonthTo: "To",
        shipmentMonthFilter: "Shipment Month Filter",
        dateFilterApplied: "Date Filter Applied:",
        shipmentMonthFilterApplied: "Shipment Month Filter Applied:",
        applyFilter: "Apply Filter",
        fromDateCannotAfterToDate: "From Date cannot be after To Date",
        pleaseSelectToDate: "Please select the To Date",
        taxCannotBeEmpty: "tax cannot be empty",
        taxAlreadyAdded: "tax already added",
        purchaseType: "Purchase type",
        terminalRate: "Terminal rate",
        terminalMonth: "Terminal month",
        bookingTerminalRate: "Booking terminal rate",
        bookingTerminalMonth: "Booking terminal month",
        differential: "Differential",
        marketPrice: "Market price",
        poMargin: "PO margin",
        contractStatus: "Contract status",
        bookingLogisticsCost: "Booking Logistics Cost Per MT( Metric Ton)",
      },
      messages: {
        coffeeExcess: "Coffee is being procured in Excess",
        allocationQtyMismatch: "Total Allocated Quantity Should be Equal to Po Quantity",
        sentForRequestApproval: "PO sent for request approval",
        reviewdSuccessfully: "PO reviewed successfully",
        approvedSuccessfully: "PO approved successfully",
        closedSuccessfully: "PO closed successfully",
      },
      statusLabels: {
        new: "New",
        pending_with_approval: "Pending Approval",
        approved: "Approved",
        closed: "Closed",
        partially_delivered: "Partially delivered",
        pending_review: "Pending Review",
        pending_with_general_director: "Pending with General Director",
      },
      view: {
        PreShipmentSampleLineItem: "Pre-Shipment Sample Line Item Details",
        to_be_fixed_contract : 'To be fixed contract',
        received_quantity_info_tab: {
          purchase_order_quantity: "Purchase Order Quantity",
          total_quantity_received_percentage: "Total Quantity Received (%)",
          received_quantity_table: {
            dispatch_id: "Dispatch Record Number",
            status: "Status",
            expected_quantity: "Expected Quantity (kgs)",
            quantity_received: "Quantity Received (kgs)"
          }
        }
      },
      pdfs: {
        inr: "INR",
        rate: "RATE",
        amount: "AMOUNT",
        totalValue: "TOTAL VALUE",
        workingDaysOfInvoice: "Working days from date of invoice.",
        workingDaysFromReceipt:
          "Working days from date of reciept of material.",
        percentWillBePaidAsAdvance: "percent will be paid as advance",
        rupeesPrefix: "Rupees",
        willBePaidAsAdvance: "will be paid as advance",
        continued_on_next_page: "Continued on next page ...",
        import_gc: {
          sub_headings:{
            document_required: "DOCUMENTS REQUIRED:"
          },
          eou_Extention: "100% EOU Extn.",
          gc_import_terms_fields: {
          payment_terms: "PAYMENT TERMS",
          comments: "COMMENTS",
          other_terms: "OTHER TERMS",
          incoterms: "INCOTERMS",
          forwarding: "FORWARDING",
          ports: "PORT OF LOADING",
          destination_port_name: "DESTINATION",
          insurance: "INSURANCE",
         }
        }
      },
      dispatch: {
        dispatchLogisticCost: 'Purchase Order Disptachs Logistic Costs',
        podispatch: "PO Level Dispatch",
        invoice: "Invoice",
        weight_certificate: "Weight Certificate",
        supplier_contract_copy: "Supplier Contract Copy",
        certificate_of_origin: "Certificate of Origin",
        ico_certificate_of_origin: "ICO Certificate of Origin",
        insurance_certificate: "Insurance Certificate",
        phytosanitary_certificate: "Phytosanitary Certificate",
        fumigation_certificate: "Fumigation Certificate",
        density: "Density(Gm/Cc)",
        moisture: "Moisture (%)",
        sound_beans: "Sound Beans (%)",
        browns: "Browns (%)",
        blacks: "Blacks (%)",
        broken_bits: "Broken & Bits (%)",
        insected_beans: "Insected beans (%)",
        bleached: "Bleached (%)",
        husk: "Husk (%)",
        sticks: "Sticks (%)",
        stones: "Stones (%)",
        mouldy_beans: "Mouldy Beans (%)",
        beans_retained: "Beans retained on 5mm mesh during sieve analysis",
        fileUploadSuccess: "File uploaded successfully",
        fileDeleteSuccess: "File deleted successfully",
        fileDownloadSuccess: "File downloaded successfully",
        item: "Item",
        composition: "Composition",
        date: "Date",
        mrin: "MRIN",
        dispatch: "Dispatch",
        expected_quantity: "Expected(Kgs)",
        delivered_quantity: "Delivered(Kgs)",
        balance_quantity: "Balance Quantity(Kgs)",
        parent_dispatch: "Parent dispatch",
        ap_status: "AP Status",
        qc_status: "QC Status",
        dispatch_date: "Dispatch Date",
        dispatchUpdateSuccess: "Dispatch updated successfully",
        si_check_label: "Is Shipping Instructed",
        port_date_label: "Port Date",
        eta_date: "ETA (Expected Time of Arrival)",
        edit_dispatch_details: "Edit Dispatch Details",
        si_date_label: "SI Date",
        dispatch_details: "Dispatch Details",
        dispatch_no: "Dispatch Number",
        dispatch_date: "Dispatch Date",
        quantity: "Quantity",
        delivered: "Delivered",
        balance: "Balance",
        dispatch_status: "Dispatch Status",
        port_date: "Port Date",
        si_date: "SI Date",
        specification_information: "Specification information",
        expectedOrderSpecificationInformation: "Expected order specification information",
        dispatchSpecificationInformation: "Dispatch specification information",
        mrinInformation: "MRIN information",
        documentInformation: "Document information",
        pleaseUploadPDF: "Please upload PDF files only",
        dispatchInformation: "Dispatch Information",
        childDispatchInformation: "Child Dispatch Information",
        dispatchTableHeaders: {
          dispatch_id: "Dispatch Detail",
          related_detid: "Related Dispatch",
          dispatch_quantity: "Quantity",
          dispatch_date: "Date",
          delivered_quantity: "Delivered",
          balance_quantity: "Balance",
          dispatch_status: "Dispatch Status",
          port_date: "Port Date",
        },
        deleteAttachement: "Are you sure you want to delete this Attachment ?",
        documentsUpdatedSuccessfully: "Documents updated successfully",
        attachmentDeleted: "Attachment Deleted",
        uploadFile: "upload file",
        dispatch_dtls: {
          dispatch_id: "Dispatch Number",
          dispatch_date: "Dispatch Date",
          dispatch_quantity: "Quantity",
          delivered_quantity: "Delivered",
          balance_quantity: "Balance",
          dispatch_status: "Dispatch Status",
          port_date: "Port Date",
          eta_date: "ETA (Expected Time of Arrival)",
          si_date: "SI Date",
          si_check: "Is Shipping Instructed",
        },
        documentInfoTableHeaders: {
          documentName: "Document Name",
          fileName: "File Name",
          actions: "Actions",
          documentRequired: "Documents Required",
          number: "Number",
          date: "Date",
          conversionRate: "Conversion Rate",
          upload: "Upload",
        },
        documentNumberLabelMap: {
          "Bill of Entry": "Bill of Entry Number",
          "Bill of Lading": "Bill of Lading Number",
          "Certificate of Origin": "Certificate of Origin",
          "Fumigation Certificate": "Fumigation Certificate",
          "ICO Certificate of Origin": "ICO Certificate of Origin",
          "Insurance Certificate": "Insurance Certificate",
          "Invoice": "Invoice Number",
          "Supplier Contract Copy": "Supplier Contract Copy",
          "Phytosanitary Certificate": "Phytosanitary Certificate",
        },
        auditLogHeaderLabelMap: {
          date: "Date",
          conversionRate: "Conversion Rate",
        },
        docKindFields: {
          billofladdingnumber: "billofladdingnumber",
          billofladdingdate: "billofladdingdate",
          invoicenumber: "invoicenumber",
          invoicedate: "invoicedate",
          suppliercontractcopynumber: "suppliercontractcopynumber",
          suppliercontractcopydate: "suppliercontractcopydate",
          billofentrynumber: "billofentrynumber",
          billofentrydate: "billofentrydate",
          conversationratio: "conversationratio",
          
        },
        dispatchInformation: "Dispatch Information",
        childDispatchInformation: "Child Dispatch Information",
        dispatchTableHeaders: {
          dispatch_id: "Dispatch Detail",
          related_detid: "Related Dispatch",
          dispatch_quantity: "Quantity",
          dispatch_date: "Date",
          delivered_quantity: "Delivered",
          balance_quantity: "Balance",
          dispatch_status: "Dispatch Status",
          port_date: "Port Date",
        },
        mrinTableHeaders: {
          mrindate: "Date",
          mrinno: "MRIN",
          detid: "Dispatch",
          expected_quantity: "Expected(Kgs)",
          delivered_quantity: "Delivered(Kgs)",
          balance_quantity: "Balance Quantity(Kgs)",
          related_detid: "Parent dispatch",
          ap_status: "AP Status",
          qc_status: "QC Status",
        },
      },
      allocationList: {
        allocationRecordNo: 'Allocation Record No',
        quoteNo: 'Quote No',
        quoteLineNumber: 'Quote Line Number',
        accountName: 'Account Name',
        poNo: 'PO No',
        itemName: 'Item Name',
        allocatedQty: 'Allocated Qty',
        allocationDate: 'Allocation Date',
      },
     receivedQnty:{
        dispatch_no: "Dispatch Record Number",
        status: "Status",
        dispatch_quantity: "Expected Quantity (kgs)",
        delivered_quantity: "Quantity Received (kgs)",
        receivedQntyInfo: "Received Quantity Info",
        purchaseOrderQty: "Purchase Order Quantity",
        totalReceivedQty: "Total Quantity Received (%)",
        receivedQuantity :"ReceivedQuantity"
      },
      poPreShipmentGrid: {
        record_id: "Record Number",
        status_name: "Status",
        created_by: "Requested For",
        sample_request_date: "Requested Date",
      },
      poPreShipmentLineGrid: {
        record_id: "PSLI Number",
        item_name: "Item Name",
        item_category: "Item Category",
        shippment_period: "Shippment Period",
        expected_result_date: "Expected Result Date",
        rd_analysis_status: "Is R&D Approved",
        quality_analysis_status: "Is Quality Approved",
      },
      static_dropdowns: {
        insurance_options: {
          "By Supplier": "By Supplier",
          "By CCL": "By CCL"
        },
        orm_insurance_option:{
          by_self: "By Self"
        }
      },
      poGrid: {
        po_no: "PO Number",
        contract_no: "Contract Number",
        po_date: "PO Date",
        status: "Status",
        item_name: "Item Name",
        total_quantity: "Quantity (Kgs)",
        vendor_name: "Supplier",
        currency_code: "Currency",
        total_price: "PO Value",
        email_delivered: "Email Status",
      },
      export_extra_fields: {
        company_name: "Company",
        entity_name: "Entity",
        po_sub_category: "Category",
        po_category: "Item Type",
      },
      contractReport: {
        dispatchDateFrom: "Dispatch Date from",
        dispatchDateTo: "Dispatch Date to",
      },
    },
    debitnote: {
      forms: {
        CompanyName: "Company Name",
        View: "View",
        Exporting: "Exporting...",
        ExportToExcel: "Export to excel",
        CreateDebitnote: "Debit Note GC Request",
        Debitnote: "Debit Note GC",
        MailDelivered: "Mail Delivered",
        Sending: "Sending...",
        SendEmailtoVendor: "Send Email to Vendor",
        GeneratePDF: "Generate PDF",
        Generating: "Generating...",
        all: "All",
        onGeneratePDF: "Once PDF is generated, send email to vendor will be disabled",
        debitNoteDate: "Debit Note Date",
        debitNoteInfo: "Debit Note Information",
        entity: "Entity",
        debitNoteCategory: "Debit Note Category",
        vendor: "Vendor",
        vendorId: "Vendor Id",
        vendorName: "Vendor Name",
        supplierName: "Supplier Name",
        entityName: "Entity",
        remarks: "Remarks",
        comments: "Comments",
        selectMrin: "Select MRIN",
        invoiceNo: "Invoice No.",
        mrinId: "MRIN Id",
        category: "Category",
        invoiceQty: "Invoice Qty",
        husk: "Husk",
        hsn:"HSN Code",
        invoiceNumber: "Invoice Number",
        invoiceQuantity: "Invoice Quantity",
        deliveredQuantity: "Delivered Quantity",
        shortageQuantity: "Shortage Quantity",
        quality: "Quality",
        moisture: "Moisture",
        itemType: "Item Type",
        stones: "Stones",
        soundBeans: "Sound Beans",
        itemId: "Item Id",
        itemName: "Item Name",
        gcComposition: "GC Composition",
        hsnCode: "H S Code",
        netWtRecd: "Net WT RECD",
        actualDebitAmount: "Actual Debit Amount",
        freight: "Freight",
        mandiFee: "Mandi Fee",
        total: "Total",
        igst: "IGST",
        sgst: "SGST",
        cgst: "CGST",
        sticks: "Sticks",
        quality: "Quality",
        debitAmount: "Debit Amount",
        insectedBeans: "Insected Beans",
        mrinCannotBeEmpty: "MRIN cannot be empty",
        entityCannotBeEmpty: "Entity cannot be empty",
        fillMandatoryFields: "Please fill all mandatory fields",
        createSuccess: "Debit note created successfully",
        notificationSent: "Notification Send Successfully",
        auditSuccess: "Audit log successfully created",
        nsFail: "NetSuite record not Created successfully",
        nsSuccess: "NetSuite record Created successfully",
        nsUpdateSuccess: "NetSuite record updated successfully",
        nsUpdateFail: "NetSuite record not updated successfully",
        updateSuccess: "Debit note updated successfully",
        systemInfo: "System Information",
        vendorDetails: "Vendor Details",
        mrinInfo: "MRIN Information",
        mrinDetails: "MRIN Details",
        debitNoteCalc: "Debit Amount Details",
        otherInfo: "Other Information",
        approvalComments: "Approval Comments",
        loading: "Loading ...",
        greenCoffee: "Green Coffee",
        orm: "ORM",
        poSubCategory: "PO sub-category",
        step: "Step",
        quantityTax: "Quantity Tax",
        qualityTax: "Quality Tax",
        accountVerified: "Account verified",
        pendingRequest: "Pending request",
        pendingApproval: "Pending approval",
        approved: "Approved",
        uploadFile: "Upload File",
        fileTypeNotSupported: "Uploaded file type is not supported. Please upload only image, PDF, or Excel files.",
        fileAlreadyExists: "Uploaded file is already exist. Please upload new file.",
        fileDownloaded: "File downloaded successfully",
        debitNoteReleaseCCLAccount: "Debit Note Release CCL Account",
        pleaseFillMandatoryFields: "Please fill mandatory fields",
        atLeastOneDeviationMustBeSelected: "At least one Deviation must be selected.",
        deviationMandatoryFields : "Please fill all mandatory fields for selected deviations.",
        enterAllRequiredTaxPercentages: "Enter all required tax percentages",
        emailDeliverd : "Email Delivered",
        download: "Download",
        netSuiteId: "NetSuite Id",
        netSuiteResponse: "NetSuite Response",
        sentForPendingApproval: "Debit note sent for pending approval",
        sentForApproved: "Debit note sent for approved",
        sentForAccountVerified: "Debit note sent for account verified",
        releaseSuccess: "Debit Note Release request executed successfully.",
        warning: "Warning",
        success: "Success",
        debitNoteReleaseWarning: "Debit Note for this MRIN was already generated and released. Do you want to generate/download the PDF?",
        debitNoteRequestSubmitted: "DebitNoteGc request submitted and email sent successfully",
        selectCreationType: "Select creation type",
        selectDebitNoteType: "Select Debit Note Type",
        quantityDeviation: "Quantity Deviation",
        qualityDeviation: "Quality Deviation",
        totalQtyDevAmount: "Total Quantity Deviation Amount",
        totalQualDevAmount: "Total Quality Deviation Amount",
        deviationAmount: "Deviation Amount",
        tax: "Tax",
        taxPercent: "Tax (%)",
        taxMessage:"You can select up to 2 taxes only.",
        totalQtyDeviationAmt: "Total Quantity Deviation Amount",
        totalDebitAmount: "Total Debit Amount",
        totalDebitAmountFormula: "Total Debit Amount = Total Quantity Deviation Amount + Total Quality Deviation Amount",
        debitAmountInfo: "Debit Amount Information",
        mrinNumber: "MRIN Number",
        requestApproval: "Request Approval",
        approve: "Approve",
        approvalComments: "Approval Comments",
        verifyAccount: "Verify Account",
        qtyDeviationAmountFormula: "Quantity Deviation Amount + (Quantity Deviation Amount × Tax %)",
        qualDeviationAmountFormula: "Quality Deviation Amount + (Quality Deviation Amount × Tax %)",
        ormQtyDeviationAmountFormula: "(Quantity Amount + Freight + Mandi Fee) + ((Quantity Amount + Freight + Mandi Fee) * Tax%)",
        ormQualDeviationAmountFormula: "(Quality Amount + Freight + Mandi Fee) + ((Quality Amount + Freight + Mandi Fee) * Tax%)",
        quantityDeviationAmountLabel: "Quantity Deviation Amount",
        qualityDeviationAmountLabel: "Quality Deviation Amount",
        qualityTooltip: "Quality (%) = Husk (%) + Moisture (%) + Sticks (%) + Sound Bean (%) + Stone (%) + Insected Beans (%)",
        pendingRequestStep: "Pending Request",
        pendingApprovalStep: "Pending Approval",
        accountVerifiedStep: "Account Verified",
        // audit config labels
        quantityDeviationEnabled: "Quantity Deviation",
        qualityDeviationEnabled: "Quality Deviation",
        quantityTaxLabel: "Quantity Tax",
        qualityTaxLabel: "Quality Tax",
        quantityTax1Percent: "Quantity Tax 1 (%)",
        quantityTax2Percent: "Quantity Tax 2 (%)",
        qualityTax1Percent: "Quality Tax 1 (%)",
        qualityTax2Percent: "Quality Tax 2 (%)",
        totalQuantityDeviation: "Total Quantity Deviation",
        totalQualityDeviation: "Total Quality Deviation",
      },
      grid: {
        debit_note_number: "Debit Note Number",
        debit_note_date: "Debit Note Date",
        status_name: "Status",
        item_name: "Item Name",
        supplier_name:"Supplier",
        mrin_no:"MRIN Number",
        delivered_quantity: "Delivered Quantity",
        debit_amount: "Debit Amount",
        email_delivered: "Email status",
      },
      exportColumns: {
        debit_note_number: "Debit Note Number",
        entity_name: "Entity",
        po_category: "Category",
        debit_note_date: "Debit Note Date",
        status_name: "Status",
        item_name: "Item Name",
        item_type: "Item Type",
        supplier_name: "Supplier",
        mrin_no: "MRIN Number",
        delivered_quantity: "Delivered Quantity",
        debit_amount: "Debit Amount",
        email_delivered: "Email Status",
      },
      view: {
        debitNoteGcId: "Debit Note GC id",
        debitNoteGcNumber: "Debit Note GC Number",
        companyName: "Company Name",
        vendorName: "Vendor Name",
        mrinId: "MRIN id",
        husk: "Husk (%)",
        moisture: "Moisture (%)",
        soundBeans: "Sound Beans (%)",
        stones: "Stones (%)",
        itemId: "Item Id",
        insected_beans: "Insected Beans (%)",
        sticks: "Sticks (%)",
        supplierName: "Supplier Name",
        deitNoteDetails: {
          debit_note_no: "Debit Note Number",
          debit_note_date: "Debit Note Date",
          coffee_type: "Item Type",
          entity_name: "Entity",
          netsuite_id: "NetSuite Id",
          netsuite_response: "NetSuite Response",
        },
        mrinDetails: {
          mrin_no: "MRIN Number",
          coffee_type: "Item Type",
          item_name: "Item Name",
          vendor_name: "Supplier Name",
          invoice_no: "Invoice Number",
          hsn_code: "HSN Code",
          delivered_quantity: "Delivered Quantity",
          invoice_quantity: "Invoice Quantity",
          wayment_shortage: "Shortage Quantity",
          po_sub_cat: "PO sub-category",
          quality: "Quality",
        },
        entityListDetails:{
          All: "All",
          eouDuggirla: "EOU Duggirala",
          eouExtension: "EOU Extension",
          sez: "SEZ",
          cclFb: "CCL F&B",
          vietnam: "Vietnam",
        },
        itemTypesDetails: {
          all: "All",
          gc:"GC",
          orm:"ORM",
          rc:"RC",
        },
        categoryDetails:{
          all: "All",
          import: "Import",
          domestic: "Domestic",
        }
      },
      pdfs: {
        debitNote: "DEBIT NOTE",
        to: "TO,",
        debitNoteNo: "DEBIT NOTE NO",
        date: "Date",
        contractNo: "Contract No.",
        dearSir: "Dear Sir (s),",
        noteAccountDebited: "Please note that your account has been debited with a sum of ",
        towardsQualityProblems: "towards Quantity/Quality problems:",
        invoiceNo: "INVOICE NO",
        invoiceDate: "INVOICE DATE",
        poNo: "PO NO",
        poDate: "PO DATE",
        mrinNo: "MRIN NO",
        mrinDt: "MRIN DT",
        grade: "GRADE",
        hsCode: "HSN CODE",
        debitAmount: "DEBIT AMOUNT",
        total: "TOTAL",
        authorisedSignatory: "Authorised Signatory",
        electronicallyApproved: "THIS IS ELECTRONICALLY APPROVED. SIGNATURE NOT REQUIRED",
        formerly: "(Formerly - CONTINENTAL COFFEE LTD.)",
        only: "Only)",
        for: "for",
        vehicleNo: "VEHICLE NO",
        itemDesc: "ITEM DESC",
        uom: "UOM",
        sticks: "STICKS",
        invoiceQty: "INVOICE QTY",
        deliverdQty: "DELIVERED QTY",
        netRecd: "NET RECD",
        husk: "HUSK",
        stones: "STONES",
        moisture: "MOISTURE",
        quality: "QUALITY",
        insectedBeans: "INSECTED BEANS",
        remarks: "Remarks : ",
        towardsWeightOrQualityProblems: "towards weight or Quantity/Quality problems:",
        item: "ITEM",
        debitAmountInr: "DEBIT AMOUNT (₹)",
        panNoLabel: "PAN No :",
        panNo: "PAN No : AAACC9552G",
        cinNo: "CIN No : L15110AP1961PLC000874",
        forCompanyBeverages: "CCL FOOD AND BEVERAGES PRIVATE LIMITED.",
        forCompanyName: "CCL PRODUCTS (INDIA) LTD.",
        notAvailable: "Not Available",
        rs: "Rs.",
        rupeesInWords: "(Rupees",
      },
      statusBars:{
        pendingRequest: "Pending Request",
        pendingApproval: "Pending Approval",
        accountsVerified: "Accounts Verified",
        PendingAccountsVerification: "Pending Accounts Verification",
      },
    },
    mrin: {
      financeInfo: "Finance Information",
      mrinLogisticCost: 'Mrin Logistic Costs',
      deliveredError: "Delivered quantity should not be greater than Expected quantity.",
      deliveredError1: "Delivered quantity should not be greater than Invoice quantity.",
      weighmentError: "Weighment shortage cannot exceed balance quantity",
      invoiceError: "Invoice quantity should not be greater than Expected quantity.",
      mrinCreated: "MRIN created successfully",
      new: "New",
      inProgress: "Weighment In Progress",
      pendingWithQCApproval: "Pending with QC Approval",
      pendingWithFinance: "Pending with Finance",
      qualityRejected: "Quality Rejected",
      pendingWithQuality: "Pending with Quality",
      closed: "Closed",
      rejected: "Rejected",
      mrinSubmittedToQcBy: " MRIN Submitted to QC by ",
      mrinApprovedByQc: " MRIN Approved by QC",
      systemIntegration : "System Integration",
      forms: {
        mrin: "MRIN",
        createMrin: "Create MRIN",
        paid: "Paid",
        allMrin: "All MRIN",
        mrinNo: "MRIN No",
        mrinDate: "MRIN Date",
        deliveryAt: "Delivery At",
        poNo: "PO Number",
        poDate: "PO Date",
        mrinQty: "MRIN Quantity(kgs)",
        vendorType: "Vendor Type",
        vendor: "Vendor",
        itemDesc: "Item Description",
        invoiceNo: "Invoice No",
        invoiceDate: "Invoice Date",
        invoiceStatus: "Invoice Status",
        creditNoteNumber: "Credit Note Number",
        creditNoteAmount: "Credit Note Amount",
        deviation: "Deviation",
        deviationParametersWeight: "Deviation Parameters Weight",
        deviationParametersQuality: "Deviation Parameters Quality",
        dueDate: "Due Date",
        status: "Status",
        mrinValue: "MRIN Value",
        mrinINR: "MRIN Value(INR)",
        attachment: "Attachment",
        companyName: "Company Name",
        netSuiteId: "NetSuite Id",
        netSuiteResponse: "NetSuite Response",
        grossMRIN: "Gross MRIN Value",
        billConversionRate: "Bill of entry conversion rate",
        billEntryDate: "Bill of Entry Date",
        apStatus: "AP Status",
        apDetails: "AP Details",
        qcStatus: "QC Status",
        invoiceFile: "Invoice PDF",
        invalidFileType: "Invalid file type. Only PDF files are accepted.",
        previewAttachment: "Preview Attachment",
        debitNoteNo: "Debit Note Number",
        expectedQty: "Expected Quantity(Kgs)",
        vehicleNo: "Vehicle Number",
        invoiceQty: "Invoice Quantity(Kgs)",
        deliveryDate: "Delivery Date",
        weighmentShortage: "Weighment Shortage",
        wayBillNo: "Way Bill Number",
        hsnCode: "HSN Code",
        purchasePrice: "Purchase Price",
        transactionNo: "Transaction Number",
        securityInwardNo: "Security Inward Number",
        gstAmount: "GST Amount",
        totalTaxAmount: "Total Tax Amount",
        tdsAmount: "TDS Amount",
        tds: "TDS (%)",
        referenceBillNo: "Reference Bill Number",
        billCategory: "Bill Category",
        basicAmount: "Basic Amount",
        grossAmount: "Gross Amount",
        netPayable: "Net Payable",
        parentDispatch: "Parent dispatch",
        purchasePriceMT: "Purchase Price/MT",
        purchasePriceKG: "Purchase Price/KG",
        selectPoDetails: "Select PO details",
        poCategory: "PO category",
        poID: "PO ID",
        dispatchNumber: "Dispatch Number",
        invoiceNumber: "Invoice Number",
        poSubCategory: "PO Sub Category",
        greenCoffeeType: "Green Coffee Type",
        wayBillDate: "Way Bill Date",
        locations: "Locations",
        location: "Location",
        isWeighmentShortage: "Is Weighment shortage",
        deliveredQty: "Delivered Quantity(Kgs)",
        balanceQty: "Balance Quantity(Kgs)",
        vehicleBlNo: "Vehicle/BL number",
        invoiceAmount: "Invoice Amount",
        mrinSubmitted: "MRIN submitted to QC successfully",
        mrinPaid: "MRIN Paid successfully",
        mrinClosed: "MRIN closed successfully",
        mrinApproved: "MRIN Approved successfully",
        approveBoth: "Are you sure you want to Approve/Reject the received material and its specifications?",
        approveBothNew: "Are you sure you want to approve both?",
        addTaxInfo: "Add Tax Information",
        taxPercent: "Tax(%)",
        invoiceAmountError: "Cannot enter Invoice Amount more than PO Total Amount.",
        taxes: "Taxes",
        tax: "Tax",
        taxValue: "Tax Value(%)",
        taxDetails: "Tax Details",
        totalPrice: "Total Price",
        weighmentConfirmation: "Weighment confirmation",
        qualityConfirmation : "Quality Confirmation",
        closureConfirmationHeader: "MRIN Closure Confirmation",
        closureConfirmationBody: "You are about to close this MRIN. Once closed, it cannot be modified or reopened. Please confirm if you would like to proceed with the closure.",
        closeMrin: "Close MRIN",
        fineWeighmentShortage: "Are You Ok With Weighment Shortage?",
        notFine: "NO :- shortage quantity will be added to the pending quantity.",
        yesFine1: "YES :- shortage quantity will ",
        yesFine2: " be added to the pending quantity. ",
        weighmentYesCardText1: "Shortage quantity will",
        weighmentNotText: "NOT",
        weighmentYesCardText2: "be added to the pending quantity.",
        weighmentNoCardText1: "Shortage quantity",
        weighmentWillBeAdded: "will be added",
        weighmentNoCardText2: "to the pending quantity.",
        weighmentYesConfirm: "Yes, confirm",
        weighmentNoConfirm: "No, add to pending",
        validation: "Validation",
        mrinUpdated: "MRIN updated successfully",
        mrinGCUpdated: "MRIN GC specification updated successfully",
        mrinDocument: "MRIN Document uploaded successfully",
        createdWOWayment: "Wayment shortage is ignored, MRIN created successfully",
        createdWithWayment: "MRIN create successfully. A new dispatch created with wayment shortage & balance quanotity",
        netsuiteIdMissingWarning: "NetSuite integration is in progress. Editing is temporarily disabled. Please refresh the page and try again in a few moments.",
        submitToQCWarning: "Please upload the invoice attachment and select a location before submitting to Quality.",
        weighmentInProgressWarning: "Weighment is in progress. Please wait until the weighment process is completed for all vehicles.",
      },
      view: {
        item: "Item",
        expected: "Expected",
        dispatched: "Dispatched",
        delivered: "Delivered",
        difference: "Difference",
        sampleRequestSubmitted: "Sample Request Submitted and email sent successfully",
        tax: "Tax",
        taxValue: "Tax Value(%)",
        totalPrice: "Total Price",
        tds: "TDS (%)",
        submitToQC: "Submit to Quality",
        gcSpec: {
          density: "Density(Gm/Cc)",
          moisture: "Moisture (%)",
          soundbeans: "Sound Beans (%)",
          browns: "Browns (%)",
          blacks: "Blacks (%)",
          brokenbits: "Broken & Bits (%)",
          insectedbeans: "Insected beans (%)",
          bleached: "Bleached (%)",
          husk: "Husk (%)",
          sticks: "Sticks (%)",
          stones: "Stones (%)",
          mouldy_beans: "Mouldy Beans (%)",
          beansretained: "Beans retained on 5mm mesh during sieve analysis",
        },
        dispatchId: "Dispatch Id",
        quantity: "Quantity",
        dispatchDate: "Dispatch Date",
        balanceQty: "Balance Quantity",
        parentDispatch: "Parent Dispatch",
        mrinAlreadyCreated: "MRIN Already Created",
        dispatchDetails: "Dispatch Detail",
        gcTableColumns: {
          composition_name: "Item",
          expected_spec: "Expected",
          dispatched_spec: "Dispatched",
          delivered_spec: "Delivered",
          difference: "Difference",
        },
        taxTableColumns: {
          tax_name: "Tax",
          tax_perc: "Tax Value(%)",
          total_rate: "Total Price",
        },
        dispatchColumns: {
          dispatch_id: "Dispatch Id",
          quantity: "Quantity (Kgs)",
          dispatch_date: "Dispatch Date",
          balance_quantity: "Balance Quantity",
          relateddispatch_id: "Parent Dispatch",
          action: "",
        },
        date: "Date",
        delivered: "Delivered",
        balance: "Balance",
        supplier: "Supplier",
        supplierEmail: "Supplier Email",
        supplierId: "Supplier Id",
        supplierAddress: "Supplier Address",
        taxAndDuties: "Taxes & Duties",
        packaging: "Packaging & Forwarding",
        modeOfTransport: "Mode of transport",
        transitInsurance: "Transit Insurance",
        currency: "Currency",
        daysRequired: "No of days IOM can  be generated from date of invoice",
        advanceType: "Advance type",
        advance: "Advance",
        incoterm: "Incoterm",
        forwarding: "Forwarding",
        paymentTerms: "Payment terms",
        origin: "Origin",
        insurance: "Insurance",
        comments: "Comments",
        portOfLoading: "Port of loading",
        destinationPort: "Destination Port",
        noOfContainers: "No of containers",
        billingAt: "Billing at",
        billingAddress: "Billing address",
        deliveryAt: "Delivery at",
        deliveryAddress: "Delivery address",
        gcType: "Green coffee type",
        quotationNo: "Quotation no",
        quotationDate: "Quotation date",
        price: "Price",
        sez: "SEZ", 
        eouDuggirala: "EOU Duggirala",
      },
      sections: {
        mrinInfo: "MRIN Information",
        dispatchInfo: "Dispatch Information",
        purchaseInfo: "Purchase Order Information",
        taxDetails: "Tax Details",
        logisticInfo: "Logistic Cost Information",
        creditInfo: "Credit Note Information",
        debitInfo: "Debit Note Information",
        qualityInfo: "Quality Information",
        taxInfo: "Tax Information",
        otherInfo: "Other Information",
        otherSpecInfo: "GC Composition Information",
        invoiceInfo: "Invoice Information",
        financeInfo: "Finance Information",
      },
      grid: {
        mrin_no: 'MRIN No',
        mrin_date: 'MRIN Date',
        po_no: 'PO No',
        item_name: 'Item Name',
        delivered_quantity: 'Delivered Quantity(kgs)',
        supplier_name: 'Supplier',
        invoice_no: 'Invoice No',
        invoice_date: 'Invoice Date',
        status: 'Status',
        due_date: 'Due Date',
      },
      export_extra_fields: {
        entity_name: 'Entity',
        category: 'Category',
        item_type: 'Item Type',
      },
      mrinEditDetailsStrings: {
        mrindate: "MRIN Date",
        invoiceno: "Invoice Number",
        invoice_date: "Invoice Date",
        invoice_quantity: "Invoice Quantity",
        delivery_date: "Delivery Date",
        vehicle_no: "Vehicle Number",
        delivered_quantity: "Delivered Quantity",
        balance_quantity: "Balance Quantity",
        wayment_shortage: "Weighment Shortage",
        way_bill_number: "Way Bill Number",
        way_bill_date: "Way Bill Date",
        location: "Location",
        doc_name: "Invoice Document",
      },
      dispatchView: {
        dispatch_id: "Dispatch Number",
        po_no: "Purchase Order Number",
        related_detid: "Parent Dispatch",
        po_category: "Purchase Order Category",
        po_sub_category: "Purchase Order Sub Category",
        vendor_name: "Vendor Name",
        item_name: "Item Name",
        purchase_price: "Purchase Price",
        expected_quantity: "Expected Quantity (kgs)",
        conversationratio: "Bill of Entry Conversion Rate",
      },
      mrinDetailsStrings: {
        mrinno: "MRIN Number",
        mrindate: "MRIN Date",
        coffee_grade: "Item Description",
        hsncode: "HSN Code",
        status: "Status",
        file_name: "Invoice Document",
        netsuiteid: "NetSuite Id",
        netsuite_response: "NetSuite Response",
      },
      dispatchInfoStrings: {
        detid: "Dispatch Number",
        related_detid: "Parent Dispatch Number",
        expected_quantity: "Expected Quantity(Kgs)",
        silo_name: "Location",
        conversationratio: "Bill of Entry Conversion Rate",
        invoiceno: "Invoice Number",
        invoice_date: "Invoice Date",
        invoice_quantity: "Invoice Quantity(Kgs)",
        way_bill_number: "Way Bill Number",
        way_bill_date: "Way Bill Date",
        delivered_quantity: "Delivered Quantity(Kgs)",
        delivery_date: "Delivery Date",
        wayment_shortage: "Weighment Shortage",
        wayment_shortage_flag: "Is Weighment Shortage",
        balance_quantity: "Balance Quantity",
        net_mrinvalue: "MRIN Value",
        mrinvalue_inr: "MRIN Value (INR)",
        gross_mrinvalue: "Gross MRIN Value",
        vehicle_no: "Vehicle Number",
      },
      purchaseInfoStrings: {
        po_no: "Purchase Order Number",
        po_category: "Purchase Order Category",
        po_sub_category: "Purchase Order Sub Category",
        vendorname: "Supplier Name",
        purchase_price: "Purchase Price",
      },
      importConversionStrings: {
        po_no: "Purchase Order Number",
        vendorname: "Vendor Name",
        debit_noteno: "Debit Note Number",
        purchase_price: "Purchase Price",
        po_category: "PO Category",
        po_sub_category: "PO Sub Category",
        poid: "PO ID",
        related_detid: "Parent Dispatch",
        detid: "Dispatch Number",
        balance_quantity: "Balance Quantity(Kgs)",
        silo_name: "Location",
        conversationratio: "Bill of Entry Conversion Rate",
      },
      importGrossStrings: {
        mrinvalue_inr: "MRIN Value(INR)",
        gross_mrinvalue: "Gross MRIN Value",
      },
      nonImportGrossStrings: {
        gross_mrinvalue: "Gross MRIN Value",
      },
      creditInfoStrings: {
        credit_note_number: "Credit Note Number",
        credit_note_amount: "Credit Note Amount",
        deviation: "Deviation",
        deviation_parameters_weight: "Deviation Parameters Weight",
        deviation_parameters_quality: "Deviation Parameters Quality",
      },
      debitInfoStrings: {
        debit_noteno: "Debit Note Number",
        debit_amount: "Debit Amount",
      },
      taxSummaryStrings: {
        tax_tds: "TDS (%)",
      },
      financeInfoStrings: {
        apStatus: "AP Status",
        apDetails: "AP Details",
        invoiceAmount: "Invoice Amount",
        basicAmount: "Basic Amount",
        gstAmount: "GST Amount",
        tdsAmount: "TDS Amount",
        totalTaxAmount: "Total Tax Amount",
        netPayable: "Net Payable",
        grossAmount: "Gross Amount",
        transactionNo: "Transaction Number",
        referenceBillNo: "Reference Bill Number",
        billCategory: "Bill Category",
        securityInwardNo: "Security Inward Number",
      },
      pdf: {
        importPdf: {
          cclFnBName: "CCL FOOD AND BEVERAGES PRIVATE LIMITED",
          cclName: "CCL PRODUCTS (INDIA) LIMITED",
          cin: "CIN : L15110AP1961PLC000874",
          refNo: "QFR/PUR/001",
          contractTitle: "CONTRACT",
          sellerExporterTitle: "SELLER / EXPORTER",
          productSection: "PRODUCT: GREEN COFFEE BEANS",
          shipmentSection: "SHIPMENT",
          documentsRequired: "DOCUMENTS REQUIRED:",
          buyer: "BUYER",
          buyerName: "CCL PRODUCTS(INDIA) LIMITED",
          seller: "SELLER",
          datePrefix: "DT.",
          otherTermsPrefix: "shipment in",
          bagsSuffix: "bags",
          sellerLabels: {
            name: "NAME",
            address: "ADDRESS",
            phone: "PHONE",
            mobile: "MOBILE",
            email: "EMAIL",
          },
          contractLabels: {
            contractNo: "CONTRACT NO",
            contractDate: "CONTRACT DATE",
            incoterms: "INCOTERMS",
            forwarding: "FORWARDING",
            portOfLoading: "PORT OF LOADING",
            destination: "DESTINATION",
            insurance: "INSURANCE",
          },
          conditionLabels: {
            paymentTerms: "PAYMENT TERMS",
            comments: "COMMENTS",
            otherTerms: "OTHER TERMS",
          },
          reportTableHeaders: {
            itemDescription: "ITEM DESCRIPTION",
            bagsNos: "BAGS / NOS",
            bagsWtKgs: "BAGS WT KGS",
            contractQtyMt: "CONTRACT QTY / MT",
            rateMtUsd: "RATE / MT USD",
            amountUsd: "AMOUNT USD",
          },
          coffeeTableHeaders: {
            contractNo: "CONTRACT NO",
            origin: "ORIGIN",
            noOfContainer: "NO OF CONTAINER",
            shipment: "SHIPMENT",
          },
        },
        mrinPdf: {
          refNo: "QFR/STR/001",
          mrinTitle: "MATERIAL RECEIPT & INSPECTION NOTE (MRIN)",
          greenCoffeeMaterial: "GREEN COFFEE MATERIAL",
          electronicApproval: "THIS IS ELECTRONICALLY APPROVED. SIGNATURE NOT REQUIRED",
          mrinNoLabel: "MRIN NO",
          mrinDateLabel: "MRIN DATE",
          unitKg: "KGs",
          subTotal: "SUB TOTAL",
          otherChargesInr: "Other Charges(INR)",
          excludingHamali: "(Excluding Hamali)",
          otherChargesUsd: "Other Charges(USD)",
          taxes: "TAXES",
          total: "TOTAL",
          amountInWordsUsdPrefix: "(USD ",
          amountInWordsInrPrefix: "(Indian Rupees ",
          amountInWordsSuffix: "Only) ",
          partySection: {
            vendorname: "PARTY",
            gstIn: "GST NO.",
            invoiceno: "INVOICE NO.",
            invoice_date: "INVOICE DATE",
            billofentrynumber: "BILL OF ENTRY NO.",
            billofentrydate: "BILL OF ENTRY DATE",
            vehicle_no: "VEHICLES",
          },
          poSection: {
            po_no: "PO NO.",
            podate: "PO DATE",
            duedate: "PAYMENT DATE",
            payment_terms: "PAYMENT TERMS",
          },
          preparedSection: {
            createduser: "PREPARED BY",
            createddate: "PREPARED DATE",
          },
          approvedSection: {
            approvedBy: "APPROVED BY",
            approvedDate: "APPROVED DATE",
          },
          tableHeaders: {
            sno: "SNO",
            itemCode: "ITEM CODE",
            hsncode: "HSNCODE",
            description: "DESCRIPTION",
            unit: "UNIT",
            qty: "QTY",
            location: "LOCATION",
            rate: "Rate",
            rateImportPrefix: "Rate (",
            rateImportSuffix: "/KG)",
            amount: "AMOUNT",
          },
        },
        mrinPdf2: {
          mrinTitle: "MATERIAL RECEIPT & INSPECTION NOTE (MRIN)",
          orderSpecTitle: "Order specification information",
          electronicApproval: "THIS IS ELECTRONICALLY APPROVED. SIGNATURE NOT REQUIRED",
          formerlyText: "(Formerly - CCL PRODUCTS (INDIA) LIMITED.) Duggirala Mandal, Guntur District – 522 330",
          nclFormerlyText: "(Ngon Coffee Company Limited Cu Kuin Industrial Complex, Dray Bhang Commune Dak Lak Province, Vietnam)",
          stateLine: "Andhra Pradesh, India.",
          cclCorporateOffice: 'Corporate Office: 7-1-24/2/D. "GreenDale" Ameerpet, Hyderabad, Telangana - 500 016 Tel : (040) 23730855.',
          nclOffice: '"Ngon Coffee Company Limited Cu Kuin Industrial Complex, Dray Bhang Commune Dak Lak Province, Vietnam"',
          panNo: "PAN No: AAACC9552G",
          cinNo: "CIN No: L15110AP1961PLC000874",
          infoLeftSection: {
            mrinno: "MRIN No.",
            purchase_price: "Purchase Price.",
            vendorname: "Supplier Name.",
            delivery_date: "Delivery Date.",
            contract_number: "Contract No.",
          },
          infoRightSection: {
            po_no: "PO NO.",
            mrindate: "MRIN Date.",
            delivered_quantity: "Delivered Qty.",
            coffee_grade: "Item Description.",
            invoiceno: "Invoice Number.",
          },
          tableHeaders: {
            item: "Item",
            expected: "Expected",
            dispatched: "Dispatched",
            delivered: "Delivered",
            difference: "Difference",
          },
        },
      },
    },
    allocation: {
      forms: {
        balanceQty: "Balance Quantity for this PO is ",
        allocationValid: "Please enter allocated Quantity",
        gcAllocation: "GC Allocations",
        allAllocations: "All Allocations",
        quotesForAllocation: "Quote for allocation",
        allocatedQtyError: "Allocated quantity must be greater than zero",
        gcPrice: "Gc Price",
        balanceQty: "Balance Qty",
        gc: "GC",
        orm: "ORM",
        displayInPO: "Display this item in purchase order",
        displayInGC: "Display this green coffee rates in daily update",
        item_type: "Item Type",
        isSpecial: "Is special coffee",
        density: "Density(Gm/cc)",
        moisture: "Moisture(%)",
        sound_beans: "Sound Beans(%)",
        browns: "Browns(%)",
        blacks: "Blacks(%)",
        broken_bits: "Broken & bites(%)",
        insected_beans: "Insected beans(%)",
        bleached: "Bleached(%)",
        husk: "Husk(%)",
        sticks: "Sticks(%)",
        stones: "Stones(%)",
        beans_retained: "Beans retained on 5mm mesh during sieve analysis",
        itemNameExist: "Item Name is already exist",
        itemCodeExist: "Item Code is already exist",
        gcCreated: "GC Information Created Successfully",
        allocationCreated: "Allocation created successfully",
        confirmation: "Confirmation",
        modalBody1: "For this PO, PO Quantity and allocation Quantity is not match.",
        modalBody2: "Do you want to allocate remaining Quantity to another quote?",
        selectQuote: "Select Quote for Allocation",
        balanceQnty: "Balance Quantity",
        reload: "Reload",
        add: "Add",
        reloadMsg: "Reload for updated Balanced Quantity"
      },
      sections: {
        gcInfo: "Green Coffee Information",
        allocationDetails: "Allocation Details",
        allocationInfo: "Allocation Information",
        categoriesUOM: "Categories & UOM",
        displayInfo: "Display & Type information",
        specificationInfo: "Specification information",
      },
      view: {
        fileName: "File Name",
        uri: "URI",
        createdBy: "Created By",
        createdDate: "Created Date",
        allocationRecordNo: "Allocation Record No",
        allocatedQty: "Allocated Qty",
        accountName: "Account Name",
        itemName: "Item Name",
        purchaseOrderNo: "Purchase Order No",
        quoteNo: "Quote No",
        poQuantity: "PO Quantity",
        group: "Group",
        poStatus: "PO Status",
        quoteLineNumber: "Quote Line Number",
        fromDate: "From Date",
        gcPrice: "GC Price",
        toDate: "To Date",
        allocationDate: "Allocation Date",
        quotationNo: "Quotation No",
        quotationLineNo: "Quotation Line No",
        itemQuantity: "Item Quantity (KGs)",
        balanceQuantity: "Balance Quantity (KGs)",
        allocatedQuantity: "Allocated Quantity",
      },
      grid: {
        record_id: "Allocation Record No",
        account_name: "Account Name",
        quote_number: "Quote Number",
        quote_line_number: "Quote Line Number",
        pono: "PO Number",
        item_name: "Item Name",
        allocated_quantity: "Allocated Qty",
      }
    },
    supplier: {
      grid: {
        vendor_name: "Name",
        contact_name: "Contact Person",
        is_active: "Active",
        phone: "Phone",
        city: "City",
        state: "State",
        country: "Country",
        group_name: "Group",
        attachments_count: "Attachment",
      },
      forms: {
        SelectProviderType: "Select Provider Type",
        ProviderType: "Provider Type",
        status: "Status",
        notAvailable: "Not Available",
        typeNSupplierGroup: "Type and Supplier group",
        customerDetails: "Service Provider Information",
        supplierDetails: "Supplier Information",
        serviceDetails: "Service Provider Details",
        hamaliInfo: "Hamali Information",
        contactDetails: "Contact Information",
        identificationNumberDetails: "Identification Numbers",
        bankDetails: "Bank Details",
        intermediaryBankDetails: "Intermediary Bank Details",
        createSupplier: "Create",
        Supplier: "Supplier",
        Create: "Record created successfully",
        Update: "Record updated successfully",
        SupplierInfo: "Supplier Information",
        SupplierDetails: "Supplier Details",
        serviceProvider: "Service Provider",
        quantityStatistics: "Quantity Statistics",
        po: "PO Information",
        mrin: "MRIN Information",
        poinfo: "poInfo",
        mrininfo: "mrinInfo",
        duplicateVendorexists: "Vendor with the name is already exits Please use a different name.",
        duplicateGSTexists: "Vendor with this GST number is already registered.",
        service_provider_name: "Service Provider Name",
        panValidation: "Please enter valid PAN number",
        supplierName: "Supplier Name",
        supplierType: "Supplier Type",
        contactName: "Contact Name",
        address1: "Address 1",
        address2: "Address 2",
        country: "Country",
        state: "State",
        city: "City",
        pincode: "Pincode",
        phone: "Phone (Optional)",
        Phone: "Phone",
        mobile: "Mobile",
        website: "Website",
        email: "Email",
        registrationType: "Registration Type",
        panAvailability: "Pan Availability",
        panNo: "PAN No",
        panNumber: "PAN Number",
        gstIdentificationNo: "GST Identification No",
        gstIdentificationNumber: "GST Identification Number",
        cinNumber: "CIN Number",
        tanNumber: "TAN Number",
        msme: "MSME/SSI",
        cinNo: "CIN No",
        tanNo: "TAN No",
        tds: "TDS(%)",
        taxCode : "Tax Code",
        intermediaryBankDetailsBtn: "Intermediary Bank Details",
        bankName: "Bank name",
        branch: "Branch",
        accountType: "Account Type",
        accountNumber: "Account Number",
        ifscCode: "IFSC Code",
        micrCode: "MICR Code",
        swiftCode: "SWIFT Code",
        ifscIBAN: "IFSC/IBAN Code",
        micrSwiftCode: "MICR/SWIFT Code",
        beneficiaryName: "Beneficiary Name",
        ifscIbanCode: "IFSC code / IBAN Code",
        serviceProviderType: "Service Provider Type",
        serviceProviderCategory: "Service Provider Category",
        serviceProviderGroup: "Service Provider Group",
        is_active: "Is Active",
        isActiveGC: "Is Active GC",
        isActiveORM: "Is Active ORM",
        supplierCategory: "Supplier Category",
        supplierGroup: "Supplier Group",
        supplierClassification: "Supplier Classification",
        certificateNumber: "Certificate Number",
        certificateIssueDate: "Certificate Issue Date",
        certificateValidity: "Certificate Validity",
      },
      grid: {
        vendor_name: "Vendor Name",
        contact_name: "Contact Name",
        is_active: "Is Active",
        city: "City",
        state: "State",
        country: "Country",
        phone: "Phone",
        group_name: "Group Name",
        pan_no: "PAN Number",
        gst_no: "GST Number",
        service_provider_group: "Service Provider Group",
        provider_type: "Provider Type"
      },
      view: {
        provider_type: "Provider Type",
        netsuite_id: "NetSuite Id",
        netsuite_response: "NetSuite Response",
        is_active: "Is Active",
        gc: "GC",
        rc: "RC",
        orm: "ORM",
        totalQuantity: "Total Quantity",
        totalReceivedQuantity: "Total Received Quantity",
        totalPendingQuantity: "Total Pending Quantity",
        averageItemPrice: "Average Item Price",
        poNumber: "Purchase Order Number",
        poStatus: "Po Status",
        itemName: "Item Name",
        poQuantity: "PO Quantity",
        poPendingQuantity: "PO Pending Quantity",
        purchasePrice: "Price",
        mrinNumber: "MRIN Number",
        invoiceNumber: "Invoice Number",
        mrinQuantity: "MRIN Quantity"
      },
      mrinGrid: {
        mrin_no: "MRIN Number",
        po_no: "Purchase order Number",
        invoice_no: "Invoice Number",
        item_name: "Item Name",
        mrin_quantity: "MRIN quantity",
        logistic_category: "Logistic Category",
        grand_total: "Grand Total"
      },
      poGrid: {
        po_no: "PO Number",
        po_status: "PO Status",
        total_quantity: "PO Quantity",
        item_name: "Item Name",
        dispatch_id: "Dispatch Record",
        logistic_category: "Logistic Category",
        grand_total: "Grand Total",
      },
      dropdowns: {
        import: "Import",
        domestic: "Domestic",
        available: "Available",
        notAvailable: "Not Available",
        trader: "Trader",
        manufacturerProcessor: "Manufacturer/Processor",
      }
    },
    GC: {
      binDetails: "Bin Details",
      dispenseInformation: "Dispense Information",
      forms: {
        selectItemType: "Select Item Type",
        gc: "GC",
        createGc: "Create GC",
        dutyPaid: "Duty Paid",
        itemCategory: "Item Category",
        itemUOM: "Item UOM",
        itemType: "Item type",
        status: "Status",
        group: "Group",
        orm: "ORM",
        sublocationName: "Sub locations",
        exportExcelMessage: "Export to Excel",
        import: 'Import',
        indigenous: "Indigenous",
        groupBasedInventory: "Group Based Details",
        backToGC: "Back to GC",
        groupExportMsg: "Excel export will include only the records displayed on the screen.",
        is_active: "Is Active",
        greenCoffeeInformation: "Green coffee information",
        categoriesAndUOM: "Categories & UOM",
        displayTypeInformation: "Display & Type information",
        specificationInformation: "Specification information",
        uniqueIdentification: "Unique For Your Identification",
        contactRD: "(R&D Purpose For Sample Creation)Please Contact R&D Department To Enter The Short Code",
        itemContribution: "Please Enter This Item Contribution Percentage For The Powder Production",
        itemGroup: "Item Group",
        itemCode: "Item code",
        itemName: "Item name",
        shortCode: "Short code",
        itemDescription: "Item description",
        conversionRatio: "Conversion ratio",
        itemClassification: "Item classification",
        hsnCode: "HSN code",
        displayGreenCoffeeRates: "Display this green coffee rates in daily update",
        displayItemInPO: "Display this item in purchase order",
        isSpecialCoffee: "Is Special Coffee",
        density: "Density(Gm/cc)",
        moisture: "Moisture(%)",
        soundBeans: "Sound Beans(%)",
        browns: "Browns(%)",
        blacks: "Blacks(%)",
        brokenBits: "Broken & Bites(%)",
        beansRetained: "Beans retained on 5mm mesh during sieve analysis",
        insectedBeans: "Insected Beans (%)",
        bleached: "Bleached(%)",
        husk: "Husk(%)",
        sticks: "Sticks(%)",
        stones: "Stones(%)",
        mouldyBeans: "Mouldy Beans(%)",
        itemNameExist: "Item Name is already exist",
        itemCodeExist: "Item Code is already exist",
        gcCreated: "GC Information Created Successfully",
        gcUpdated: "GC Information Updated Successfully",
        gcCreatedAuditlog: "GC Created",
        greenCoffee: "Green Coffee",
      },
      view: {
        grid: {
          item_code: "Item Code",
          s_code: "Short Code",
          item_name: "Item Name",
          uom: "UOM",
          group_name: "Group Name",
          display_in_po: "Show in PO",
          coffee_type: "Item Type",
          attachments_count: "Attachment",
          itrem_code: "Item Code",
          group: "Group",
          item_group: "Item Group",
          status: "Status Enabled",
          totalPOQty: "Total PO Quantity",
          pendingPOQty: "Pending PO Quantity",
          qtyOnHand: "Quantity on Hand",
          qtyCommitted: "Quantity Committed",
          location: "Location",
          active: "Active",
          inActive: 'Inactive',
          seeLocations: "See Locations",
          vendor: "Vendor",
          contact: "Contact",
          city: "City",
          state: "State",
          country: "Country",
          entity: "Entity",
          name: "Name",
          quantity: "Quantity",
          value: "Value",
          unitPrice: "Unit Price",
        },
        categoryDropdown: {
          import: "Import",
          indigenous: "Indigenous",
          domestic: "Domestic",
        },
        summary: {
          totalQty: "Total Quantity",
          receivedQty: "Total Received Quantity",
          pendingQty: "Total Pending Quantity",
          avgPrice: "Weighted Average Price",
        },
        quantityStatistics: "Quantity Statistics",
        gcInformation: "GC information",
        itemStockLocations: "Item stock locations",
        listVendors: "List of vendors purchased this item",
        gcNo: "GC no",
        netsuiteId: "NetSuite Id",
        netsuiteResponse: "NetSuite Response",
        TypeSampleLineItem: "Type Sample Line Item Details",
        PreShipmentSampleLineItem: "Pre-Shipment Sample Line Item Details",        
        tabs: {
          allocationInformation: "Allocation Information",
          inventoryInformation: "Inventory Information",
          gcEnquiry: "GC Enquiry",
          gcDailyRates: "GC Daily Rates",
          poInformation: "PO Information",
          mrinInformation: "MRIN Information",
          dispenseInformation: "Dispense Information",
          typeSampleInfo: "Type Sample Info",
          preshipmentSampleInfo: "Pre-Shipment Sample Info",
        },
      },
      creatEdit: {
        // Section titles
          itemInformation: "Item Information",
          displayInformation: "Display Information",
          specificationInformation: "Specification Information",
          itemType: {
            // Item Information fields
            coffee_type: "Item Type",
            s_code: "Short Code",
            item_name: "Item Name",
            item_desc: "Item Description",
            hsn_code: "HSN Code",
            uom_name: "Item UOM",
            item_cat_name: "Category",
            item_code: "Item Code",
            group_name: "Item Group",
            gc_group_name: "Sub Group",
            item_classification_name: "Item Classification",
            convertion_ratio: "Conversion Ratio",
            origin: "Origin",
            netsuite_id: "NetSuite Id",
            netsuite_response: "NetSuite Response",
          },
          itemTypeORM: {
            // Item Information fields
            coffee_type: "Item Type",
            s_code: "Short Code",
            item_name: "Item Name",
            item_desc: "Item Description",
            hsn_code: "HSN Code",
            uom_name: "Item UOM",
            item_cat_name: "Category",
            item_code: "Item Code",
            group_name: "Item Group",
            item_classification_name: "Item Classification",
            convertion_ratio: "Conversion Ratio",
            origin: "Origin",
            netsuite_id: "NetSuite Id",
            netsuite_response: "NetSuite Response",
          },
          displayInfo: {
            // Display Information fields
            display_in_po: "Display This Item In Purchase Order",
            daily_price_enable: "Display This Green Coffee Rates In Daily Update",
            duty_paid: "Duty Paid",
            enable_status: "Is Active",
            is_special_coffee: "Is Special Coffee",
          },

          displayInfoORM: {
            // Display Information fields for ORM
            display_in_po: "Display This Item In Purchase Order",
            daily_price_enable: "Display This Green Coffee Rates In Daily Update",
            duty_paid: "Duty Paid",
            enable_status: "Is Active",
          },

          specificationInfo: {
            // Specification Information fields
            density: "Density (Gm/cc)",
            moisture: "Moisture (%)",
            sound_beans: "Sound Beans (%)",
            browns: "Browns (%)",
            blacks: "Blacks (%)",
            broken_bits: "Broken & Bites (%)",
            husk: "Husk (%)",
            bleached: "Bleached (%)",
            sticks: "Sticks (%)",
            stones: "Stones (%)",
            mouldy_beans: "Mouldy Beans (%)",
            insected_beans: "Insected Beans (%)",
            beans_retained: "Beans Retained On 5mm Mesh (%)",
          }
      },
      GCGrid: {
        item_code: "Item Code",
        item_name: "Item Name",
        s_code: "Short Code",
        gc_group_name: "Sub Group",
        item_classification: "Item Classification",
        uom_name: "UOM",
        display_in_po: "Display In PO",
        attachments_count: "Attachment"
      },
      allocationGrid: {
        record_id: "Record Number",
        quote_number: "Quote Number",
        quote_line_number: "Quote Line Number",
        pono: "PO No",
        item_name: "Item Name",
        allocated_quantity: "Allocated Quantity",      
      },
      inventoryGrid: {
        item_name: "Item Name",
        total_po_quantity: "Total PO Quantity",
        in_transit_quantity: "Pending PO Quantity",
        stock_available_quantity: "Received Quantity",
        item_quantity_on_hand: "Quantity On Hand",
        item_quantity_committed: "Quantity Committed",
        item_quantity_back_ordered: "Back Order Quantity",
        allocated_quantity_ccl_quote: "Open Quote Allocated Quantity",
        allocated_quantity_other_quote: "Other Quotes Allocated Quantity",
        average_price: "Average Cost",
        show_locations: "see Locations",
      },
      enquiryGrid: {
        record_id: 'Record ID',
        gc_enquiry_number: 'Enquiry No',
        enquiry_date: 'Enquiry Date',
        vendor_name: 'Vendor',
        vendor_info: 'Vendor Information',
      },
      vendorInfo: {
        item_name: 'Item Name',
        item_category: 'Category',
        item_sub_category: 'Sub Category',
        uom: 'Item UOM',
        offer_price: 'Offer Price',
        final_price: 'Final Price',
        quantity: 'Quantity',
        calender_period_from: 'Period From',
        calender_period_to: 'Period To',
      },
      dailyRatesGrid: {
        record_id: 'Record ID',
        currency_date: 'Price Dates',
        currency_name: 'Currency',
        currency_rate: 'Currency Factor',
        terminal_month_details: 'Terminal Month Details',
      },
      terminalMonthGrid: {
        current_terminal_month: 'Terminal Month',
        current_terminal: 'Terminal',
        current_closing_value: 'Closing Value',
        current_highest_value: 'Highest Value',
        current_lowest_value: 'Lowest Value',
      },
      poGrid: {
        po_no: 'Purchase Order No',
        po_category: 'Category',
        po_sub_category: 'Sub Category',
        vendor_name: 'Vendor Name',
        total_quantity: 'Total Quantity',
        mrin_quantity: 'MRIN Quantity',
        balance_quantity: 'Balance Quantity',
        purchase_price: 'Purchase Price',
        status: 'Status',
      },
      mrinGrid: {
        mrin_no: 'MRIN Number',
        po_no: 'Purchase Order Number',
        invoice_no: 'Invoice Number',
        vendor_name: 'Vendor Name',
        total_quantity: 'PO Quantity',
        delivered_quantity: 'Delivered Quantity',
        balance_quantity: 'Balance Quantity',
      },
      dispenseGrid: {
        item_name: 'Item Name',
        blendsheet_number: 'Blend Sheet Number',
        alternative_sample_code: 'Alternative Sample',
        item_quantity: 'Item Quantity',
        bin_details: 'Bin Details',
        dispense_information: 'Dispense Information',
      },
      gcTypeSampleGrid: {
        record_id: 'Record Number',
        entity_name: 'Entity',
        supplier_name: 'Supplier Name',
        status_name: 'Status',
        requested_for: 'Requested For',
        requested_date: 'Requested Date',
      },
      gcTypeSampleLineGrid: {
        record_id: 'TSLI Number',
        item_name: 'Item Name',
        item_category: 'Item Category',
        shippment_period: 'Shipment Period',
        expected_result_date: 'Expected Result Date',
        rd_analysis_status: 'R&D Approved',
        quality_analysis_status: 'Quality Approved',
      },
      gcPreShipmentGrid: {
        record_id: 'Record Number',
        entity_name: 'Entity',
        purchase_order_number: 'Purchase Order Number',
        supplier_name: 'Supplier Name',
        status_name: 'Status',
        requested_for: 'Requested For',
        requested_date: 'Requested Date',
      },
      gcPreShipmentLineGrid: {
        record_id: 'PSLI Number',
        item_name: 'Item Name',
        item_category: 'Item Category',
        shippment_period: 'Shipment Period',
        expected_result_date: 'Expected Result Date',
        rd_analysis_status: 'R&D Approved',
        quality_analysis_status: 'Quality Approved',
      },
      binHeaderDetails: {
        lot_number: 'Lot Number',
        bin_number: 'Bin Number',
        lot_number_qty: 'Allocated Quantity',
      },
      dispenseHeaderDetails: {
        silo_number: "Bin Number",
        required_quantity: "Quantity Dispensed",
        issue_quantity: "Issued Quantity",
        start_date: "Production Start Date",
        set_quantity: "Set Quantity",
        dam_name: "Damper Name",
        dam_on_time: "Damper On Time",
        dam_off_time: "Damper Off Time",
        completed_date:"Production End Date",
        pending_quantity:"Pending Quantity",
        status: "Status",
      }
    },
    dispatchInfo: {
      forms: {
        createDispatchInfo: "Create Dispatch Info",
        allDispatchInfo: "All Dispatch Info",
        dispatchInfo: "Dispatch Info",
        item: "Item",
        composition: "Composition",
        specification_information: "Specification information",
        expectedOrderSpecificationInformation: "Expected order specification information",
        dispatchSpecificationInformation: "Dispatch specification information",
        dispatchDetails: "Dispatch Details",
        dispatchDate: "Dispatch Date",
        expectedQuantity: "Expected Quantity",
        parentDispatch: "Parent Dispatch",
        dispatchQuantityKGs: "Dispatch Quantity(KGs)",
        vehicleBlNumberDetails: "Vehicle/BL number details",
        invoiceNumber: "Invoice Number",
        invoiceQuantity: "Invoice Quantity",
        itemDescription: "Item Description",
        itemCategory: "Item category",
        uom: "UOM",
        displayGreenCoffeeRates: "Display this green coffee rates in daily update",
        displayItemInPO: "Display this item in purchase order",
        coffeeType: "Item type",
        isSpecialCoffee: "Is special coffee",
        density: "Density(Gm/cc)",
        moisture: "Moisture(%)",
        soundBeans: "Sound Beans(%)",
        browns: "Browns(%)",
        blacks: "Blacks(%)",
        brokenBits: "Broken & Bites(%)",
        beansRetained: "Beans retained on 5mm mesh during sieve analysis",
        insectedBeans: "Insected beans(%)",
        bleached: "Bleached(%)",
        husk: "Husk(%)",
        sticks: "Sticks(%)",
        stones: "Stones(%)",
        mouldy_beans: "Mouldy Beans(%)",
        poDate: "PO date",
        poCategory: "PO category",
        poSubCategory: "PO sub-category",
        itemName: "Item name",
        totalQuantity: "Total quantity",
        supplierName: "Supplier Name",
        companyName: "Company Name",
        entity: "Entity",
        documentInformation: "Document information",
        poNo: "PO no",
        dispatchDetailsAlreadySubmitted: "Dispatch Details already submitted",
        expectedOrderCompositionInformation: "Expected order composition information",
        dispatchCompositionInformation: "Dispatch composition information",
        pdfUploadMessage: "(Please upload PDF files only*)",
        filterOptions: "Filter Options",
        confirmationMessage: "Please check all the details before submitting. Details once submitted cannot be changed/edited",
        purchaseOrderDetails: "Purchase Order Details",
        notificationSent: "Notification Send Successfully",
        dispatchInfoSent: "Dispatch information sent successfully",
        dispatchInfoUpdated: "Dispatch information update successfully",
        groupExportMsg: "Excel export will include only the records displayed on the screen.",
        greenCoffeeInformation: "Green coffee information",
        categoriesAndUOM: "Categories and UOM",
        displayTypeInformation: "Display & Type information",
        specificationInformation: "Specification information",
        itemGroup: "Item group",
        itemCode: "Item code",
        shortCode: "Short code",
        hsnCode: "HSN code",
        itemClassification: "Item classification",
        conversionRatio: "Conversion ratio",
        gcUpdated: "GC updated successfully",
        sectionHeaders: {
          purchaseInfo: "Purchase Order Details",
        },
        PO_Details: {
          pono: "PO Number",
          po_date: "PO Date",
          po_category: "PO Category",
          po_sub_category: "PO Sub Category",
          item_name: "Item Name",
          total_quantity: "Total Quantity",
          supplier_name: "Supplier Name"
        },
        invoiceDate: "Invoice Date",
        wayBillNumber: "Way Bill Number",
        wayBillDate: "Way Bill Date",
        vehicleInformation: "Vehicle Information",
        vehicleInfoMandatory: "(Mandatory to add at least one Vehicle Information*)",
        compositionInformation: "Composition Information",
        specificationCompositionInformation: "Specification Composition Information",
        expectedCompositionInformation: "Expected Composition Information",
        createDispatchConfirmationMessage: "Once submitted, this dispatch record cannot be edited. Please confirm vehicle numbers & quantities, invoice number, composition values, and all documents are correct.",
        createDispatchConfirmationLine1: "Once submitted, this dispatch record cannot be edited.",
        createDispatchConfirmationLine2: "Please verify the following before continuing:",
        createDispatchConfirmationBullets: [
          "Vehicle numbers",
          "Dispatched quantities",
          "Invoice number",
          "Composition values",
          "All supporting documents",
        ],
        createDispatchConfirmationLine3: "Are you sure you want to submit this dispatch?",
        creatingRecord: "Your record is being created. Please wait....",
        composition_info_grid_labels: {
          density: "Density(Gm/cc)",
          moisture: "Moisture(%)",
          soundbeans: "Sound Beans(%)",
          browns: "Browns(%)",
          blacks: "Blacks(%)",
          brokenbits: "Broken & Bites(%)",
          insectedbeans: "Insected beans(%)",
          bleached: "Bleached(%)",
          husk: "Husk(%)",
          sticks: "Sticks(%)",
          stones: "Stones(%)",
          mouldy_beans: "Mouldy Beans(%)",
          beansretained: "Beans retained on 5mm mesh during sieve analysis",
        },
        compositionColumns: {
          composition_name: "Item",
          expected_rate: "Expected Composition",
          spec_rate: "Dispatched Composition",
        },
      },
      view: {
        doc_kind: "Document Name",
        file_name: "File Name",
        required: "Documents Required",
        invoicenumber: "Number",
        invoicedate: "Date",
        conversionratio: "Conversion Rate",
        is_upload: "Upload",
        download: "Download",
        totalQuantityReceivedPct: "Total Quantity Received (%)",
        vehicleMovementSubHeader: "Vehicle Movement & Weighment Details",
        section_headers: {
          purchase_info: "Purchase Information",
          dispatch_info: "Dispatch Information",
          specification_info: "Specification Information",
          expected_order_spec_info: "Expected Order Specification Information",
          dispatch_spection_info: "Dispatch Specification Information",
          document_info: "Document Information",
          dispatch_qty_kgs: "Dispatch Quantity(KGs)",
        },
        purchase_info:{
          po_no: "Purchase Number",
          po_date: "Purchase Date",
          po_category: "Purchase Category",
          po_sub_category: "Purchase Sub Category",
          item_name: "Item Name",
          vendor_name: "Supplier Name",
          total_quantity: "Total Quantity"
        },
        dispatch_info: {
          dispatch_id: "Dispatch Number",
          parent_detid: "Parent Dispatch Number",
          quantity: "Expected Quantity",
          dispatch_date: "Dispatch Date",
          dispatch_quantity: "Dispatched Quantity",
          invoice_no: "Invoice Number",
          invoice_date: "Invoice Date",
          invoice_quantity: "Invoice Quantity",
          way_bill_number: "Way Bill Number",
          way_bill_date: "Way Bill Date",
        },
      },
      grid: {
        dispatch_id: "Dispatch Record No",
        po_no: "PO Number",
        supplier_name: "Supplier Name",
        item_name: "Item Name",
        dispatch_quantity: "Dispatch Quantity",
        invoice_no: "Invoice Number",
        dispatch_status: "Status",
      },
      export_extra_fields: {
        entity_code: "Entity",
        po_category: "Item Type",
        po_sub_category: "PO Sub Category",
      },
      vehicle: {
        addVehicleDetails: "Add Vehicle Details",
        vehicleInformationTab: "Vehicle Information",
        vehicleNumber: "Vehicle Number",
        quantityInVehicle: "Quantity in Vehicle",
        expectedQuantityInVehicle: "Expected Quantity in Vehicle (Kgs)",
        actions: "Actions",
        recordNo: "Record No",
        invoiceNumber: "Invoice Number",
        arrivalDate: "Vehicle Arrival Date",
        exitDate: "Vehicle Exit Date",
        fullWeight: "Vehicle Full Weight",
        emptyWeight: "Vehicle Empty Weight",
        finalWeight: "Final Weight",
        quantityReceivedPct: "Quantity Received %",
        quantityReceivedOverall: "Quantity Received (Overall)",
        yetToReceive: "Yet to Receive",
        qtyRequired: "Quantity is required",
        digitsOnly: "Digits only",
        qtyPositive: "Quantity must be greater than 0",
        requiredVehicleNo: "Vehicle number is required",
        saveVehicleTitle: "Save Vehicle",
        cancelAddVehicleTitle: "Cancel Adding Vehicle",
        saveChangesTitle: "Save Changes",
        deleteVehicleTitle: "Delete Vehicle",
        editVehicleTitle: "Edit Vehicle",
        qtyPositiveNumber: "Quantity must be a positive number",
        exceedPoTotal: "Cannot exceed PO total quantity",
        exceedRemaining: "Quantity cannot exceed remaining",
        vehicleRequired: "Vehicle number is required",
        invalidVehicle: "Invalid vehicle number. Use AA99AA9999 or AA99AAA9999",
        invalidVehicleEg: "Invalid number. Use AA99AA9999 or AA99AAA9999",
        duplicateVehicle: "Duplicate vehicle number is not allowed",
        addAtLeastOneVehicle: "Please add at least one vehicle.",
        rowVehicleRequired: "Row {row}: Vehicle number is required",
        rowVehiclePattern: "Row {row}: Vehicle number must be AA99AA9999 or AA99AAA9999",
        rowQtyPositive: "Row {row}: Quantity must be a positive number",
        rowTotalExceeds: "Total vehicles’ quantity",
        cannotExceed: "rowTotalExceeds",
        examplePlate: "e.g., AP12AP1234 or AP12APX1234",
        continueTyping: "Continue typing: format is AA99AA9999 or AA99AAA9999",
        apiError: "Failed to fetch vehicles",
        serverError: "Server Error. Please contact administrator",
        vehicalNoticeMSg: "Note : A Quantity Received (%) value of 0% indicates that the vehicle has not yet arrived at the factory",
        add: "Add",
        bagWeight: "Bag Weight (Kgs)",
      },
      vehicleInfo: {
        record_no: "Record No",
        invoice_no: "Invoice Number",
        vehicle_no: "Vehicle Number",
        expected_quantity_in_vehicle: "Expected Quantity in Vehicle(kgs)",
        vehicle_arrival_date: "Vehicle Arrival Date",
        vehicle_exit_date: "Vehicle Exit Date",
        vehicle_full_weight: "Vehicle Full Weight(kgs)",
        vehicle_empty_weight: "Vehicle Empty Weight(kgs)",
        final_weight: "Final Weight(kgs)",
        quantity_received_pct: "Quantity Received (%)",
      },
      vehicleToRecieve: {
        yetToReceive: "Yet to Receive"
      },
      vehicleInfoMain: {
        record_id: "Record No",
        vehicle_no: "Vehicle Number",
        invoice_no: "Invoice Number",
        expected_quantity: "Expected Quantity (kgs)",
        quantity_received_percentage: "Quantity Received (%)",
        bag_weight: "Bag Weight",
      },
      vehicleTrips: {
        vehicle_in_date: "Vehicle Arrival Date",
        vehicle_out_date: "Vehicle Exit Date",
        gross_weight: "Vehicle Full Weight(kgs)",
        tare_weight: "Vehicle Empty Weight(kgs)",
        final_weight: "Final Weight (kgs)",
      },
    },
    gcDailyRates: {
      forms: {
        createGcDailyRates: "Create GC Daily Rates",
        gcDailyRates: "GC Daily Rates",
        allGcdailyrates: "All GC Daily Rates",
        record_id: "Record Id",
        price_dates: "Price Dates",
        currency_rate: "Currency Factor",
        terminal_month_details: "Terminal Month Details",
        systemPurpose: "System Purpose",
        currencyConversion: "Currency Conversion",
        addNewItem: "Add New",
        updateItem: "Update",
        proceed: "Proceed",
        currencyDate: "Currency Date",
        selectCurrency: "Select Currency",
        conversionRateUSDINR: "Conversion Rate On Selected Date(USD->INR)",
        itemName: "Item Name",
        terminalRate: "Terminal Rate",
        differential: "Differential",
        logistics: "Logistics",
        currencyCode: "Currency Code",
        currency: "Currency",
        rawMaterial: "Raw Material",
        currentTerminalDetails: "Current Terminal Details",
        itemInformation: "Item Information",
        current: "Current",
        future: "Future",
        srNo: "Sr No.",
        terminal: "Terminal",
        logistic: "Logistic",
        id: "Id",
        rawMaterialRates: "Raw Material",
        createSuccess: "GC Daily Rates created successfully",
        updateSuccess: "GC Daily Rates updated successfully",
        errorCheckExisting: "Error while checking existing GC Daily Rates",
        errorFetchConversion: "Error while fetching conversion rate",
        errorFetchItems: "Error while fetching items list",
        errorFetchDetails: "Error while fetching GC Daily Rates details",
        errorUpdate: "Error while updating GC Daily Rates",
        errorCreate: "Error while creating GC Daily Rates",
        errorFetchTerminal: "Error while fetching terminal rates",
        conversionDateLabel: "Conversion Rate As On Selected Date(USD-INR)",
        terminalDetails: "Current Terminal Details need to added",
        warningPopupBody: "Future Terminal Details Are not Added Are You Sure You Want to Create Record Without Future Terminal Rate Details?"
      },
      grid: {
        record_id: "Record ID",
        currency_date: "Price Date",
        currency_name: "Currency",
        currency_rate: "Currency Factor",
        terminal_month_details: "Terminal Month Details",
      },
      nestedGrid: {
        terminal_month: "Terminal month",
        terminal: "Terminal",
        closing_value: "Closing Value",
        highest_value: "Highest Value",
        lowest_value: "Lowest Value",
      }
    },
    gcEnquiry: {
      noOffer: "No Offer",
      sections: {
        enquiryInfo: "Enquiry Information",
        vendorInfo: "Vendor Information",
        itemInfo: "Item Information",
        systemInfo: "System Information",
      },
      forms: {
        gcEnquiry: "GC Enquiry",
        createGcenquiry: "Create GC Enquiry",
        allGcenquiry: "All GC Enquiry",
        enquiryNo: "Enquiry No",
        enquiryDate: "Enquiry Date",
        vendor: "Vendor",
        vendorInfo: "Vendor Information",
        srNo: "SR No",
        quote: "Quote *",
        vendorName: "Vendor Name",
        remarks: "Remarks",
        itemName: "Item Name",
        category: "Category",
        subCategory: "Sub Category",
        uom: "UOM",
        calendarPeriodFrom: "Calendar Period (From)",
        calendarPeriodTo: "Calendar Period (To)",
        price: "Price",
        period: "Period",
        offerPrice: "Offer Price",
        finalPrice: "Final Price",
        quantity: "Quantity",
        createSuccess: "GC Enquiry Created Successfully",
        updateSuccess: "GC Enquiry updated successfully",
        record_id: "Record Id",
      },
      grid: {
        record_id: "Record ID",
        gc_enquiry_number: "Enquiry Number",
        enquiry_date: "Enquiry Date",
        vendor_name: "Vendor",
        gc_enquiry_items: "Vendor Information",
      },
      view: {
        enquiryId: "Enquiry Id",
        enquiryNo: "Enquiry No",
        enquiryDate: "Enquiry Date",
        relateToQuote: "Enquiry relate to Quote",
        itemStockLocations: "Item stock locations",
      },
      nestedGrid: {
        item_name: "Item Name",
        item_category: "Category",
        item_sub_category: "Sub Category",
        uom: "UOM",
        offer_price: "Offer Price",
        final_price: "Final Price",
        quantity: "Quantity",
        period: "Period"
      }
    },
    gcRequired: {
      // keys are the grid dataIndex — used to build both the table columns and the export columns
      grid: {
        quote_number: "Quote No",
        quote_line_number: "Quote Line No",
        account_name: "Account Name",
        item_name: "Item Name",
        gc_approved_price: "Quote Approved Price",
        gc_given_price: "GC Given Price",
        quote_item_quantity: "Quote Item Qty",
        gc_price_given_date: "GC Price Date",
        quote_approved_by_customer_date: "Quote Approved By Customer Date",
        comments_gc: "Comment GC",
        allocated_quantity: "Allocation %",
      },
      status: {
        all_gc_required: "All GC Required",
        allocation_percentage: "Allocation 100 %"
      },
      gcRequiredList: "GCRequiredList",
    },
    PSS: {
      forms: {
        create: "Create",
        SelectReqType: "Select Request Type",
        SelectSubmitUserType: "Select Submit Report User Type",
        Comment: "Comment",
        TypeSampleRequest: "Type Sample Report Request",
        PSSSampleRequest: "Pre-Shipment Sample Report Request",
        TypeSample: "Type Sample Report",
        PSSSample: "Pre-Shipment Sample Report",
        TypeSampleReq: "Type Sample Request",
        PSSSampleReq: "Pre-Shipment Sample Request",
        TypeSampleLineItem: "Type Sample Line Item Details",
        AddItemDetails: "Add Item Details",
        add: "Add",
        requestType: "Request Type",
        PreShipmentSampleLineItem: "Pre-Shipment Sample Line Item Details",
        RequestForReport: "Request For Report",
        RDManager: "R&D Manager",
        RDManagerBD: "R&D Manager (BD)",
        RDAssociate: "R&D Associate",
        TypeSampleLineItemDetail: "Type Sample Line Item Details",
        PSSLineItemDetail: "Pre-Shipment Sample Line Item Details",
        ParameterSpecification: "Parameters / Specifications",
        SampleSpecification: "Sample Specifications",
        SieveAnalysis: "Sieve Analysis",
        CupTaste: "Cup Taste",
        lineCreatedSuccess: "Sample Type Line Item Created Successfully",
        lineCreatedSuccess: "Sample Type Line Item Created Successfully",
        documentattchedSuccess: "Document Attached Successfully",
        lineUpdatedSuccess: "Sample Type Line Item Updated Successfully",
        CreatedSampleSuccess: "Type Sample Created Successfully",
        updateSampleSuccess: "Type Sample Updated Successfully",
        preshipmentlineCreatedSuccess:
          "Pre shipment Sample Type Line Item Created Successfully",
        preshipmentlineUpdatedSuccess:
          "Pre shipment Sample Type Line Item Updated Successfully",
        CreatedpreshipmentSuccess: "Pre shipment Sample Created Successfully",
        updatepreshipmentSuccess: "Pre shipment Sample Updated Successfully",
        primaryDefects: "Primary Defects",
        secondaryDefects: "Secondary Defects",
        color: "Color",
        createReport: "Create Report",
        physical_appearance: "Physical Appearance",
        odor: "Odour",
        evaluatedDetails: "Evaluated & Approve/Rejection Details",
        sampleSpecification: "Sample Specifications",
        RDManagerAnalysis: "R&D Manager Analysis",
        QCAnalysis: "Quality Manager Analysis",
        submitReport: "Submit Report",
        requestForCEO: "Request For CEO",
        requestForMD: "Request For MD",
        resubmit: "Resubmit",
        resubmitted: "ReSubmitted",
        resubmitReport: "Resubmit Report",
        approve: "Approve",
        reject: "Reject",
        attachError:
          "Uploaded file type is not supported. Please upload only image, PDF, or Excel files.",
        fileDownlaod: "File downloaded successfully",
        numberOfDefects: "Number of defects",
        equivalentDefects: "Equivalent Defects",
        full_black: "Full Black",
        full_sour: "Full Sour",
        dried_cherry_pod: "Dried Cherry Pod",
        foriegn_matter: "Foriegn Matter",
        severe_insected_damage: "Severe Insected Damage",
        total_primary_defects: "Total Primary defects",
        part_black: "Part black",
        part_sour: "Part Sour",
        parchment_pargamanio: "Parchment/Pargamanio",
        floater: "Floater",
        immature_unripe: "Immature/Un-Ripe",
        withered: "Withered",
        shells: "Shells",
        broken_chipped_cut: "Broken Chipped Cut",
        hull_husk: "Hull/Husk",
        slight_insect_damage: "Slight Insect Damage",
        total_secondary_defects: "Total Secondary defects",
        color_blue: "Blue",
        color_yellow_green: "Yellow-Green",
        color_blue_green: "Blue-Green",
        color_pale_yellow: "Pale-Yellow",
        color_green: "Green",
        color_yellowish: "Yellowish",
        color_greenish: "Greenish",
        color_brownish: "Brownish",
        odor_clean: "Clean",
        odor_not_clean_smells_like: "Not Clean & Smells Like",
        evaluated_by: "Evaluated by",
        authorized_by: "Authorized by",
        isSampleApproved: "Is Sample Approved",
        attachment: "Attachment",
        contract_no: "Contract No",
        item_type: "Item Type",
        item_name: "Item Name",
        item_category: "Item Category",
        sample_number: "Sample No",
        contract_no: "Contract No",
        origin: "Origin",
        coffee_grade: "Coffee Grade",
        expectedDays: "Expected Days for Result",
        expectedResultDate: "Expected Result date",
        entity: "Entity",
        tracking_number: "Tracking Number",
        shipmentPeriod: "Shipment Period",
        comments: "Comments",
        item_group: "Item Group",
        contract_number: "Contract Number",
        supplier_name: "Supplier Name",
        phone_code: "Phone Code",
        phone_number: "Phone Number",
        email: "Email",
        supplier_category: "Supplier Category",
        address: "Address",
        purchase_order_number: "Purchase Order Number",
        contract_number: "Contract Number",
        po_category: "PO Category",
        po_sub_category: "PO Sub Category",
        appearance: "Appearance",
        foriegn_material: "Foreign Material",
        color_agrton: "Color(Agrton)",
        extractability_min: "Extractability (Min%)",
        solubility: "Solubility",
        sieve_analysis_pan: "Sieve analysis (PAN)",
        moisturise_max: "Moisturise (Max %)",
        sieve_analysis_astm_50_300um: "Sieve analysis (ASTM 50 (+ 300um))",
        sensory_attributes: "Sensory Attributes",
        total_solids_nlt: "Total Solids(NLT %)",
        bulk_density_g_cc: "Bulk Density (g/cc)",
        bulk_density_gr_cc: "Bulk Density(Gr/Cc)",
        caffeine_min: "Caffeine (Min %)",
        feathering_test: "Feathering test",
        water_content_max: "Water content (Max%)",
        ph_10_wv_solution: "pH (10% w/v solution)",
        isSampleApproved: "Is Sample Approved ?",
        sensory: "Sensory",
        remarks: "Remarks",
        evaluatedBy: "Evaluated By",
        moisture: "Moisture%",
        phReading: "pH reading",
        sediment: "Sediment",
        roastedChicoryWaterExtractability: "Roasted Chicory Water Extractability %",
        colorAgtron: "Colour (Agtron)",
        panReading: "Pan Reading of -17 (6.75mm)",
        attachments: "Attach",
        browns: "Browns%",
        blacks: "Blacks%",
        brokens: "Brokens%",
        insected: "Insected%",
        bleached_agent_beans: "Bleached Beans%/Aged Beans%",
        husk: "Husk%",
        stones: "Stones%",
        sticks: "Sticks%",
        mouldy_beans: "Mouldy Beans%",
        aroma: "Aroma",
        acidity: "Acidity",
        sieveAnalysis: "Sieve Analysis",
        strength: "Strength",
        sourness: "Sourness",
        mouthfeel: "Mouthfeel",
        off_flavour: "Off Flavour",
        earthy_note: "Earthy Note",
        others: "Others",
        approval_remarks: "Approval Remarks",
        rejection_remarks: "Rejection Remarks",
        approval_rejection_remarks: "Approval/Rejection Remarks",
        approved_by: "Approved By",
        rejected_by: "Rejected By",
        approved_rejected_by: "Approved/Rejected By",
        export: "Export",
        domestic: "Domestic",
        speciality: "Speciality",
        commercial: "Commercial",
        yes: "Yes",
        no: "No",
        conditionally_accepted: "Conditionally Accepted",
        faq: "FAQ",
        faqPlus: "FAQ+",
        faqMinus: "FAQ-",
        new: "New",
        existing: "Existing",
        gc: "GC",
        orm: "ORM",
        npd: "NPD",
        innovation: "Innovation",
        poor: "Poor",
        average: "Average",
        good: "Good",
        fair: "Fair",
        acceptable: "Acceptable",
        notacceptable: "Not Acceptable",
        mdApprovalDetails: "MD Approval Details",
        mdStatus: "MD Status",
        mdComment: "MD Comment",
        ceoApprovalDetails: "CEO Approval Details",
        ceoStatus: "CEO Status",
        ceoComment: "CEO Comment",
        pendingWithCEO: "Pending with CEO",
        pendingWithMD: "Pending with MD",
        pendingWithRDQC: "Pending with R&D / QC",
        pendingWithQC: "Pending with QC",
        pendingWithRD: "Pending with R&D",
        pending: "Pending",
        requested: "Requested",
        requestCompleted: "Request Completed",
        phoneCode: "Phone Code",
        supplierCategory: "Supplier Category",
        qualityManager: "Quality Manager",
        rdManager: "R&D Manager",
        rdAssociate: "R&D Associate",
        rdInnovationManager: "R&D Innovation Manager",
        rdNPDManager: "R&D NPD Manager",
        requestReportForQualityManager: "Request Report for Quality Manager",
        requestReportForRD: "Request Report for R&D",
        reSubmitted: "ReSubmitted",
        approvedByCEO: "Approved by CEO",
        rejectedByCEO: "Rejected by CEO",
        approvedByMD: "Approved by MD",
        rejectedByMD: "Rejected by MD",
        rdResubmitted: "R&D Resubmitted",
        qualityResubmitted: "Quality Resubmitted",
      },
      view: {
        request_number: "Request Number",
        created_date: "Created Date",
        supplier_name: "Supplier Name",
        created_by: "Created By",
        email: "Email",
        phone_number: "Phone Number",
        address: "Address",
        supplier_category: "Supplier Category",
        sample_request_date: "Sample Request date",
        requested_for: "Requested For",
        purchase_order_number: "Purchase Order Number",
        po_category: "PO Category",
        contract_number: "Contract Number",
        po_sub_category: "PO Sub Category",
        tsli_number: "TSLI Number",
        item_type: "Item Type",
        item_name: "Item Name",
        item_category: "Item Category",
        sample_number: "Sample No",
        origin: "Origin",
        coffee_grade: "Coffee Grade",
        expectedDays: "Expected days for Result",
        expectedResultDate: "Expected Result date",
        entity: "Entity",
        tracking_number: "Tracking Number",
        comments: "Comments",
        shipmentPeriod: "Shippment Period",
        psli_number: "PSLI Number",
        contract_no: "Contract No",
        sample_no: "Sample No",
        appearance: "Appearance",
        foreign_material: "Foreign Material",
        color_agrton: "Color (Agrton)",
        extractability_min: "Extractability (Min%)",
        solubility: "Solubility",
        sieve_analysis_pan: "Sieve Analysis (PAN)",
        moisturise_max: "Moisturise (Max %)",
        sieve_analysis_astm_50_300um: "Sieve Analysis (ASTM 50 (+ 300µm))",
        sensory_attributes: "Sensory Attributes",
        total_solids_nlt: "Total Solids (NLT %)",
        bulk_density_g_cc: "Bulk Density(Gr/Cc)",
        caffeine_min: "Caffeine (Min %)",
        feathering_test: "Feathering Test",
        water_content_max: "Water Content (Max %)",
        ph_10_wv_solution: "pH (10% w/v solution)",
        rdIsSampleApproved: "Is Sample Approved ?",
        rdAttachment: "Attachment",
        appearance: "Appearance",
        ph_10_wv_solution: "pH (10% w/v solution)",
        foreign_material: "Foriegn Material",
        color_agrton: "Color(Agrton)",
        solubility: "Solubility",
        extractability_min: "Extractability (Min%)",
        moisturise_max: "Moisturise (Max %)",
        sieve_analysis_pan: "Sieve analysis (PAN)",
        sensory_attributes: "Sensory Attributes",
        sieve_analysis_astm_50_300um: "Sieve analysis (ASTM 50 (+ 300um))",
        bulk_density_g_cc: "Bulk Density (g/cc)",
        total_solids_nlt: "Total Solids(NLT %)",
        feathering_test: "Feathering test",
        caffeine_min: "Caffeine (Min %)",
        water_content_max: "Water content (Max%)",
        rdIsSampleApproved: "Is Sample Approved ?",
        rdAttachment: "Attachment",
        physical_appearance: "Physical Appearance",
        odour: "Odour",
        bulk_density_gr_gc: "Bulk Density(Gr/Cc)",
        moisture: "Moisture%",
        browns: "Browns%",
        blacks: "Blacks%",
        brokens: "Brokens%",
        insected: "Insected%",
        bleached_agent_beans: "Bleached Beans%/Aged Beans%",
        husk: "Husk%",
        stones: "Stones%",
        sticks: "Sticks%",
        mouldy_beans: "Mouldy Beans%",
        sleve_plus_17: "+17",
        sleve_plus_16: "+16",
        sleve_plus_15: "+15",
        sleve_plus_14: "+14",
        sleve_pan: "PAN",
        sleve_plus_12: "+12",
        sleve_pan_1: "PAN",
        aroma: "Aroma",
        acidity: "Acidity",
        strength: "Strength",
        sourness: "Sourness",
        mouthfeel: "Mouthfeel",
        off_flavour: "Off Flavour",
        earthy_note: "Earthy Note",
        others: "Others",
        qcIsSampleApproved: "Is Sample Approved ?",
        qcAttachment: "Attachment",
        approval_remarks: "Approval Remarks",
        rejection_remarks: "Rejection Remarks",
        approval_rejection_remarks: "Approval/Rejection Remarks",
      },
      grid: {
        TSLINumber: "TSLI Number",
        PSLINumber: "PSLI Number",
        ItemName: "Item Name",
        ItemCategory: "Item Category",
        ShippmentPeriod: "Shippment Period",
        Entity: "Entity",
        ExpectedResultDate: "Expected Result Date",
        IsRNDApproved: "Is R&D Approved",
        IsQualityApproved: "Is Quality Approved",
        ActionRequired: "Action Required",
        CEOStatus: "CEO Status",
        MDStatus: "MD Status",
        QCReport: "QC Report",
        RDManager: "R&D Manager",
        RDManagerBD: "R&D Manager (BD)",
        RDAssociate: "R&D Associate",
        RequestNumber: "Request Number",
        entity: "Entity",
        ItemName: "Item Name",
        PONumber: "Purchase Order Number",
        Contact: "Contract Number",
        SupplierName: "Supplier Name",
        Status: "Status",
        CreatedBy: "Created By",
        RequestDate: "Requested Date"
      },
      pdf: {
        cclName: "CCL PRODUCTS (INDIA) LTD.",
        duggirala: "DUGGIRALA",
        rdReportTitle: "RAW MATERIAL SPECIFICATION AND PARAMETERS",
        rdNPDReportTitle:
          "RAW MATERIAL SPECIFICATION FOR NON - COFFEE INGREDIENTS",
        qcReportTitle: "QUALITY ANALYSIS REPORT ON GREEN COFFEE SAMPLE",
        gcReportTitle: "GREEN COFFEE SAMPLE ANALYSIS REPORT",
        ormReportTitle: "QUALITY ANALYSIS REPORT ON OTHER RAW MATERIALS",
        parameters: "PARAMETERS/SPECIFICATIONS",
        parametersQC: "PARAMETERS",
        results: "RESULTS",
        full_black: "Full Black",
        full_sour: "Full Sour",
        dried_cherry_pod: "Dried Cherry Pod",
        foriegn_matter: "Foriegn Matter",
        severe_insected_damage: "Severe Insected Damage",
        total_primary_defects: "Total Primary defects",
        part_black: "Part black",
        part_sour: "Part Sour",
        parchment_pargamanio: "Parchment/Pargamanio",
        floater: "Floater",
        immature_unripe: "Immature/Un-Ripe",
        withered: "Withered",
        shells: "Shells",
        broken_chipped_cut: "Broken Chipped Cut",
        hull_husk: "Hull/Husk",
        slight_insect_damage: "Slight Insect Damage",
        total_secondary_defects: "Total Secondary defects",
        color_blue: "Blue",
        color_yellow_green: "Yellow-Green",
        color_blue_green: "Blue-Green",
        color_pale_yellow: "Pale-Yellow",
        color_green: "Green",
        color_yellowish: "Yellowish",
        color_greenish: "Greenish",
        color_brownish: "Brownish",
        statusOfSample: "Status of the sample",
        odor_clean: "Clean",
        odor: "Odor",
        approvedBy: "Approved By",
        rejectedBy: "Rejected By",
        approvedRemarks: "Approval Remarks",
        rejectedRemarks: "Rejected Remarks",
        footerNote: 'This document is electronically authenticated and does not require a physical signature.',
        contract_number: 'Contract No:',
        evaluated_by: 'Evaluated by',
        sampleDetails: {
          supplier_name: 'Supplier Name',
          item_name: 'Sample Name',
          sample_number: 'Sample Reference Number',
          line_created_date: 'Report Creation Date',
          entity_name: 'Entity'
        },
        gcNpdPdf:{
          supplier_name: 'Supplier Name:',
          type: 'Type:',
          grade: "Grade:",
          sample_number: 'Sample No:',
          parameters:{
           parameters : "PARAMETERS/SPECIFICATIONS",
           physical_appearance: 'Appearance',
           bulk_density_gr_gc: "Bulk Density(Gr/Cc)",
           browns: "Browns%",
           brokens: "Brokens%",
           bleached_agent_beans: "Bleached Beans%/Aged Beans%",
           stones: "Stones%",
           mouldy_beans: "Mouldy Beans%",
           odour: "Odour",
           moisture: "Moisture%",
           blacks: "Blacks%",
           insected: "Insected%",
           husk: "Husk%",
           sticks: "Sticks%"
          },
          sieve_analysis: {
            sieve_analysis: "SIEVE ANALYSIS",
            sieve_analysis_17: "+17",
            sieve_analysis_16: "+16",
            sieve_analysis_15: "+15",
            sieve_analysis_14: "+14",
            pan1: "PAN",
            sieve_analysis_12: "+12",
            pan2: "PAN",
          },
          cup_taste:{
            cup_taste: "CUP TASTE",
            aroma: "Aroma",
            strength: "Strength",
            mouthfeel:"Mouthfeel",
            earthy_note: "Earthy Note",
           acidity : "Acidity",
           sourness: "Sourness",
           off_flavour: "Off Flavour",
           miscellaneous: "Miscellaneous",
          }
        },
        parameterDetails: {
          physical_appearance: 'Physical Appearance',
          odour: 'Odour',
          bulk_density_gr_gc: 'Bulk Density(Gr/Cc)',
          moisture: 'Moisture%',
          roasted_chicory_water_extractability: 'Roasted Chicory Extractability%',
          sensory: 'Sensory',
          colour_agtron: 'Colour (Agtron)',
          pan_reading_of_positive_17_6_75_mm: 'Pan reading of -17(6.75mm)',
          ph_reading: 'pH reading',
          sediment: "Sediment",
        }
      },
    },
    logistics: {
      forms: {
        createLogistics: "Create Logistics Cost",
        taxDetails: "Tax Details",
        updateLogistics: "Update Logistics Cost",
        deleteLogistics: "Delete Logistics Cost",
        viewLogistics: "Logistics Cost Details",
        othercharges: "Other Charges",
        requestForApproval: "Request For Approval",
        purchaseOrderLogisticCost: "Purchase Order Logistic Costs",
        category: "Category",
        categoryDetails: "Category Details",
        mrinLogisticCosts: "Mrin Logistic Costs",
        subCategory: "Sub Category",
        serviceProvider: "Service Provider",
        containerType: "Container Type",
        containerTypeList: {
          fourtyFt: "40 ft",
          twentyFt: "20 ft",
        },
        invoiceNumber: "Invoice Number",
        mandiPer: "Mandi (%)",
        certificateNumber: "Certificate Number",
        certificateDate: "Certificate Date",
        certificateIssueDate: "Certificate Issue Date",
        certificateValidity: "Certificate Validity",
        validTill: "Valid Till",
        invoiceDate: "Invoice Date",
        noOfContainers: "No of Containers",
        noOfVehicles: "No of Vehicles",
        totalTons: "Total Tons",
        ratePerVehicle: "Rate Per Vehicle",
        ratePerTon: "Rate Per Ton",
        paymentDueDate: "Payment Due Date",
        totalAmount: "Total Amount",
        currency: "Currency",
        conversionRate: "Conversion Rate",
        invoiceValue: "Invoice Value",
        invoiceValueINR: "Invoice Value (INR)",
        invoiceValueINRFormula: "Invoice Value * Conversion Rate",
        sumInsured: "Sum Insured (%)",
        totalSumInsuredValue: "Total Sum Insured Value",
        totalSumInsuredValueFormula: "Invoice Value (INR) * Sum Insured (%)",
        premiumAmount: "Premium Amount",
        rate: "Rate",
        tax: "Tax",
        taxes: "Taxes",
        taxSingleMessage: "You can select only 1 tax.",
        taxMultipleMessage: "You can select up to 2 taxes.",
        taxPercentage: "Tax(%)",
        totalTax: "Total Tax",
        totalTaxLocalTransportationFormula: "Rate * Tax %",
        totalRateLocalTransportationFormula: "Rate + Total Tax",
        totalRateVehicleFormula: "Sub Total + Total Tax",
        subTotalTonnageFormula: "Rate Per Ton * Total Tons",
        totalTaxTonnageFormula: "Sub Total * Tax %",
        subTotalVehicleFormula: "No. of Vehicles * Rate per Vehicle",
        subCategoryTotal: "Sub Category Total",
        // Total Tax = Total Rate x (Sum of selected Tax %) - holds for both single-tax categories
        // (sum of 1 tax %) and FAC-7/FAC-17, which allow up to 2 selected taxes.
        totalTaxFormula: "Total Tax = Total Rate × (Sum of selected Tax %)",
        totalRateFormula: "Conversion Rate * Rate",
        totalRateFormulaHamali: "Sum of all Rates",
        totalRateCHAFormula: "Rate * No. of Containers * Conversion Rate",
        totalRateMandiFormula: "MRIN Value * Mandi (%)",
        totalRate: "Total Rate",
        subTotal: "Sub Total",
        tonnage: "Tonnage",
        vehicle: "Vehicle",
        typeOfBill: "Type of Bill",
        billReferenceNumber: "Bill Reference Number",
        direct: 'Direct',
        pureAgent: 'Pure Agent',
        rcm: 'RCM',
        totalRateINR: "Total Rate (INR)",
        grandTotal: "Grand Total",
        grandTotalINR: "Grand Total (INR)",
        grandTotalFormula: "Total Rate + Total Tax",
        grandTotalMandiFormula: "(MRIN Value * Mandi (%)) * Conversion Rate",
        subCatGrandTotal: "Sum of Sub Category Grand Total",
        remarks: "Remarks",
        attachFile: "Attach File",
        taxName: "Tax Name",
        attachment: "Attachment",
        createLogistics: "Create Logistics Cost",
        updateLogistics: "Update Logistics Cost",
        deleteLogistics: "Delete Logistics Cost",
        paymentLogistics: "Payment Details",
        viewLogistics: "Logistics Cost Details",
        othercharges: "Other Charges",
        requestForApproval: "Request For Approval",
        logisticCostInfo: "Logistics Cost Information",
        purchaseOrderLogisticCost: "Purchase Order Logistic Costs",
        logisticCostCreatedFor: "Logistic Cost Created",
        subcategoryCreatedFor: "Sub category Created For",
      },
      grid: {
        record_number: "Record Number",
        createLogistics: "Create Logistics Cost",
        updateLogistics: "Update Logistics Cost",
        editLogisticsRecord: "Edit Logistic Record",
        viewLogisticsRecord: "View Logistic Record",
        deleteLogisticsRecord: "Delete Logistic Record",
        viewLogistics: "Logistics Cost Details",
        subCategory: "Sub Category",
        paymentInfo: "Payment Information",
        othercharges: "Other Charges",
        requestForApproval: "Request For Approval",
        requestForResubmit: "Requested For Re-submit",
        resubmitForApproval: "Resubmit For Approval",
        requestForApprovalSuccess: "Send Request For Approval Successfully",
        approvedSuccess: "Record Approved Successfully",
        reSubmitSuccess: "Record Re-submitted Successfully",
        netsuitSuccess: "Send To NetSuite Successfully",
        requestedForApproval: "Requested For Approval",
        resubmittedForApproval: "Re-submitted For Approval",
        approved: "Approved",
        approve: "Approve",
        new: "New",
        resubmitted: "Re-submitted",
        sendToNetsuit: "Send to NetSuite",
        resubmit: "Resubmit",
        addLogisticsCost: "Add Logistics Cost",
        addSubcategoryLogisticsCost: "Add Sub Category",
        logisticCostStatus: "Category Status",
        logisticCostSendtoNetsuit: "Logistic Cost Send to NetSuite",
        category: "Category",
        subcategory: "Sub-Category",
        typeOfVehicleArrived: "Type of Vehicle Arrived",
        typeOfCharge: "Type of Charge",
        serviceProvider: "Service Provider",
        invoiceNumber: "Invoice Number",
        invoiceDate: "Invoice Date",
        paymentDueDate: "Payment Due Date",
        grandTotal: "Grand Total",
        netsuiteId: "NetSuite Id",
        paymentInfo: "Payment Info",
        document: "Document",
        action: "Action",
        approvalStatus: "Approval Status",
        rate: "Rate",
        taxes: "Taxes",
        taxPercentage: "Tax(%)",
        taxName: "Tax Name",
        totalTax: "Total Tax",
        totalRate: "Total Rate",
        grandTotal: "Grand Total",
        paymentId: "Payment ID",
        paymentDocumentNo: "Payment Document No",
        supplierName: "Supplier Name",
        payingFrom: "Paying From",
        bankName: "Bank Name",
        bankBranchName: "Bank Branch Name",
        totalAmountPay: "Total Amount Pay",
        currency: "Currency",
        exchangeRate: "Exchange Rate",
        memo: "Memo",
        createdBy: "Created By",
        billPaymentDate: "Bill Payment Date",
        checkNo: "Check Number",
        lcNsRecordNumber: "NS Record Number",
        amount: "Amount",
        available: "Available",
        notAvailable: "Not Available",
        record_id: "Record Id"
      },
      subCategoryGrid: {
        chaCharges: {
          record_number: "Record Number",
          sub_category_name: "Sub Category",
          number_of_containers: "No. of Containers",
          currency_code: "Currency",
          conversion_ratio: "Conversion Rate",
          rate: "Rate",
          total_rate: "Total Rate",
          tax: "Taxes",
          tax_perc: "Tax %",
          total_tax: "Total Tax",
          sub_category_total: "Sub Category Total",
        },
        freight: {
          record_number: "Record Number",
          sub_category_name: "Sub Category",
          number_of_containers: "No. of Containers",
          currency_code: "Currency",
          conversion_ratio: "Conversion Rate",
          rate: "Rate",
          total_rate: "Total Rate",
          tax_name: "Taxes",
          tax_percentage: "Tax %",
          total_tax: "Total Tax",
          sub_category_total: "Sub Category Total",
        },
        localTransportation: {
          record_number: "Record Number",
          sub_category_name: "Sub Category",
          type_of_charge: "Type of Charge",
          no_of_vehicles: "No. of Vehicles / Total Tons",
          rate_per_vehicle: "Rate per Vehicle / Rate per Ton",
          rate: "Rate",
          sub_total: "Sub Total",
          total_tax: "Total Tax",
          total_rate: "Total Rate",
        },
        hamali: {
          record_number: "Record Number",
          sub_category_name: "Type of Vehicle Arrived",
          no_of_vehicles: "No. of Vehicles",
          rate: "Rate"
        }
      },
      delete: {
        firstDeleteMsg: "Are you sure you want to delete category",
        firstSubcategoryDeleteMsg: "Are you sure you want to delete sub category",
        secondDeleteMsg: "This action will permanently remove the related logistic cost details.",
        record: "record?",
        logisticCostDeleted: 'Logistic Cost Deleted',
        subcategoryDeleted: 'Sub category Deleted',
        yes: "Yes",
        deleteConfirmation: "Are you sure you want to delete this sub category?"
      },
      view: {
        additionalCharges: {
          record_number: "Record Number",
          category_name: "Category",
          service_provider_name: "Service Provider",
          invoice_number: "Invoice Number",
          invoice_date: "Invoice Date",
          number_of_containers: "No. of Containers",
          payment_due_date: "Payment Due Date",
          currency_code: "Currency",
          conversion_ratio: "Conversion Rate",
          rate: "Rate",
          total_rate: "Total Rate",
          tax_name: "Taxes",
          tax_percentage: "Tax %",
          total_tax: "Total Tax",
          grand_total: "Grand Total (INR)",
          type_of_bill: "Type of Bill",
          bill_reference_number: "Bill Reference Number",
          remarks: "Remarks",
          file_name: "Attach File",
          netsuite_id: "NetSuite Id",
          netsuite_response: "NetSuite Response",
        },
        localTransportaion: {
          record_number: "Record Number",
          category_name: "Category",
          service_provider_name: "Service Provider",
          container_type: "Container Type",
          invoice_number: "Invoice Number",
          invoice_date: "Invoice Date",
          payment_due_date: "Payment Due Date",
          grand_total: "Grand Total (INR)",
          currency_code: "Currency",
          conversion_ratio: "Conversion Rate",
          tax_name: "Taxes",
          tax_percentage: "Tax %",
          type_of_bill: "Type of Bill",
          bill_reference_number: "Bill Reference Number",
          remarks: "Remarks",
          file_name: "Attach File",
          netsuite_id: "NetSuite Id",
          netsuite_response: "NetSuite Response",
        },
        freight: {
          record_number: "Record Number",
          category_name: "Category",
          service_provider_name: "Service Provider",
          invoice_number: "Invoice Number",
          invoice_date: "Invoice Date",
          payment_due_date: "Payment Due Date",
          grand_total: "Grand Total (INR)",
          type_of_bill: "Type of Bill",
          bill_reference_number: "Bill Reference Number",
          remarks: "Remarks",
          file_name: "Attach File",
          netsuite_id: "NetSuite Id",
          netsuite_response: "NetSuite Response",
        },
        freightTransportationOnInvoice: {
          record_number: "Record Number",
          category_name: "Category",
          invoice_number: "Invoice Number",
          invoice_date: "Invoice Date",
          currency_code: "Currency",
          conversion_ratio: "Conversion Rate",
          total_rate: "Total Rate (INR)",
          tax_details: "Taxes",
          total_tax: "Total Tax",
          grand_total: "Grand Total (INR)",
          remarks: "Remarks",
          file_name: "Attach File",
        },
        insurance: {
          record_number: "Record Number",
          category_name: "Category",
          service_provider_name: "Service Provider",
          certificate_number: "Certificate Number",
          certificate_date: "Certificate Date",
          certificate_valid: "Valid Till",
          currency_code: "Currency",
          conversion_ratio: "Conversion Rate",
          invoice_value: "Invoice Value",
          invoice_value_inr: "Invoice Value (INR)",
          elevated_sum_insured_percentage: "Sum Insured %",
          total_sum_insured_value: "Total Sum Insured Value ",
          premium_amount: "Premium Amount",
          remarks: "Remarks",
          file_name: "Attach File",
        },
        mandiFee: {
          record_number: "Record Number",
          category_name: "Category",
          invoice_number: "Invoice Number",
          invoice_date: "Invoice Date",
          mandi_percentage: "Mandi %",
          total_rate: "Total Rate",
          tax_details: "Taxes",
          total_tax: "Total Tax",
          currency_code: "Currency",
          conversion_ratio: "Conversion Rate",
          grand_total: "Grand Total (INR)",
          remarks: "Remarks",
          file_name: "Attach File",
        },
        hamali: {
          record_number: "Record Number",
          category_name: "Category",
          service_provider_name: "Service Provider",
          certificate_number: "Certificate Number",
          certificate_date: "Certificate Issue Date",
          certificate_valid: "Certificate Validity",
          currency_code: "Currency",
          conversion_ratio: "Conversion Rate",
          tax_name: "Taxes",
          tax_percentage: "Tax %",
          total_rate: "Total Rate",
          total_tax: "Total Tax",
          grand_total: "Grand Total",
          remarks: "Remarks",
          file_name: "Attach File",
          netsuite_id: "NetSuite Id",
          netsuite_response: "NetSuite Response",
        },
        addLogisticsCost: "Add Logistics Cost",
        category: "Category",
        serviceProvider: "Service Provider",
        invoiceNumber: "Invoice Number",
        invoiceDate: "Invoice Date",
        noOfContainer: "No of Containers",
        noOfVehicles: "No of Vehicles",
        paymentDueDate: "Payment Due Date",
        totalAmount: "Total Amount",
        currency: "Currency",
        conversionRate: "Conversion Rate",
        rate: "Rate",
        taxes: "Taxes",
        tax: "Tax %",
        totalTax: "Total Tax",
        totalRate: "Total Rate",
        grandTotal: "Grand Total",
        attachFile: "Attach File",
        remarks: "Remarks",
        netsuiteID: "NetSuite Id",
        netsuiteResponse: "NetSuite Response",
        createSuccess: "Logistics cost Record created successfully",
        updateSuccess: "Logistics cost Record updated successfully",
        deleteSuccess: "Logistics cost Record deleted successfully",
        createSubcategorySuccess: "Logistics cost Sub Category created successfully",
        updateSubcategorySuccess: "Logistics cost Sub Category updated successfully",
        deleteSubcategorySuccess: "Logistics cost Sub Category deleted successfully",
      },
    },
    packingType: {
      forms: {
        packingType: "Packing Type",
        packingMode: "Packing Mode",
        packingCategory: "Packing Category",
        packingSubType: "Packing Sub-Type",
        sampleType: "Sample Type",
        unitNetWeight: "Unit Net Weight(Gms)",
        jarType: "Jar Type",
        packingConfiguration: "Packing Configuration (as per above fields)",
        unitPerCarton: "Units per Carton",
        capType: "Cap Type",
        market: 'Market',
        wastage: 'Wastage (%)',
        loadbility: "Loadability",
        loadbilityType: "Loadability Type",
        type: "Type",
        containerSize: "Container Size",
        palletType: "Pallet Type (mm)",
        totalWeight: "Total Weight(Kgs)",
        noOfBox: "No of Box",
        loadabilityCombination: "Loadability Combination",
        remarks: "Remarks",
        createSuccess: "Packing Type created successfully",
        updateSuccess: "Packing Type updated successfully",
        packingTypeCreatedFor: "Packing Type Created",
        new: "New",
        pendingForPricing: "Pending For Pricing",
        pendingForApproval: "Pending For Approval",
        pendingForReview: "Pending for Review",
        pendingApprovalFromPacking:"Pending Approval from Packing Team",
        approved: "Approved",
        rejected: "Rejected",
        approve: "Approve",
        approvalComment: "Approval Comment",
        rejectionComment: "Rejection Comment",
        inactive: "InActive",
        yes: "Yes",
        inactiveHeader: "InActive Packing Type",
        resubmitOrReject: "Resubmit or Reject",
        resubmitModalDesc: "Do you want to resubmit or reject?",
        resubmit: "Resubmit",
        statsUpdated : "Status Updated",
        reject: "Reject",
        inactiveConfirmation: "Are you sure you want to inactivate this packing type record?",
        reject: "Reject",
        approvedRejected: "Approved / Rejected",
        bomCreated: "Packing Line Item Created",
        sendForPricing: "Request for Pricing",
        sendForReview: "Send For Review",
        resubmitModalHeader:"Do you want to resubmit this Packing Type to",
        quoteInfo: "Quote Information",
        duplicateErrorTitle: "Duplicate Packing Type",
        duplicateErrorMessage: "There is an existing packing type with the given combination.",
        approve_by: "Approved By",
        approve_date: "Approved Date",
        reject_by: "Rejected By",
        reject_date: "Rejected Date",
        selectPackingtype: "Select Packing Type",
        fd: "FD",
        sd: "SD",
        aglo: "AGLO",
        fd_sd_aglo: "FD/SD/AGLO",
        premix: "Premix",
        lfc: "LFC",
        pp: "PP",
        hdpe: "HDPE",
        approvalRemarks: "Approval Remarks",
        rejectedRemarks: "Rejected Remarks",
        roundGlassJar: "Round Glass Jar",
        newSquareGlassJar: "New Square Glass Jar",
        ukSquareGlassJar: "UK Square Glass Jar",
        newRoundGlassJar: "New Round Glass Jar",
        squarePetJar: "Square Pet Jar",
        plain: "Plain",
        embossed: "Embossed",
        floor: "Floor",
        pallet: "Pallet",
        unitsOf: "UNITS OF",
        gms: "GMS",
      },
      BOMLines: {
        BOMLines: "Packing Type lines",
        srNo: "Sr. No.",
        description: "Description",
        uom: "UOM",
        qtyPerCase: "Quantity Per Case",
        remarks: "Remarks",
        costPerUnit: "Cost Per Unit",
        unitsPerKg: "Units Per Kg",
        costPerKg: "Cost Per Kg",
        action: "Action",
        addBom: 'Add Packing Type Line Item',
        updateBom: 'Edit Packing Type Line Item',
        deleteBom: 'Delete Packing Type Line Item',
        addBomBtn: "+ Add Packing Type Line",
        usd: "USD",
        inr: "INR",
        totalCostPerUnit: "Total Cost Per Unit",
        subTotal: "Sub Total",
        waste: "Wastage ",
        grandTotal: "Grand Total",
        bomDeleted: "Packing Line Deleted",
        deleteConfirmation: "Are you sure you want to delete this Packing Type Line?",
      },
      grid: {
        packing_type_id: "Packing Type Number",
        packing_category: "Packing Category",
        packing_type_name: "Packing Type",
        status: "Status",
        sample_type: "Sample Type",
        created_by: "Created By",
        cost_per_kg: "Cost Per KG",
        created_at: "Created Date",
        approve_reject_by: "Approved/Rejected By",
        approve_reject_date: "Approved/Rejected Date"
      },
      packingModeDetails: {
        category_name: "Packing Category",
        packing_sub_type: "Packing Sub-Type",
        packing_name: "Packing Mode",
        sample_type: "Sample Type",
        unit_net_weight: "Unit Net Weight(Gms)",
        jar_type: "Jar Type",
        packing_configuration: "Packing Configuration (as per above fields)",
        upc: "Units per Carton",
        cap_type: "Cap Type",
        market: 'Market',
        wastage_percentage: 'Wastage (%)',
        totalCostTooltip: "Sum(Cost per Unit of Packing Line items)",
        subTotalTooltip: "Sum(Cost per Kg of Packing Line items)",
        wastageTooltip: "(Wastage% * Subtotal)",
        grandTotalTooltip: "Subtotal (Cost/kg) + Wastage"
      },
      loadabilityDetails: {
        loadability_type: "Type",
        container_size: "Container Size",
        pallet_type: "Pallet Type (mm)",
        total_weight: "Total Weight(Kgs)",
        no_of_boxs: "No of Box",
      },
      quotationDetails: {
        quote_number: "Quote number",
        quote_line_number: "Quote Line Number",
        customer_name: "Customer",
        quote_status: "Quote status",
        quote_line_status: "Quote Line Status",
        expected_order_quantity: "Expected order quantity",
        confirmed_quantity: "Confirmed quantity",
        scheduled_quantity: "Schedule Quantity",
      },
      bomLinelist: {
        srNo: "Sr. No.",
        record_id: "Packing Type Id",
        description: "Description",
        uom_name: "UOM",
        quantity_per_case: "Quantity Per Case",
        remarks: "Remarks",
        cost_per_unit: "Cost Per Unit",
        unit_per_kg: "Units Per Kg",
        cost_per_kg: "Cost Per Kg",
      }
    }
  },
  ProductionNQuality: {
    blendsheet: {
      forms: {
        NegativeText: "Negative values are not allowed",
        TotalPowderRequiredKgs: "Total Powder Required(Kgs):",
        approveRejectError: "Please Provide approval/Rejection Remarks",
        orderDispatchInfo: "Order Dispatch Information",
        NoorderDispatch: "No Order dispatch selected.",
        gcandotherItems: "Green Coffee And Other Consumable Items",
        bindetails: "Bin Details",
        dispenseInformation: "Dispense Information",
        qcapproval: "Request For Quality Approval",
        submitToStores: "Submit To Stores",
        requestapproval: "Request for Approval",
        approve: "Approve",
        reject: "Reject",
        approveReject: "Approve / Reject",
        approveRejectRemarks: "Approve/Reject Remarks",
        qualityApproveRejectRemarks: "Quality Approve / Reject Remarks",
        productionApproveRejectRemarks: "Production Approve / Reject Remarks",
        pendingWithStoresRemarks: "Pending with Stores Remarks",
        submitBackToProductionAssistant: "Submit Back to Production Assistant",
        submitBackConfirmMessage: "Are you sure you want to submit this Blend Sheet back to the Production Assistant? It will move back to New status.",
        submitBackRemarks: "Submit Back Remarks",
        submitBackRemarksError: "Please Provide Submit Back Remarks",
        blendSheetSentBackToProductionAssistant: "BlendSheet Sent Back to Production Assistant",
        retriggerToNetsuite: "Re-trigger to Netsuite",
        noMRINDetails: "MRIN Details Not Yet Updated",
        edit: "Edit",
        pleaseEnterProductionValue: "Production Quantity cannot be zero",
        pleaseEnterProductionQty: "Please enter a Production Quantity",
        errorToCheckingTotalProductionQuantity: 'Error checking total production quantity:',
        blendSheet: "Blend Sheet",
        gcblendSheet: "Green Coffee Blend Sheet",
        createBlendSheet: "Create Blend Sheet",
        editBlendSheet: "Edit Blend Sheet",
        blendSheetDetails: "Blend Sheet Details",
        powderRequiredMT: "Powder Required (MT)",
        greenCoffeeRequirementMT: "Green Coffee Requirement (MT)",
        roastColor: "Roast Color",
        remarks: "Remarks",
        aroma: "Aroma",
        productionAssistantRemarks: "Production Assistant Remarks",
        storesManagerRemarks: "Stores Manager Remarks",
        qualityManagerRemarks: "Quality Manager Remarks",
        productionManagerRemarks: "Production Manager Remarks",
        qualityApprovalRemarks: "Quality Approval Remarks",
        qualityRejectionRemarks: "Quality Rejection Remarks",
        productionManagerApprovalRemarks: "Production Manager Approval Remarks",
        productionManagerRejectionRemarks: "Production Manager Rejection Remarks",
        product: "Product",
        ffbd: "FFBD GR/CC",
        color: "Color",
        moisture: "Moisture",
        serialNumber: "Serial Number",
        batchNumber: "Batch Number",
        quotedAlternativeSample: "Quoted Alternative Sample",
        quotedAS: "Quoted Alternative Sample*",
        alternativeSample: "Alternative Sample",
        quotedASCode: "Quoted Alternative Sample Code*",
        productionAlternativeSample: "Production Alternative Sample",
        productionAS: "Production Alternative Sample*",
        netsuiteId: "NetSuite Id",
        netsuiteResponse: "Netsuite Response",
        noMRINforGC: "No MRIN is selected for GC items.",
        entity: "Entity",
        category: "Category",
        arabicaMT: "Arabica (MT)",
        robustaMT: "Robusta (MT)",
        inventoryInformation: "Inventory Information",
        approverComments: "Approver Comments",
        approveRejectComments: "Approve/Reject Comments",
        greenCoffeeAndOtherConsumableItems: "Green Coffee And Other Consumable Items And Their Specifications",
        productionRequirement: "Production Requirement",
        finalConsumables: "Final Consumables",
        workOrderInformation: "Work Order Information",
        itemInformation: "Item Information",
        batchOutput: "Batch Output",
        seeLocations: "See Locations",
        locationDetails: "Location Details",
        new: "New",
        blendsheetFeatureCategory: "Blendsheets",
        createdByNotification: "Blendsheet created by",
        updatedByNotification: "Blendsheet Updated by",
        deletedByNotification: "Blendsheet deleted by",
        blendSheetDeleted: "Blend Sheet deleted successfully.",
        notificationSendSuccess: "Notification Send Successfully",
        deleteErrorWithQuote: "This sample can not be deleted as it has a quote/blendsheet associated.",
        auditLogCreated: "Audit log successfully created",
        blendSheetSentToQM: "BlendSheet Send to Quality Manager",
        blendSheetSentForApproval: "BlendSheet Send For Approve/Reject",
        pendingWithQM: "Pending With Quality Manager",
        pendingWithPM: "Pending With Production Manager",
        rejectedBy: "Rejected By",
        approved: "Approved",
        rejected: "Rejected",
        blendSheetCreated: "Blend Sheet Created successfully",
        blendSheetInfo: "Blend Sheet Information",
        phyApperance: "Physical Apperance",
        density: "Density",
        ph: "PH",
        solubilityHot: "Solubility In Hot Water",
        solubilityCold: "Solubility In Cold Water",
        sediment: "Sediment",
        particleSizeDist: "Particle Size Distribution",
        caffeine: "Caffeine",
        ash: "Ash",
        sensoryProfile: "Sensory Profile",
        totalPlateCount: "Total Plate Count",
        yeastMould: "Yeast & Mould",
        coliform: "Coliform",
        ecoli: "E-Coli",
        solmonella: "Solmonella",
        storageConditions: "Storage Conditions",
        productCategory: "Product Category",
        changeProductionAS: "Production Alternative Sample Changed",
        wantToChangeProductionAS: "Do you want to change production Alternative Sample",
        powderRequiredKgs: "Powder Required (KGS)",
        item: "Item",
        percentage: "Percentage",
        parameterName: "Parameter Name",
        parameterValue: "Parameter Value",
        addParameter: "Add Parameter",
        orderDispatchNumber: "OD Number",
        searchQuotedAS: "Search for Quoted Alternative Sample Code...",
        searchProductionAS: "Search for Production Alternative Sample Code ...",
        productSpecifications: "Product Specifications",
        addParameters: "Add Parameters",
        previous: "Previous",
        create: "Create",
        percentError: "Total percentage of Green Coffee Items must be 100%",
        blendSheetUpdated: "Blend Sheet updated successfully",
        totalPercentageError: "The percentage of the sum of all green coffee items should be 100.",
        percentageZeroError: "percentage of Green Coffee Item cannot be 0",
        maxAllowedMsg: "Maximum allowed:",
        updateGC: "Please update green coffee items to add location and then hit save.",
        errorCheckingProductionQty: "Error checking total production quantity:",
        pendingApproval: "Pending for Approval",
        pendingWithStores: "Pending With Stores",
        blendSheetSentToGCStores: "BlendSheet Send To Pending With GCStores",
        location: "Location",
        siloNo: "Silo No.",
        mrin_no: "MRIN No",
        bin_name: "BIN Name",
        mrin_quantity: "MRIN Quantity",
        referenceMRIN: "Reference MRIN/LOT",
        parameter: "Parameter",
        value: "Value",
        inventoryError: "Inventory not Found for this MRIN items.",
        sumOfRequiredQuantity: "Sum of Required Quantity should be ",
        sumOfRequiredQuantityTooltip: "Sum of Required Quantity:",
        sumOfRequiredQuantityToProceed: " to Proceed",
        tableHeaderTooltip: "Value Should Not Greater Than Available Quantity.",
        submitBackToGCStores: "Submit back to GC Stores",
        inventoryNotAvailable: "Inventory Not Available",
        mrinInventoryDetails: "MRIN Inventory Details",
        itemCode: "Item Code",
        item_name: "Item Name",
        coffee_type: "Item Type",
        typeOfGreenCoffee: "Type of Green Coffee",
        beansQuantityMT: "Beans Quantity (MT)",
        beansQuantityMtTooltip: "Beans Quantity (KGS) / 1000",
        beansQuantityKG: "Beans Quantity (KGS)",
        beansQuantityKgTooltip: "Powder Required (KGS) x Conversion Ratio x Percentage",
        beansQuantityGm: "Beans Quantity (GMS)",
        beansQuantityGmTooltip: "Beans Quantity (KGS) x 1000",
        conversion_ratio: "Conversion Ratio",
        mrinDetails: "MRIN Details",
        itemDetails: "Item Details",
        mrinBlendsheetUsage: "MRIN Blend Sheet Usage",
        committed: "Committed",
        subLocationInventory: "Sub Location Inventory",
        mainEntityInventoryNote: "Note: Only the Main Entity Inventory will be visible and can be selected here.",
        blendSheetUpdated: "Blend Sheet updated successfully",
        blendsheetInventoryDeleted: "Deleted MRIN Inventory Record successfully",
        inventoryList: "Inventory List",
        mrinList: "MRIN List",
        retriggeredToNetsuite: "Record Retriggered to netsuite successfully",
        netsuiteRetriggered: "Netsuite Re-triggered",
        maximumAllowed: "Maximum allowed: ",
        powderRequiredMtTooltip: "Powder Required (KGS) / 1000",
        netsuiteResponse: "Netsuite Response:",
        productionSchedule: "Production Schedule",
        recordId: "PS Record",
        plannedQuantity: "Planned Quantity",
        quantity: "OD Quantity",
        psNumber: "Record Number",
        startDate: "Start Date",
        endDate: "End Date",
        productionQuantity: "Production Quantity",
        balanceQuantity: "Balance Quantity",
        expectedProductionPercentage: "Expected Production %",
        expectedProductionPercentagePsTooltip: "Production Quantity / Order Dispatch's Production Quantity (KGS) x 100",
        expectedProductionPercentageMainTooltip: "Production Quantity (KGS) / Powder Required (KGS) x 100",
        actualProductionQuantity: "Actual Production Quantity",
        total: "Total",
      },
      view: {
        batch_number: "Batch Number",
        blend: "Blend",
        entity_name: "Entity",
        powder_required: "Powder Required (MT)",
        powder_required_kgs: "Powder Required (kgs)",
        gc_requirement: "Green Coffee Requirement (MT)",
        status_name: "Status",
        created_by: "Created By",
        approved_by: "Approved By",
        customer: "Customer",
        alternative_sample: "Alternative Sample",
        order_dispatch: "Order Dispatch",
        dispatch_date: "Dispatch Date",
        quote_line_item: "Quote Line Item",
        total_od_quantity_kgs: "Total OD Quantity(KGS)",
        produced_quantity_kgs: "Produced Quantity(KGS)",
        balance_quantity_kgs: "Balance Quantity(KGS)",
        production_quantity_kgs: "Production Quantity(KGS)",
        expected_production_quantity_percentage: "Expected Production Quantity Percentage",
        expected_production_quantity_perc: "Expected Production Quantity(%)",
        actual_production_quantity: "Actual Production Quantity",
        workorder_number: "Work Order Number",
        entity: "Entity",
        total_quantity: "Total Quantity",
        sfg_name: "SFG Name",
        status: "Status",
        bin_number: "Bin Number",
        item_number: "Item Number",
        produced_quantity: "Produced Quantity",
        serial_lot_number: "Serial Lot Number",
        item_name: "Item Name",
        item_code: "Item Code",
        item_quantity: "Item Quantity",
        bin_details: "Bin Details",
        dispense_information: "Dispense Information",
        lot_number: "Lot Number",
        allocated_quantity: "Allocated Quantity",
        quantity_dispensed: "Quantity Dispensed",
        issued_quantity: "Issued Quantity",
        production_start_date: "Production Start Date",
        set_quantity: "Set Quantity",
        damper_name: "Damper Name",
        damper_on_time: "Damper On Time",
        damper_off_time: "Damper Off Time",
        production_end_date: "Production End Date",
        pending_quantity: "Pending Quantity",
        gc_type: "Type of Green Coffee",
        beans_quantity_mt: "Beans Quantity (MT)",
        beans_quantity_kgs: "Beans Quantity (KGS)",
        conversion_ratio: "Conversion Ratio",
        percentage: "Percentage",
        location: "Location*",
        BinName: "Bin Name",
        siloNo: "Silo No.",
        mrin_no: "MRIN No",
        referenceMRIN: "Reference MRIN/LOT",
        alternative_sample_code: "Alternative Sample Code",
      },
      grid: {
        batch_number: "Batch Number",
        blend: "Blend",
        entity_name: "Entity",
        powder_required: "Powder Required (MT)",
        powder_required_kgs: "Powder Required (kgs)",
        gc_requirement: "Green Coffee Requirement (MT)",
        status_name: "Status",
        created_by: "Created By",
        approved_by: "Approved By",
      },
      orderDispatchGrid: {
        account_name: "Customer",
        alternative_sample_code: "Alternative Sample",
        order_dispatch_number: "Order Dispatch",
        dispatch_date: "Dispatch Date",
        quote_line_item_number: "Quote Line Item",
        total_order_diaptch_quantity: "Total OD Quantity(KGS)",
        produced_quantity: "Produced Quantity(KGS)",
        balance_quantity: "Balance Quantity(KGS)",
        production_quantity: "Production Quantity(KGS)",
      },
      orderDispatchGridNewExtra: {
        expected_production_quantity_percentage: "Expected Production Quantity Percentage",
      },
      orderDispatchGridApprovedExtra: {
        expected_production_quantity_percentage: "Expected Production Quantity(%)",
        actual_production_quantity: "Actual Production Quantity",
      },
      consumableItemsGrid: {
        item_code: "Item Code",
        gc_type: "Type of Green Coffee",
        beans_quantity: "Beans Quantity (MT)",
        beans_quantity_kgs: "Beans Quantity (KGS)",
        conversion_ratio: "Conversion Ratio",
        percentage: "Percentage",
        bin_name: "Bin Name",
        mrin_no: "MRIN No",
      },
      workOrderGrid: {
        workorder_number: "Work Order Number",
        entity: "Entity",
        total_quantity: "Total Quantity",
        sfg_name: "SFG Name",
        status: "Status",
        bin_number: "Bin Number",
        item_number: "Item Number",
        produced_quantity: "Produced Quantity",
        serial_lot_number: "Serial Lot Number",
      },
      itemInfoGrid: {
        item_name: "Item Name",
        item_code: "Item Code",
        item_quantity: "Item Quantity",
        bin_details: "Bin Details",
        dispense_information: "Dispense Information",
      },
      inventoryBinDetailsGrid: {
        lot_number: "Lot Number",
        bin_number: "Bin Number",
        allocated_quantity: "Allocated Quantity",
      },
      inventoryDispenseInfoGrid: {
        bin_number: "Bin Number",
        quantity_dispensed: "Quantity Dispensed",
        issued_quantity: "Issued Quantity",
        production_start_date: "Production Start Date",
        set_quantity: "Set Quantity",
        dam_name: "Damper Name",
        dam_on_time: "Damper On Time",
        dam_off_time: "Damper Off Time",
        production_end_date: "Production End Date",
        pending_quantity: "Pending Quantity",
        status: "Status",
      },
      categoryPicklist: {
        All: "All",
        Export: "Export",
        Domestic: "Domestic",
      },
      prodreq1Grid: {
        powder_required: "Powder Required (MT)",
        powder_required_kgs: "Powder Required (KGS)",
        ffbd: "FFBD GR/CC",
        moisture: "Moisture",
        remarks: "Remarks",
      },
      prodreq2Grid: {
        gc_requirement: "Green Coffee Requirement (MT)",
        roast_colour: "Roast Color",
        colour: "Color",
        product: "Product",
        aroma: "Aroma",
      },
      blendinfo1Grid: {
        serial_number: "Serial Number",
        entity_name: "Entity",
        netsuite_id: "NetSuite Id",
      },
      blendinfo2Grid: {
        batch_number: "Batch Number",
        blend: "Alternative Sample",
        netsuite_response: "Netsuite Response",
      },
      finalconsum1Grid: {
        arabica_quantity: "Arabica (MT)",
      },
      finalconsum2Grid: {
        robusta_quantity: "Robusta (MT)",
      },
      mrinUsageGrid: {
        batch_number: "Batch Number",
        entity_name: "Entity",
        item_code: "Item Code",
        item_name: "Item Name",
        allocated_quantity: "Allocated Quantity",
        status: "Status",
      },
      parameterOptionsGrid: {
        "Physical Apperance": "Physical Apperance",
        "Density": "Density",
        "Color": "Color",
        "Moisture": "Moisture",
        "PH": "PH",
        "Solubility In Hot Water": "Solubility In Hot Water",
        "Solubility In COLD Water": "Solubility In Cold Water",
        "Sediment": "Sediment",
        "Particle Size Distribution": "Particle Size Distribution",
        "Caffeine": "Caffeine",
        "Ash": "Ash",
        "Sensory Profile": "Sensory Profile",
        "Total Plate Count": "Total Plate Count",
        "Yeast & Mould": "Yeast & Mould",
        "Coliform": "Coliform",
        "E-Coli": "E-Coli",
        "Solmonella": "Solmonella",
        "Storage Conditions": "Storage Conditions",
      },
      inventoryMRINCols: {
        mrin_no: "MRIN No",
        location: "Location",
        bin_name: "Bin Name",
        quantity: "MRIN Quantity",
        quantity_on_hand: "Quantity On Hand",
        available: "Available Quantity",
        allocated_quantity: "Allocated Quantity",
        committed: "Committed Quantity",
        netsuite_response: "Netsuite Response",
      },
      inventoryMRINColsView: {
        mrin_no: "MRIN No",
        bin_name: "Bin Name",
        quantity: "MRIN Quantity",
        quantity_on_hand: "Quantity On Hand",
        available: "Available Quantity",
        quantity_allocated: "Allocated Quantity",
        committed: "Committed Quantity",
        netsuite_response: "Netsuite Response",
      },
      mrinSubLocationCols: {
        mrin_no: "MRIN No",
        item_code: "Item Code",
        item_name: "Item Name",
        location_name: "Location",
        bin_name: "Bin Name",
        quantity: "MRIN Quantity",
        quantity_on_hand: "Quantity On Hand",
        available: "Available Quantity",
        committed: "Committed Quantity",
        netsuite_response: "Netsuite Response",
      },
    },
    certification: {
      forms: {
        certification: "Certificate",
        createCertification: "Create Certificate",
        certifications: "Certifications",
        expired: "Expired",
        certification_body: "Certification Body",
        country: "Country",
        addCertificationBody: "Add Certification Body",
        next_audit_date: "Next Audit Due*",
        add: "+ Add",
        issue_date: "Issue Date*",
        expiry_date: "Expiry Date*",
        certificateSuccess: "Certificate Created Successfully",
        certificationBodySuccess: "Certification Body Added Successfully",
        certificateUpdationSuccess: "Certificate Updated Successfully",
      },
      grid: {
        location: "Location",
        type_of_certification: "Type Of Certification",
        certification_name: "Certification Body",
        issued_date: "Issued Date",
        expiry_date: "Expiry Date",
        alert_initation_date1: "First Alert Initiation Date",
        alert_initation_date2: "Second Alert Initiation Date",
        status: "Status",
        expired: "Expired",
        attachments_count: "Attachment",
        doc_name: "",
      },
      view: {
        location: "Location",
        certification_body: "Certification Body",
        comments: "Comments",
        type_of_certification: "Type of Certification",
        status: "Status",
        issued_date: "Issue Date",
        next_audit_date: "Next Audit Due",
        expiry_date: "Expiry Date",
        alert_initation_date: "Alert Initation Date",
        doc_name: "Certification Document",
        download: "Download",
        certification_id: "Certification Id",
      },
      sections: {
        system_info: "System Information",
        cert_uploaded_versions: "Certificate Uploaded versions"
      }
    },
    batchOutput: {
      forms: {
        batchOutput: "Batch Output",
        createBatchOutput: "Create Batch Output",
        alternative_sample_id: "Alternative Sample Id",
        alternative_sample_code: "Alternative Sample Code",
        remarks: "Remarks",
        batch: "Batch",
        serial_number: "Serial Number",
        alternativeSampleSelectionError: 'Please select the alternative sample code before Creating the BatchOuput.',
        blendSheetSelectionError: "Please select the Blend Sheet before Creating the BatchOuput.",
        batchNumberRequired: "Batch number is required",
        alternativeSampleIdRequired: "Alternative sample id is required",
        createdSuccess: "Batch Output Created Successfully",
        updatedSuccess: "Batch Output updated Successfully",
        sampleRemarks: "Sample Remarks",
        recordId: "Record Id",
        batchDetails: "Batch Details",
        sampleDetails: "Sample Details",
        category: "Category",
        batchNumber: "Batch Number",
        powderRequired: "Powder Required",
        entity: "Entity",
        workOrderNumber: "Work Order Number",
        producedQuantity: "Produced Quantity",
        quotesAlternativeSample: "Quoted Alternative Sample",
        masterSample: "Master Sample",
        productionCapacity: "Production Capacity",
        theoreticalYield: "Theoretical Yield",
        productionAlternativeSample: "Production Alternative Sample",
        productType: "Product Type",
        theoreticalYieldRatio: "Theoretical Yield Ratio",
        dateOfProduction: "Date of Production",
        actualYieldRatio: "Actual Yield Ratio",
        actualYield: "Actual Yield",
        reasonYieldVariation: "Reason for Yield Variation",
        others: "Others",
        submitToQuality: "Submit to Quality",
        addParameter: "Add Parameters",
        createPopUpHeader: "Select Category",
        parameters: "Parameters",
        otherApplicableParameters: "Other applicable parameters",
      },
      view: {
        alternative_sample_id: "Sample Id",
        alternative_sample_code: "Sample Code",
        alternative_sample_yield: "Theoretical Yield",
        alternative_sample_yield_ratio: "Theoretical Yield Ratio",
        alternative_sample_remarks: "Sample Remarks",
        batch_number: "Batch Number",
        serial_number: "Serial Number",
        customer_name: "Customer Name",
        entity_name: "Entity",
        master_sample_code: "Master Sample Code",
        master_sample_id: "Master Sample Id",
        record_id: "Batch Output Number",
        actual_yield: "Actual Yield",
        date_of_production: "Date of Production",
        work_order: "Work Order",
        actual_yield_ratio: "Actual Yield Ratio",
        product_category: "Product Category",
        reason_yield_variation: "Reason for Yield Variation",
        others: "Others",
        paramerterDetails: "Parameter Details",
        status: "Status",
        approved_by: "Approved By",
        rejected_by: "Rejected By",
        approved_date: "Approved Date",
        rejected_date: "Rejected Date",
      },
      sections: {
        batchOutputInfo: "Batch Output Information",
        alternativeSampleInfo: "Alternative Sample Information",
        blendSheetInfo: "Blend Sheet Information",
        masterSampleInfo: "Master Sample Information",
        alternativeSamples: "Alternative Samples",
        blend: "Blend",
        batchOutput: "Batch Output"
      },
      statuses: {
        new: "New",
        pendingWithQuality: "Pending with Quality",
        approved: "Approved",
        rejected: "Rejected",
      },
      details: [
        {
          header: "Batch Output Information",
          fields: {
            record_id: "Batch Output Record",
            category: "Category",
            entity: "Entity",
            batch_number: "Batch Number",
            work_order_number: "Work Order",
            powder_required: "Powder Required(Kgs)",
            produced_quantity: "Produced Quantity(Kgs)",
          },
        },
        {
          header: "Alternative Sample Information",
          fields: {
            quoted_alternative_sample: "Quoted Alternative Sample",
            production_alternative_sample: "Production Alternative Sample",
            master_sample: "Master Sample",
            product_type: "Product Type",
            production_capacity: "Production Capacity(MT)",
            sample_remarks: "Sample Remarks",
            theoretical_yield: "Theoretical Yield",
            theoretical_yield_ratio: "Theoretical Yield Ratio",
          },
        },
        {
          header: "Batch Output",
          fields: {
            date_of_production: "Date of Production",
            actual_yield: "Actual Yield",
            actual_yield_ratio: "Actual Yield Ratio",
            reason_for_yield_variation: "Reason for Yield Variation",
          },
        },
      ],
      grid: {
        id_sno: "Batch Output Number",
        batch_number: "Batch Number",
        alternative_sample_code: "Alternative Sample Code",
        product_category: "Product Category",
        date: "Date Of Production",
        alternative_sample_yield: "Theoretical Yield",
        actual_yield: "Actual Yield",
        alternative_sample_yield_ratio: "Theoretical Yield Ratio",
        actual_yield_ratio: "Actual Yield Ratio",
        remarks: "Reason for Yield variations",
      },
      parameters: {
        acrylamide: "Acrylamide",
        ota: "OTA",
        pesticides: "Pesticides",
        eto: "ETO",
      },
      paramColumns: {
        parameters: "Parameters",
        isPerformed: "Is Performed",
        result: "Result"
      }
    }
  },
  finance: {
    financeCosting: {
      forms: {
        updateFCSuccess: "Finance Costing Updated Successfully",
        createDate: "Creation Date",
        category: "Category",
        financialYear: "Financial year",
        productSubType: "Product Sub Type",
        productionUnit: "Production Unit",
        quarter: "Quarter",
        packingUnit: "Packing Unit",
        productType: "Product Type",
        packingCategory: "Packing Category",
        packingSubType: "Packing Sub-Type",
        packingMode: "Packing Mode",
        weight: "Weight(Gms)",
        upc: "UPC",
        capType: "Cap Type",
        processCost: "Process Cost",
        conversionCost: "Conversion Cost",
        packingLabourCost: "Packing Labour Cost",
        packingSubTypeError: "This packing category has no packing sub type",
        FCAlreadyExist: "Finance Costing record already exist",
        errorFetchPackingMode: "Error fetching packing modes:",
        errorFetchFinancialYear: "Error fetching financial years:",
        errorProductSubType: "Error fetching product subtypes",
        errorProductionUnit: "Error fetching production units",
        errorFetchQuarter: "Error fetching quarters:",
        errorFetchPackingUnit: "Error fetching packing units:",
        errorFetchPackingCategory: "Error fetching packing categories:",
        errorFetchPackingSubType: "Error fetching packing sub types:",
        errorFetchPackingDetails: "Error fetching packing details:",
        fcFormCreateError: "Error creating finance costing record:",
        fcFormUpdateError: "Error updating finance costing record:",
        failToFetchFC: "Failed to fetch FC details:",
        errorFetchProductType: "Error fetching product type list:",
        errorCheckExistingFC: "Error checking existing FC:",
        quoteCategory: "Quote Category",
      },
      view: {
        createFC: "Create Finance Costing",
        createPopUpHeader: "Select Category Type",
        FC: "Finance Costing",
        FCInfo: "Finance Costing Information",
        FCDetails: "Finance Costing Details",
        packingDetails: "Packing Details",
        costingInfo: "Costing Information",
        confirmation: "Confirmation",
        confirmMsg: " Are you sure you want to expire this cost record? This action cannot be undo.",
        expireConfirmExport: "Do you want to clone this Finance costing record ?",
        incomplete: "incomplete",
        inprogress: "inprogress",
        PendingWithFactoryManagerPacking: "Pending With Factory Packing Manager",
        completed: "completed",
        LabelCompleted: "Completed",
        New: "New",
        expired: "Expired",
        PendingWithPackingTeam: "Pending with Packing Team",
      },
      grid: {
        record_id: "Record Number",
        packing_category: "Packing Category",
        packing_mode: "Packing Mode",
        packing_unit: "Packing Unit",
        production_unit: "Production Unit",
        product_type: "Product Type",
        financial_year: "Financial Year",
        quarter: "Quarter",
        process_cost: "Process Cost",
        conversion_cost: "Conversion Cost",
        packing_labour_cost: "Packing Labour Cost",
        status: "Status",
      },
    }
  },
  CRM: {
    Home: {
      reports: "Reports",
      comingSoon: "Coming Soon ...",
      greenCoffeeDashboard: "Green Coffee Dashboard",
      inventoryStatusDashboard: "Inventory Status Dashboard",
      salesDashboard: "Sales Dashboard",
      salesAnalysisDashboard: "Sales Analysis Dashboard",
      capacityCalendarDashboard: "Capacity Calender Dashboard",
      gcAllocationDashboard: "GC Allocation Dashboard",
      gcReceiptsDashboard: "GC Receipts Dashboard",
      gcPendingDashboard: "GC Pending Dashboard",
      gcLogisticsDashboard: "GC Logistics Dashboard",
      executiveDashboard: "Executive Dashboard",
      costAnalysis: "Cost Analysis",
      purchaseReportTop15Items: "Purchase Report (Top 15 Items)",
      standupDashboard: "Standup Dashboard",
      commercialDashboard: "Commercial Dashboard",
      gcStoresDashboard: "GC Stores Dashboard",
      inventoryAvailableQty: "Inventory Available Quantity",
      salesOrderDetailsDashboard: "Sales Order Details Dashboard",
      inventorySummaryReport: "Inventory Summary Report",
      salesOrderDashboard: "Sales Order Dashboard",
      scmDashboard: "SCM Dashboard",
      orderDispatchStatusTracker: "Order Dispatch Status Tracker",
      order_schedule_qty_report: "Order Schedule Quantity Report",
      fixed_consumption_report : "Fixed Consumption Report",
      soft_schedule_report : "Soft Schedule Report",
      gcMRINQualityCheckDashboard: "GC MRIN Quality Check",
      gcReceipts_consumption_dashboard: "GC Receipts & Consumption Dashboard",
      exportLogisticsDashboard: "Export Logistics Dashboard",
      gcConsumptionDashboard: "GC Consumption Dashboard",
      packingMaterialReceiptDashboard: "Packing Material Receipt Dashboard",
      logisticPaymentAndDetailsReport: "Logistic Payment and Details Report",
      quoteVsAllocateVsConsumedPriceDashboard: "Quote Vs Allocate Vs Consumed Price",
      gcFinanceBudgetReport: "GC Finance Budget Report",
      gcApprovedQuotesDashboard: "GC Approved Quotes Dashboard",
      gcSiloDispensingWorkOrderReport: "GC Silo Dispensing Work Order Report",
      quoteStatusTracker: "Quote Status Tracker",
    },
    Lead: {
      forms: {
        domestic: "Domestic",
        leads: "Leads",
        createLead: "Create Lead",
        existError: "Lead Name already exists",
        leadCreated: "Lead created successfully",
        customerName: "Customer Name",
        contactName: "Contact Name",
        country: "Country",
        charExceedError: "You have exceed the limit of 100 characters",
        leadForCompany: "Lead for Company",
        leadName: "Lead Name",
        aliasesName: "Aliases Name",
        accountType: "Account Type",
        website: "Website",
        productSegment: "Product Segment",
        annualTurnOver: "Annual turn over ($)",
        category: "Category",
        salutation: "Salutation",
        firstName: "First Name",
        lastName: "Last Name",
        email: "Email",
        designation: "Designation",
        ext: "Ext",
        phone: "Phone",
        mobile: "Mobile",
        instantCoffeeBusiness: "Instant Coffee Business",
        manufacturingUnit: "Manufacturing Unit",
        coffeeType: "Coffee Type",
        sampleReady: "Sample Ready",
        otherInformation: "Other Information",
        address1: "Address1",
        address2: "Address2",
        state: "Province/State",
        city: "City",
        postalCode: "Postal Code",
        sameAsBilling: "Same as Billing",
        shippingContinent: "Shipping to Continent",
        shippingCountry: "Shipping to Country",
        registrationType: "Registration Type",
        panNumber: "PAN Number",
        taxRegistrationNumber: "Tax Registration Number",
        leadInfo: "Leads Information",
        contactInfo: "Contacts Information",
        profileCompletion: "Profile Completion",
        billingAddress: "Billing Address",
        shippingAddress: "Shipping Address",
        shippingDetails: "Shipping Details",
        taxRegistration: "Tax Registration",
        contact: "Contact",
        leadOwner: "Lead Owner",
        selectUser: "Select users to assign",
        userSelection: "Select User",
        comments: "Comments",
        leadUpdated: "Lead updated successfully",
        reassignUser: "Please select a user to reassign",
        reassignSuccess: "Lead reassigned successfully",
        accountName: "Account Name",
        accountOwner: "Account Owner",
        approvalStatus: "Approval Status",
        accountExistWarning: " Account is already exist ",
        contactExistWarning: " Contact is already exist, upon approval it will allow for the conversion ",
        accountCreate: "Click on Proceed button to create Account.",
        leadDetails: "Lead Details",
        leadConversion: "Lead Conversion",
        accountExists: "Lead Conversion is not possible as the account already exists.",
        approveReject: "Approve / Reject",
        convertToAccount: "Convert to Account",
        reAssign: "Re-Assign",
        pendingWithGnrlDirector : "Pending with General Director",
        accountCreatedWithCmnts: "Account created with comments",
        rejectedWithCmnts: "Rejected with comments",
        accountCreated:"Account Created",
        approved: "Approved", 
      },
      view: {
        grid: {
          account_name: "Lead Name",
          aliases: "Aliases",
          contact_first_name: "First Name",
          contact_last_name: "Last Name",
          created_by_user_name: "Lead Owner Name",
          lead_score: "Profile Completion",
          master_status: "Status",
          attachments_count: "Attachments",
        },
      },
    },
    Account: {
      forms: {
        Accounts: "Accounts",
        firstName: "First Name",
        lastName: "Last Name",
        email: "Email",
        quoteNumber: "Quote Number",
        status: "Status",
        createdBy: "Created By",
        createdDate: "Created Date",
        accountName: "Account Name",
        accountType: "Account Type",
        aliases: "Aliases",
        phone: "Phone",
        email: "Email",
        fax: "Fax",
        website: "Website",
        turnover: "Annual approx. turnover($)",
        product_segment: "Product Segment",
        address1: "Address1",
        address2: "Address2",
        country: "Country",
        state: "Province/State",
        city: "City",
        postalCode: "Postal Code",
        alreadyInBusiness: "Already in instant coffee business?",
        haveUnit: "Do you have instant coffee manufacturing unit?",
        typeInterested: "Coffee type interested in?",
        otherInformation: "Other Information",
        shippingContinent: "Shipping to continent",
        shippingCountry: "Shipping to country",
        amountDue: "Amount Due",
        dueDate: "Due Date",
        accountStatus: "Account Status",
        status: "Status",
        invoiceDate: "Invoice Date",
        age: "Age",
        registrationType: "Registration Type",
        panNumber: "Pan Number ",
        taxNumber: "Tax Registration Number ",
        assignTo: "Select users to assign",
        reAssign: "Re-Assign",
        pendingSamples: "Pending Samples",
        approvedSamples: "Approved Samples",
      },
      sections: {
        accountsInfo: "Accounts Information",
        accountInfo: "Account Information",
        contactInfo: "Contact Information",
        sampleRequestInfo: "Sample Request Information",
        allCustomerSamples: "All Customer Samples",
        allocationInfo: "Allocation Information",
        customerSamples: "Customer Samples",
        finished_goods: "Finished Goods",
        quoteInfo: "Quote Information",
        billingAddress: "Billing Address",
        shippingAddress: "Shipping Address",
        profileCompletion: "Profile Completion",
        shippingInfo: "Shipping Information",
        pricingInfo: "Pricing Information",
        taxRegistration: "Tax Registration",
        taxInfo: "Tax Information",
      },
      allocationList: {
        record_id: "Item Code",
        quote_number: "Short Code",
        pono: "Item Name",
        item_name: "Item Category",
        allocated_quantity: "Allocated Quantity",
        groupname: "Group Name",
        show_in_po: "Show in PO",
        coffee_type: "Item Type",
        attachments_count: "Attachments",
        allocation_record_no: "Allocation Record No",
        quote_no: "Quote No",
        quote_line_number: "Quote Line Number",
        ponumber: "PO No",
        allocated_qty: "Allocated Qty"
      },
      customerSampleList: {
        customer_sample_code: "Customer Sample Code",
        sample_name: "Sample Name",
        product: "Product",
        category: "Category",
        customer_name: "Customer Name",
        remarks: "Remarks",
        sampleDate: "Sample Date",
        createdDate: "Created Date",
        status: "Status"
      },
      view: {
        customerSampleDataFailed: "Failed to load Customer Sample Data",
        selectUserToResign: "Please select a user to reassign",
        accountReassignSuccess: "Account reassigned successfully",
        account_owner: "Account Owner",
        account_type: "Account Type",
        phone: "Phone",
        mobile: "Mobile",
        fax: "Fax",
        approxAnnualTurnover: "Approx. annual turnover ($) ",
        account_name: "Account Name",
        netsuite: "NetSuite ID",
        netsuiteResponse: "NetSuite ID Response",
        aliases: "Aliases",
        email: "Email",
        website: "Website",
        productSegment: "Product Segment",
        grid: {
          account_name: "Account Name",
          aliases: "Aliases",
          account_type_names: "Account Type",
          account_owner: "Account Owner",
          master_status: "Approval Status",
          attachments_count: "Attachments",
          sample_code: "Sample Code",
          product_type: "Product Type",
          sample_created_by: "Sample Created By",
          sample_created_date: "Sample Created Date",
          quote_number: "Quote Number",
          quote_created_by: "Quote Created By",
          quote_created_date: "Quote Created Date",
          created_date: "Account Created Date",
          age_in_days: "Age(in days)",
        },
      },
    },
    Contacts: {
      forms: {
        Contacts: "Contacts",
        allContacts: "All Contacts",
        myContacts: "My Contacts",
        address1: "Address1",
        address2: "Address2",
        country: "Country",
        state: "Province/State",
        city: "City",
        postal_code: "Postal Code",
        billing_primary: "Is Primary Billing Address",
        billing_details: "Billing Details",
        shipping_primary: "Is Primary Shipping Address",
        shipping_details: "Shipping Details",
        account_name: "Account name",
        salutation: "Salutation",
        first_name: "First name",
        last_name: "Last name",
        email: "Email",
        position: "Position",
        phone_ext: "Ext",
        phone: "Phone",
        mobile_ext: "Ext",
        mobile: "Mobile",
        current_sales_no: "Current sales number",
        past_sales_no: "Past sales number",
        createContact: "Create Contact",
        streetError: "Street name cannot exceed 100 characters.",
        addressError: "Address1 cannot exceed 100 characters.",
        contactUpdated: "Contact updated successfully",
        contactCreated: "Contact created successfully",
      },
      view: {
        address1: "Address1",
        address2: "Address2",
        country: "Country",
        primary_address: "Primary Address",
        state: "State",
        city: "City",
        postal_code: "Postal Code",
        billing_info: "Billing Information",
        shipping_info: "Shipping Information",
        salutation: "Salutation",
        contact_owner: "Contact owner",
        first_name: "First name",
        last_name: "Last name",
        email: "Email",
        mobile: "Mobile",
        phone: "Phone",
        past_sales_no: "Past sales number",
        current_sales_no: "Current sales number",
        billing_id: "Billing Id",
        billing_city: "Billing City",
        billing_country: "Billing Country",
        billing_state: "Billing State",
        billing_street: "Billing Street",
        billing_postal_code: "Billing Postal Code",
        shipping_id: "Shipping Id",
        shipping_city: "Shipping City",
        shipping_country: "Shipping Country",
        shipping_state: "Shipping State",
        shipping_street: "Shipping Street",
        shipping_postal_code: "Shipping Postal Code",
        contactDetails: "Contact Details"
      },
      sections: {
        contactInfo: "Contact information",
        billingInfo: "Billing information",
        shippingInfo: "Shipping information",
        contactInformation: "Contacts Information",
        billingAddress: "Billing Address",
        shippingAddress: "Shipping Address",
        auditLog: "Audit Log",
        attachments: "Attachments"
      },
      grid: {
        account_name: "Account Name",
        contact_first_name: "First Name",
        contact_last_name: "Last Name",
        contact_email: "Email",
        phone: "Phone",
        attachments_count: "Attachment",
      }
    },
    SampleRequest: {
      forms: {
        sampleRequest: "Sample Request",
        sampleRequestInfo: "Sample Request Information",
        entity: "Entity",
        recordType: "Record Type",
        accountName: "Account name",
        contactName: "Contact name",
        shippingAddress: "Shipping address",
        contact_number: "Phone No",
        mobileNo: "Mobile No",
        sampleRequestDate: "Sample Request date",
        category: "category",
        remarks: "Remarks",
        timeForSubmission: "Time For Submission",
        requestSample: "Request Sample",
        sampleCreated: "Sample created successfully",
        sampleItemCreated: "Sample line item created successfully",
        sampleRequestCreateAuditField: "Sample Request Create",
        sampleLineItemCreateAuditField: "Sample Line Item Create",
        sampleLineRdDetailsCreateAuditField: "Sample Details R&D Create",
        productInfo: "Product Information",
        productType: "Product Type",
        productDescription: "Product Description",
        blendComposition: "Blend Composition",
        blendRatio: "Blend Ratio(A/R)",
        priceRange: "Price Range",
        currency: "Currency",
        targetCountry: "Target Country",
        clientRequirements: "Client Requirements",
        remarks: "Remarks",
        regulatoryRequirements: "Regulatory Requirements",
        certificationRequirements: "Certification Requirements",
        noProductSpecifications: "No product specifications have been added yet.",
        packingCategory: "Packing Category",
        packingSubType: "Packing Sub Type",
        packingMode: "Packing Mode",
        weight: "Weight (Gms/Kgs)",
        upc: "UPC(Unit Per Carton)",
        evaluationProcedure: "Evaluation Procedure",
        description: "Description",
        packingType: "Packing Type",
        grammage: "Grammage",
        comments: "Comments",
        quantity: "Quantity",
        createdDate: "Created Date",
        requestSampleItem: "Request Sample Item",
        revisionsPrototypes: "If There Are Revisions To The Prototype, Please Specify The Tweaks Suggested By The Client For The Submitted Prototype",
        addNew: "Add New",
        proceed: "Proceed",
        endProductSKU: "End Product SKU",
        evaluationSampleSize: "Evaluation Sample Size",
        productSpecification: "Product Specification",
        dataSaving: "data is saving, please wait...",
        clientRequirementExists: "Client Requirment is already selected",
        revisionsRevised: "If there are revisions to the prototype, please specify the tweaks suggested by the client for the submitted prototype",
        new: "New",
        pendingWithQC: "Pending with QC",
        approved: "Approved",
        status: "Status",
        requestedType: "Requested Type",
        requestType: "Request Type",
        sampleRequested: "Sample requested successfully",
        sampleUpdated: "Sample updated successfully",
        customerFeedback: "Customer Feedback",
        resubmit: "Resubmit",
        sampleDetailsRD: "Sample Details R&D",
        trackingDetails: "Tracking Details",
        sampleAndTrackingDetails: "Sample Details R&D &  Tracking Details",
        carrierName: "Carrier Name",
        trackingNumber: "Tracking Number",
        dispatch_date: "Dispatch Date",
        resubmitted: "Re-Submitted",
        srNo: "SR No",
        customerApproval: "Customer Approval",
        carrierTrackingRequired: "Please Enter Value In Carrier Name & Tracking Number for Dispatched",
        rdDetailsPendingForDispatch: "Please provide the latest Sample Details R&D / Tracking Details before dispatching",
        recordNumber: "Record Number",
        customerFeedbackCol: "Customer FeedBack",
        sampleLineItemNumber: "Sample Line Item Number",
        sampleCodeRDCol: "Sample Code R&D",
        productTypeRDCol: "Product Type R&D",
        productTypeRDRemarksCol: "Product Type R&D Remarks",
        resubmittedCol: "Re-Submitted",
        warning: "Warning!",
        sampleLineItemCreated: "Sample Line Item Created Successfully",
        submitToRD: "Submit to R&D",
        sampleCodeRD: "Sample Code R&D",
        productTypeRD: "Product Type R&D",
        processTypeRD: "Process Type R&D",
        productTypeRDRemarks: "Product Type R&D Remarks",
        fromDate: "From Date",
        toDate: "To Date",
        dateFilter: "Sample Requested Date Filter",
        dateFilterApplied: "Date Filter Applied:",
        applyFilter: "Apply Filter",
        fromDateCannotAfterToDate: "From Date cannot be after To Date",
        pleaseSelectToDate: "Please select the To Date",
        createdBy: "Created By",
      },
      view: {
        sample_request_details: {
          sample_request_number: "Sample Request No",
          record_type_name: "Entity",
          account_name: "Account name",
          contact_name: "Contact name",
          contact_phone: "Phone No",
          category: "Category",
          sample_request_date:"Sample Request date",
          time_for_submission: "Time For Submission",
          remarks: "Remarks",
          shipping_address: "Shipping address",
        },
        sample_line_header_info: {
          sample_request_number: "Sample Request Number",
          sample_request_line_number: "Sample Request Line Item Number",
        },
        sample_line_product_info: {
          sample_category_name: "Requested Type",
          product_type_name: "Product Type",
          product_description_name: "Product Description",
          blend_composition_name: "Blend Composition",
          blend_ration_ar: "Blend Ratio(A/R)",
          price_range: "Price Range",
          currencyname: "Currency",
          countryname: "Target Country",
          submitted_prototype: "Tweaks Suggested by Client for the Submitted Prototype",
        },
        sample_line_packing_info: {
          category_name: "Packing Category",
          packing_mode: "Packing Mode",
          upc: "UPC(Unit Per Carton)",
          packing_sub_type: "Packing Sub Type",
          weight: "Weight (Gms/Kgs)",
          evaluation_sample_size: "Evaluation Procedure",
          // description: "Description",
        },
        sample_line_eval_info: {
          packing_type_name: "Packing Type",
          grammage_name: "Grammage",
          quantity: "Quantity",
          comments: "Comments",
        },
        sr_line_view:{
          tab_names:{
            sample_line_info: "Sample Line Information"
          }
        },

        sampleRequestDetails: "Sample Request Details",
        sampleRequestNumber: "Sample Request Number",
        sampleRequestLineNumber: "Sample Request Line Item Number",
        sampleLineItemInfo: "Sample Line Item Information",
        status: "Status",
        statusSteps: {
          new: "New",
          pendingWithRD: "Pending with R&D",
          dispatched: "Dispatched",
          customerApproved: "Customer Approved"
        },
        submitSuccess: "Sample Request Submitted And Email Sent Successfully",
        sampleLineItem: "Sample Line Item",
        srliNumber: "SRLI Number",
        sampleCategory: "Sample Category",
        productType: "Product Type",
        packingCategory: "Packing Category",
        packingType: "Packing Type",
        quantity: "Quantity",
        deleteConfirm: "Are you sure you want to delete this record?",
      },
      grid: {
        sample_request_number: "System Number",
        record_type_name: "Record Type",
        account_name: "Account Name",
        requested_user_name: "Requested By",
        sample_request_date: "Sample Request Date",
        time_for_submission: "Time for Submission",
        status_name: "Status"
      },
      sampleLineGrid: {
        sample_request_line_number: "SRLI Number",
        sample_category: "Sample Category",
        product_type: "Product Type",
        packing_category: "Packing Category",
        packing_type: "Packing Type",
        quantity: "Quantity",
        status_name: "Status"
      },
      productSpecificationTableHeaders: {
        clinet_requirements_name: "Specifications",
        clinet_requirements: "Remarks",
        regulatory_requirements_name: "Regulatory",
        certification_requirements_names: "Certifications Required",
        actions: "Actions",
      },
      rdDetailsTableHeaders: {
        sample_request_line_number: "Sample Line Item Number",
        sample_code_rd: "Sample Code R&D",
        product_type_rd: "Product Type R&D",
        product_type_remarks_rd: "Product Type R&D Remarks",
        carrier_name: "Carrier Name",
        tracking_number: "Tracking Number",
        resubmitted: "Re-Submitted",
      },
      customerFeedbackTableHeaders: {
        sample_request_line_number: "Record Number",
        customer_feedback: "Customer FeedBack",
        customer_approved: "Customer Approval",
        created_date: "Updated Date",
        created_by: "Updated By"
      }
    },
    MasterSamlples: {
      createEdit: {
        // parameter: "Parameter",
        // value: "Value",
        // update: "Update",

        proceed: "Proceed",
        addParameters: "Add Parameters",
        addNew: "Add New",
        percentageErrorMsg: "The percentage of the sum of all green coffee items should be 100.",
        gcItemInfo: "Green Coffee Item Information",
        extractionErrorMsg: "Extraction recipe is Required",
        atLeastOneItemRequired: "At least one item is required",
        percentageNullMsg: "percentage of Green Coffee Item cannot be 0",
        aromaQntyErrorMsg: "Aroma Quantity cannot be 0",

        // alternativeSampleCode: "Alternative Sample Code"
        gcOtherConsumableFields: {
          item_type: "Item Type",
          item: "Item",
          gc_group_name: "Group",
          percentage: "Percentage",
          conversion_ratio: "Conversion Ratio",
          moisture_percentage: "Moisture (%)",
          bulk_density: "Bulk Density (g/cc)",
          foriegn_matter_husk: "Foreign Matter Husk(%)",
          roast_color: "Roast Color",
          roast_loss: "Roast Loss(%)",
        },
        parameterFields: {
          parameter_name: "Parameter Name",
          parameter_value: "Value",
        }
      },
      MSSnackBarStrings: {
        masterSampleSuccess: "Master Sample Created successfully",
        parameterupdateSuccess: "Master Sample Parameters Updated successfully",
        msParameterDeleteSuccess: "Master Sample Parameters Deleted successfully",
        createASBasedOnMS: "Alternative Sample Created successfully",
        msItemsDeleteSuccess: "Master Sample Green Coffee Items Deleted successfully",
        msGrindingDeleted: "Master Sample Grinding Deleted successfully",
        deleteGCMsg: "Do you want to delete Green Coffee Item",
      },
      forms: {
        MS: "master Samples",
        MSInfo: "Master Sample Information",
        altenativeSamples: "Alternative Samples",
        alternativeSamplesInfo: "alternativeSamples",
        masterSamples: "Master Samples",
        masterSamplesInfo: "masterSamples",
        createMS: "Create Master Sample",
        MasterSampleDetails: "Master Sample Details",
        serviceProvider: "Service Provider",
        OtherConsumableItems: "Green Coffee And Other Consumable Items And Their Specifications",
        productSpec: "Product Specifications",
        RequestApproval: "Request Approval",
        ProcessRecipeSetting: "Process/Recipe Settings of Master Sample",
        itemType: "Item Type",
        group: "Group",
        generateSampleCode: "Generate Sample Code",
        approverComents: "Approver Comments",
        pendingApproval: "Pending Approval",
        coffeeType: {
          GC: "GC",
          ORM: "ORM",
        },
        greenCoffeeAndOtherConsumableItemsTabelHeaders: {
          item_code: "Item Code",
          s_code: "SCode",
          item_name: "Item Name",
          gc_group_name: "Group",
          percentage: "Percentage",
          conversion_ratio: "Conversion Ratio",
          moisture_percentage: "Moisture (%)",
          bulk_density: "Bulk Density (g/cc)",
          foriegn_matter_husk: "Foriegn Matter Husk(%)",
          roast_color: "Roast Color",
          roast_loss: "Roast Loss(%)",
          actions: "Actions",
        },
        productSpecTabelHeaders: {
          parameter_name: "Parameter Name",
          parameter_value: "Parameter Value",
        },
        MSInformation: {
          sample_code: "Sample Code",
          sample_date: "Sample Date",
          sample_name: "Sample Name",
          factory_code: "Factory Code",
          product_category: "Product Category",
          product: "Product",
          product_subtype: "Product Sub-Type",
          product_flavor: "Product Flavour",
          aroma: "Aroma",
          aroma_quantity: "Aroma Qty(LITRES/hr)",
          yield: "Yield(%)",
          yield_ratio: "Yield Ratio",
          remarks: "Remarks",
        }
      },
      view: {
        alternativeSamplTab: "Alternative Samples",
        viewGrinder: "View Grinder",
        MSHeaders: {
          MSInfo: "Master Sample Information",
          greenCoffeeAndOtherConsumableItems: "Green Coffee And Other Consumable Items And Their Specifications",
          productSpecification: "Product Specifications",
          processRecipeSettings: "Process/Recipe Settings of Master Sample",
        }
      }
    },
    AlternativeSamlples: {
      forms: {
        itemType: "Item Type",
        group: "Group",
        gc: "GC",
        orm: "ORM",
        itemCode: "Item Code",
        scode: "S_Code",
        itemName: "Item Name",
        group: "Group",
        percentage: "Percentage",
        conversionRatio: "Conversion Ratio",
        moisturePercentage: "Moisture (%)",
        bulkDensity: "Bulk Density (g/cc)",
        foriegnMatterHusk: "Foriegn Matter Husk(%)",
        roastColor: "Roast Color",
        roastLoss: "Roast Loss(%)",
        all: "All Alternative Samples",
        new: "New",
        pendingApproval: "Pending Approval",
        approved: "Approved",
        rejected: "Rejected",
        pendingForApproval: "Pending For Approval",
        createAS: "Create Alternative Sample",
        alternativeSample: "Alternative Sample",
        alternativeSampleInfo: "Alternative Sample Information",
        approverComents: "Approver Comments",
        density: "Density",
        moisture: "Moisture",
        husk: "Husk",
        sticks: "Sticks",
        stones: "Stones",
        inActiveBtn: "In Active Button",
        active: "Active",
        inActive: "In Active",
        approvedRejected: "Approved / Rejected",
        greenCoffeeParameters: "Green Coffee Parameters",
        gcInformation: "Green Coffee Item Information",
        proceed: "Proceed",
        masterSamples: "Master Samples",
        masterSampleCode: "Master Sample Code",
        AsInfo: "Alternative Sample Information",
        inventoryInfo: "Inventory Information",
        parameter: "Parameter",
        value: "Value",
        searchForMs: "Search For Master Sample Code",
        percentageWarningMsg: "Total percentage of Green Coffee Items must be 100%",
        mandatoryExtractionData: "Mandatory Extraction data is missing",
        pendingApprovalFromRD: "Pending Approval from R&D Team",
        pendingApprovalFromGD:"Pending Approval from General Director",
      },
      createEdit: {
        gcOtherConsumableFields: {
          item_type: "Item Type",
          item: "Item",
          gc_group_name: "Group",
          percentage: "Percentage",
          conversion_ratio: "Conversion Ratio",
          moisture: "Moisture (%)",
          bulk_density: "Bulk Density (g/cc)",
          foreign_matter_husk: "Foreign Matter Husk(%)",
          roast_color: "Roast Color",
          roast_loss: "Roast Loss(%)",
        },
      },
      grid: {
        sample_code: "Alternative Sample Code",
        product: "Product",
        product_category: "Category",
        factory_code: "Factory Code",
        product_subtype: "Product Sub-Type",
        remarks: "Remarks",
        created_date: "Created Date",
        sample_status: "Status",
      },
      view: {
        viewHeaders: {
          alternativeSampleInfo: "Alternative Sample Information",
          GcandOtherItems: " Green Coffee And Other Consumable Items And Their Specifications",
          inventoryInfo: "Inventory Information",
          productSpecifications: "Product Specifications",
          inActive: "In Active",
          inActivated: "In Activated",
          seeLocations: "See Locations",
          approverComments: "Approver Comments",
          recipeSettingsOfAlternativeSample: "Process/Recipe Settings Of Alternative Sample",
          customerSample: "Customer Samples",
          batchOutput: "Batch Output",
        },
        buttonStrings: {
          create: "Create",
          cancel: "Cancel",
          reject: "Reject",
          edit: "Edit",
          requestForApproval: "Request For Approval",
          approve: "Approve",
        },
        alternativeSampleInfoStirings: {
          alternative_sample_id: "Sample Id",
          master_sample_id: "Master Sample Code",
          sample_code: "Sample Code",
          product_flavor: "Product Flavour",
          sample_date: "Sample Date",
          aroma: "Aroma",
          factory_code: "Factory Code",
          aroma_quantity: "Aroma Qty (L/hr)",
          product_category: "Product Category",
          yield: "Yield (%)",
          product: "Product",
          yield_ratio: "Yield Ratio",
          product_subtype: "Product Sub-Type",
          remarks: "Remarks",
          production_capacity_per_day: "Production capacity/day (MT)",
          production_capacity_per_hour: "Per-hour capacity (kg/hr)",
          created_time: "Created Date"
        },
        greenCoffeeTableStrings: {
          itemCode: "Item Code",
          sCode: "S_Code",
          itemName: "Item Name",
          group: "Group",
          percentage: "Percentage",
          conversionRatio: "Conversion Ratio",
          moisture: "Moisture (%)",
          bulkDensity: "Bulk Density (g/cc)",
          foriegnMatterHusk: "Foriegn Matter Husk(%)",
          roastColor: "Roast Color",
          roastLoss: "Roast Loss(%)",
        },
        inventoryTableStrings: {
          itemName: "Item",
          totalPoQnty: "Total PO Quantity(Kg)",
          pendingPoQnty: "Pending PO Quantity(Kg)",
          recievedQnty: "Recieved Quantity(Kg)",
          quantityOnHand: "Quantity On Hand(Kg)",
          quantityCommitted: "Quantity Committed(Kg)",
          backOrderQnty: "Back Order Quantity(Kg)",
          openQuoteAllocatedQnty: "Open Quote Allocated Quantity(Kg)",
          otherQuotesAllowQnty: "Other Quotes Allocated Quantity(Kg)",
          averageCost: "Average Cost",
          locations: "Locations",
        },
        productSpecificationTableStrings: {
          paramName: "Parameter Name",
          paramValue: "Parameter Value",
        },
        snackMessages: {
          prodCapacityEmptyMsg: "Production Capacity/day (MT) Should not be 0",
          successMsg: "Alternative Sample Created Successfully",
          deleteSuccess: "Deleted Successfully",
          percentageError: "Total percentage of Green Coffee Items must be 100%",
          deleteGCMsg: "Do you want to delete Green Coffee Item",
          customerSampleCreatesucess: "Customer Sample Created Successfully",
          asGrindingDeleted: "Alternative Sample Grinding Deleted successfully",
          aromaQntyErrorMsg: "Aroma Quantity cannot be 0",
          productFlavourrequired: "Product Flavour is Required",
        }
      },
    },
    customerSample: {
      forms: {
        customerInformation: {
          selectCustomer: "Select Customer",
          customerName: "Customer Name",
          customerId: "Customer Id",
          sampleDate: "Sample Date",
          alternativeSampleCode: "Alternative Sample Code",
        },
        customerSampleInformation: {
          sampleCode: "Sample Code",
          sampleName: "Sample Name",
          factoryCode: "Factory Code",
          sampleDate: "Sample Date",
          productCategeory: "Product Category",
          product: "Product",
          productSubtype: "Product Sub-Type",
          productFlavour: "Product Flavour",
          aroma: "Aroma",
          aromaQty: "Aroma Qty(LITRES/hr)",
          yield: "Yield(%)",
          yieldRatio: "Yield Ratio",
          productioncapacityperday: "Production Capacity/day (MT)",
          perHourCapacity : "Per-hour capacity (kg/hr)",
          perHourCapacityTooltip: "(Per-day capacity in MT * 1,000) / 24",
          remarks: "Remarks",
        },
      },
      view: {
        CustomerSampleHeaders: {
          customerInformation: "Customer Information",
          customerSampleInformation: "Customer Sample Information",
          customerSample: "Customer Sample",
          remarks: "Remarks",
          alternativeSample: "Alternative Samples",
          productSpecification: "Product Specifications",
          greenCoffeeAndOtherConsumableItems: "Green Coffee And Other Consumable Items And Their Specifications",
          quotationInfo: "Quotation Information",
          quotation: "Quotation",
          alternativeSampleInfo: "Alternative Sample Information",
          alternateveSample: "Alternative Sample"
        },
        CustomerInfoStrings: {
          customer: "Customer",
          customer_name: "Customer Name",
          customer_id: " Customer Id",
          sample_date: "Sample Date",
        },
        customerSampleInfoStirings: {
          customer_sample_id: "Sample Id",
          sampleCode: "Alternate Sample Code",
          sample_code: "Sample Code",
          product_flavor: "Product Flavour",
          sample_date: "Sample Date",
          aroma: "Aroma",
          sample_name: "Sample Name",
          aroma_qty: "Aroma Qty(LITRES/hr)",
          factory_code: "Factory Code",
          yield: "Yield (%)",
          product_category: "Product Category",
          yield_ratio: "Yield Ratio",
          product: "Product",
          created_time: "Created Date",
          product_subtype: "Product Sub-Type",
          production_capacity_per_day: "Production capacity/day (MT)"
        },
        customerSampleSnackBarStrings: {
          uploadedFileExist: "Uploaded file is already exist. Please upload new file",
          fileTypeError: "Uploaded file type is not supported. Please upload only image, PDF, or Excel files",
          fileDownloadSuccess: "File downloaded successfully",
          serverError: "Server Error. Please contact administrator",
          customerSampleDeleteSuccess: "Customer Sample deleted successfully",
          notificationSendSuccess: "Notification Send Successfully",
          customerSampleDeleteError: "This sample can not be deleted as it has a quote/blendsheet associated",
          customerSuccess: "Customer Sample Created successfully",
          updateSuccess: "Customer Sample Updated successfully",
          failedAs: "Failed to Load Alternative Sample Details",
          failedCsDetails: "Failed to Load Customer Sample Details",
          deleteSuccess: "Deleted Successfully"
        },
        greenCoffeeTableStrings: {
          itemCode: "Item Code",
          sCode: "S_Code",
          itemName: "Item Name",
          percentage: "Percentage",
          conversionRatio: "Conversion Ratio",
        },
        productParamTableStrings: {
          paramName: "Parameter Name",
          paramValue: "Parameter Value",
        },
        ButtonStrings: {
          download: "Download",
          sendNotification: "Send Notification",
          delete: "Delete",
          update: "Update",
          edit: "Edit",
          cancel: "Cancel",
          create: "Create",
          deleted: "Deleted",
        },
      },
      create: {
        parameter: "Parameter",
        value: "Value",
        update: "Update",
        proceed: "Proceed",
        addParameters: "Add Parameters",
        percentageErrorMsg: "The percentage of the sum of all green coffee items should be 100.",
        itemName: "Item Name",
        conversionRatio: "Conversion Ratio",
        percentage: "Percentage",
        searchAlternativeSample: "Search for alternative sample code",
        productFlavourErrMsg: "Product Flavour is required",
        percentageNullMsg: "percentage of Green Coffee Item cannot be 0",
        alternativeSampleCode: "Alternative Sample Code"
      }
    },
    CustomerSamples: {
      forms: {
        createCustomerSample: "Create Customer Sample",
        CS: "Customer Samples",
      },
      grid: {
        customer_sample_id: "Customer Sample Id",
        sample_code: "Customer Sample Code",
        alternative_sample_code: "Alternative Sample Code",
        sample_name: "Sample Name",
        sample_date: "Sample Date",
        product: "Product",
        product_category: "Category",
        customer_name: "Customer Name",
        factory_code: "Factory Code",
        remarks: "Remarks",
        created_by: "Created By",
        created_date: "Created Date",
        attachments: "Attachments",
      },
      QuoteGrid: {
        quote_number: "Quotation number",
        customer_name: "Customer Name",
        quote_line_number: "QLI Number",
        quote_status: "Status",
        dispatch_period: "Dispatch period",
        expected_order_quantity: "Expected Order Quantity",
        confirmed_quantity: "Confirmed Quantity",
        created_by: "Created by"
      }
    },
    SampleInformation: {
      forms: {
        allSampleInformation: "All Sample Information",
        sampleReport: "Sample Report"
      },
      grid: {
        customer_sample_id: "Customer Sample Id",
        customer_sample_code: "Customer Sample Code",
        customer_sample_name: "Customer Sample Name",
        customer_production_plant: "Customer Production Plant",
        customer_name: "Customer Name",
        business: "Business",
        type_of_product: "Type of Product",
        output_mt_perday: "Output MT/day",
        sku: "SKU",
        customer_brand_name: "Customer Brand Name",
        pure_chicory: "Pure Chicory",
        alternative_sample_id: "Alternative Sample Id",
        alternative_sample_code: "Alternative Sample Code",
        alternative_sample_remarks: "Alternative Sample Remarks",
        master_sample_code: "Master Sample Code",
        master_sample_remarks: "Master Sample Remarks"
      }
    },
    Quotes: {
      forms: {
        createSuccess: "Quote Created Successfully",
        packingTypeSuccess: "Packing Type Created Successfully",
        bomDataSuccess: "Bom Data successfully created",
        selectFG: "Select Finished Goods",
        fg: "Finished Goods",
        sampleDetails: "Sample Details",
        confirmedQty: "Confirmed Order Quantity",
        confirmedQtyKgs: "Confirmed Order Quantity (Kgs)",
        requestProvideStockPrice: "Request to provide stock price",
        stockPriceRequestApproved: "Stock price request approved",
        confirmedSample: "Confirmed Sample",
        removeFromList: "Remove from the list",
        addForGCPriceRequest: "Add for GC Price Request",
        updateFinishedGoods: "Update Finished Goods",
        editFinishedGoods: "Edit Finished Goods",
        referenceId: "Reference id(System Purpose)",
        quoteItemUpdatedSuccess: "Quote Item Updated Successfully",
        packingDetails: "Packing Details",
        productionCostUpdated: "Production Cost updated successfully",
        otherFactors: "Production Cost of Other Factors Updated Successfully",
        otherFactorsSuccess: "Other Factors Updated Successfully",
        priceSent: "Price sent for request successfully",
        sampleSent: "Sample sent successfully",
        isNewPacking: "Is Packaging New Type",
        newPackingType: "New Packaging Type Requirement",
        taskStatus: "Task Status (New Packing Type)",
        customerRejectionRemarks: "Customer Rejection Remarks",
        generalRemarks: "General Remarks",
        itemCannotEmpty: "Item name cannot be empty",
        floor: "Floor",
        pallet: "Pallet",
        loadability: "Loadability",
        sampleInfo: "Sample Information",
        orderQtyDetails: "Expected order quantity details",
        noSamples: "Error: This account doesn't have any samples associated, ",
        createCS: "please create a customer sample for this account to enable the section.",
        submitPackType: "Submit New Packtype",
        requestPackType: "Request New Pack Type",
        comments: "Comments",
        purchaseRate: "Rate From Purchase(Per KG)",
        factorRate: "Factor Rate From Commercial (Per KG)",
        costPrice: "Cost Price (GC * Yield * Composition%)",
        stockPrice: "Stock Price (GC * Yield * Composition%)",
        basePrice: "Base Price(GC * Yield Ratio* Composition%)",
        compositionPerc: "Sum of Composition % should be 100",
        compositionSum: "Composition Sum",
        quoteItemInfo: "Quote item Information",
        bomInfo: "BOM Information",
        previousRates: "Previous Quotation Rates For This Sample And Customer",
        requestedSamples: "Requested Samples",
        currentPrice: "Current Price",
        gcPricing: "Green Coffee Configuration & Pricing (USD)",
        otherPricing: "Green Coffee & Other Factors Pricing (USD)",
        listOfSamples: "List Of Alternative Samples",
        selectSamples: "Select Samples",
        inventoryInfo: "Inventory Information",
        packingPalletCosts: "Packing / Pallet Costings",
        otherCosts: "List Of Other Factors Their Costings",
        priceInfo: "Price Information",
        confirmedQtyByCustomer: "Customer Approval & Confirmed Order Quantity",
        secondaryPackaging: "Secondary Packaging",
      },
      labels: {
        view: "View",
        quoteNumber: "Quote Number",
        destination: "Destination",
        quoteItemId: "Quote Item Id",
        systemMasterInformation: "System & Master Information",
        accountName: "Account Name",
        status: "Status",
        responsibleOwner: "Responsible Owner",
        requestedBy: "Requested By",
        requestedDate: "Requested Date",
        customer: "Customer",
        qtNo: "QT.No",
        date: "Date",
        exchangeRateUSD: "Exchanged rate USD(As per requested date)",
        quotationNo: "Quotation No.",
        quotationId: "Quotation Id",
        marketingRepName: "Marketing Rep Name",
        partyAddress: "Party Address",
        packingDetails: "Packaging Details",
        currencyCode: "Currency Code",
        conversionFactor: "Conversion Factor",
        customerId: "Customer Id",
        partyName: "Party Name",
        quoteLine: "Quote Line",
        packingDescription: "Packing Description",
        approvalRequestedOn: "Approval Requested On",
        approvalRequestedBy: "Approval Requested By",
        pricesApprovedOn: "Prices Approved On",
        pricesApprovedBy: "Prices Approved By",
        dispatchPeriod: "Dispatch Period",
        balanceQuantity: "Balance Quantity",
        gcAllocation: "GC Allocation",
        portLoading: "Port Loading",
        quoteCreationDate: "Quote creation date",
        quoteStatus: "Quote status",
        factor: "Factor",
        factors: "Factors",
        cost: "Cost",
        costPrice: "Cost Price",
        factorRate: "Factor Rate",
        factorsFromComm: "Factor Rate From Commercial(Per KG)",
        perc: "Perc",
        ratio: "Ratio",
        itemName: "Item Name",
        yield: "Yield",
        percentage: "Percentage",
        remarksMarketing: "Remarks from marketing",
        activityLog: "Activity Log",
        greenCoffeePrices: "Green Coffee Prices",
        customerCurrency: "Customer currency",
        quotationItemDetails: "Quotation Item Details",
        finalClient: "Final Client",
        finalClientId: 'Final Client Id',
        finalCustomer: "Final Customer",
        finalClientName: "Final Client Name",
        quoteCategory: "Quote category *",
        expirationPeriod: "Expiration period *",
        expirationDate: "Expiration date *",
        destinationCountry: "Destination Country",
        destinationPort: "Destination Port",
        dispatchFromDate: "Dispatch from date *",
        dispatchToDate: "Dispatch to date *",
        otherSpecification: "Other specification",
        cloneQuote: "Clone Quote",
        cloneQuoteItem: "Clone Quote Item",
        contactName: "Contact name",
        accountType: "Account type",
        createQuote: "Create Quote",
        billingAddress: "Billing address",
        paymentTerms: "Payment terms",
        incoterms: "Incoterms",
        quoteItems: "Quote Items",
        quoteDetails: "Quote Details",
        dispatchPeriodFrom: "Dispatch period from",
        totalExpectedInstantCoffeeQty: "Total expected instant coffee quantity(KGS)",
        dispatchPeriodTo: "Dispatch period to",
        othersSpecification: "Others (Specification)",
        quoteId: "Quote Id",
        quoteInformation: "Quote information",
        dispatchDetails: "Dispatch details",
        quotationDetails: "Quotation details",
        quotationNoLabel: "Quotation no",
        quoteCreation: "Quote creation",
        pendingWith: "Pending With",
        quoteUpdatedSuccess: "Quote updated successfully",
        quoteLineItemId: "Line Item Id",
        quoteItem: "Quote Item",
        sampleCode: "Sample Code",
        quotationSampleInfo: "Quotation & Sample Information",
        packingTypeDetails: "New Packaging Type Request Details",
        sampleName: "Sample Name",
        alternativeSamples: "Alternative Samples",
        finalizedSamples: "Finalized Samples",
        expectedQtyKgs: "Expected Qty (Kgs)",
        expectedOrderQty: "Expected Order Quantity(Kgs)",
        expectedOrderQuantity: "Expected Order Quantity",
        category: "Category",
        categoryType: "Category Type",
        packingCategory: "Packing Category",
        packingSubType: "Packing Sub Type",
        weight: "Weight",
        upc: "UPC",
        capType: "Cap Type",
        packingMode: "Packing Mode",
        packagingMode: "Packaging Mode",
        cartonType: "Carton Type",
        userBy: "User by",
        dtTime: "DT Time",
        bomName: "BOM Name",
        fillAllMandatoryFields: "Please fill all mandatory fields to save",
        quoteItemCreatedSuccess: "Quote Item created successfully",
        coffeeType: "Coffee type",
        customerBrandName: "Customer brand name",
        packagingTypeDetails: "Packaging Type Details",
        brandName: "Brand Name",
        type: "Type",
        container: "Container",
        expOrderQty: "Exp. order Qty(KGS)",
        previousQuotationRates: "Previous Quotation Rates",
        listAvailableSamples: "List of available master & alternate samples with GC configuration",
        alternateSamplesConfig: "Alternate samples and configuration request for prices",
        description: "Description",
        productCode: "Product Code",
        productSubTitle: "Product Sub Title",
        productSubtype: "Product Subtype",
        aroma: "Aroma",
        aromaQty: "Aroma Quantity",
        packingType: "Packaging Type",
        packagingCategory: "Packaging Category",
        additionalPackingDetails: "Additional Packaging Details",
        aromaQuantity: "Aroma Quantity (Litres/Hour)",
        packingTypeCreatedSuccess: "Packing Type Created Successfully",
        portOfLoading: "Port of Loading",
        commissionAgent: "Commission Agent",
        title: "Title",
        dispatchTimePeriod: "Dispatch Time Period",
        quoteCategoryTitle: "Quote Category",
        expirationPeriodTitle: "Expiration period",
        expirationDateTitle: "Expiration date",
        bomDataSuccess: "Bom Data successfully created",
        noApprovedSamples: "There Are No Approved Samples For This Quote",
        noApprovedFinalizedSamples: "There Are No Approved Finalized Samples For This Quote",
        noApprovedAlternateSamples: "There Are No Approved Alternate Samples For This Quote",
        totalGCPrice: "Total GC Price :",
        total: "Total:",
        confirmedOrderQty: "Confirmed Order Quantity",
        labelTotal: "Total",
        marginPercentage: "Margin (%)",
        additionalRateMD: "Additional Rate (MD)",
        destinationOldData: "Destination (Old Data)",
        negativeMarginStatus: "Negative Margin Status",
        negativeMarginRemarks: "Negative Margin Remarks",
        negativeMarginReason: "Negative Margin Reason",
        mdApprovalStatus: "MD Approval Status",
        customerApprovalStatus: "Customer Approval Status",
        createdBy: "Created By",
        createdDate: "Created Date",
        approvedBy: "Approved By",
        approvedDate: "Approved Date",
        attachment: "Attachment",
        capacity: "Capacity(Quantity Pickable in Unit)",
        packingUnitUOM: "Packing Unit UOM",
        cartonMode: "Carton Mode(Number of Units in Carton)",
        capStyle: "Cap Style",
        costOfPackingType: "Cost of Packing Type",
        height: "Height",
        width: "Width",
        length: "Length",
        packingWeightAlias: "Packing Weight Alias",
        capColor: "Cap Color",
        cartonColor: "Carton Color",
        paletizationRequired: "Paletization Required",
        additionalPackingDescription: "Additional Packing Description",
        costOfPallet: "Cost of Pallet if Applicable",
        packingTypesMaster: "Packing Types Master",
      },
      dropdowns: {
        domestic: "Domestic",
        export: "Export",
        merchantExport: "Merchant Export",
        hours24: "24 Hours",
        days7: "7 Days",
        newQuote: "New Quote",
        pricing: "Pricing",
        customerReview: "Customer Review",
        approved: "Approved",
        rejected: "Rejected",
        expired: "Expired",
        customerApproved: "Customer Approved",
        customerRejected: "Customer Rejected",
        bdmApproved: "BDM Approved",
        bdmApproved: "BDM Approved",
        bdmRejected: "BDM Rejected",
        allQuotes: "All Quotes",
        myQuotes: "My Quotes",
        pendingNegativeMargin: "Pending Negative Margin Quotelines",
        pendingWithCEO: "Pending with CEO",
      },
      grid: {
        lineItemId: "Line Item Id",
        quoteLineItemId: "Quote Line Item Id *",
        quoteItem: "Quote Item",
        mdApprovalStatus: "MD Approval Status",
        customerApprovalStatus: "Customer Approval Status",
        customerApprovalStatus: "Customer Approval Status",
        finishedGoods: "Finished Goods",
        expectedQtyKgs: "Expected Qty (kgs)",
        confirmedOrderQuantity: "Confirmed Order Quantity",
        category: "Category",
        categoryType: "Category Type",
        currency: "Currency",
        weight: "Weight",
        upc: "UPC",
        itemName: "Item Name",
        unAllocatedQuantity: "Un-Allocated Quantity",
        transit: "Transit",
        avgDollar: "Avg $",
        locked: "Locked",
        openQuoteAllocated: "Open Quote Allocated",
        allocationRecordNo: "Allocation Record No",
        quoteNo: "Quote No",
        quoteLineNumber: "Quote Line Number",
        accountName: "Account Name",
        poNo: "PO No",
        allocatedQty: "Allocated Qty",
        allocationDate: "Allocation Date",
        productType: "Product Type",
        basePrice: "Base Price",
        basePriceKg: "Base Price (Per KG)",
        finalPriceKg: "Final Price (Per KG)",
        stockPrice: "Stock Price",
        marketPrice: "Market Price",
        finalRate: "Final Rate",
        margin: "Margin",
        marginValue: "Margin Value",
        marginPsym: "Margin %",
        qtNoDate: "Qt. No & Date",
        description: "Description",
        id: "ID",
        type: "Type",
        brand: "Brand",
        sample: "Sample",
        mode: "Mode",
        packingUnit: "Pack Type",
        selling: "Selling",
        priceToCRM: "Price to CRM",
        sellingPrice: "Selling Price",
        customerApproval: "Customer Approval",
        bdmApproval: "BDM Approval",
      }
    },
    Quotation: {
      forms: {
        create: "Create Quotation",
        customerDetails: "Customer Details",
        dispatchDetails: "Dispatch Details",
        quoteLineDetails: "Quote line Details",
        packingDetails: "Packing Details",
        sampleDetails: "Sample Details",
        createSuccess: "Quotation created Successfully",
        inputCostrequestedstatusId: "Q-SS-5",
        domestic: "Domestic",
        SelectCatType: "Select Category Type",
        packingTypeDetails: "Packaging Type Details",
        FCRecordWarning: "No Finance Costing record found for the selected packing mode and packing unit",
        errormsgcosts: "Process Cost, Conversion Cost, and Packing Labour Cost have not been given for this Packing Mode.",
        noFinanceCostingRecordIdErrorMsg: "Please check with the Finance team to add the finance costing record and contact the Admin to add that finance record to this quote line item.",
        noFinanceCostingExportMsg: "Please create the finance costing record and contact the Admin to link the finance costing record to this quote line item.",
        packingSubTypeErrorMsg: "Finance cost record is not available for the selected packing",
        nomatchingpackingSubType: "No matching packing sub type found",
        packingUnit: "Packing Unit",
        coffeeType: "Coffee Type",
        sampleName: 'Sample Name',
        customerBrandName: "Customer Brand Name",
        sampleBased: "Sample Based",
        groupBased: "Group Based",
        expirationPeriod: "Expiration Period",
        expirationDate: "Expiration Date",
        floor: "Floor",
        pallet: "Pallet",
        itemGroup: "Item Group",
        confirmOrderQty: 'Confirmed order quantity(Kgs)',
        customerRejectionRemarks: 'Customer Rejection Remarks',
        basePriceRejectedRemarks: 'Base Price Rejected Remarks',
        repricingForQuoteLineItem: 'Repricing for Quote line Item',
        rePricing: 'RePricing',
        expiry: 'Expiry',
        alternativeSampleExpiredMsg: 'The Validity of the Selected Alternative Sample has Expired.',
        customerApprovalStatus: 'Customer Approval Status',
        confirmedOrderQuantity: 'Confirmed Order Quantity',
        quoteItemUpdatedSuccess: 'Quote item updated successfully',
        marginValue: "Margin Value",
        negativeMarginReason: "Negative Margin Reason",
        negativeMarginRemarks: "Negative Margin Remarks",
        negativeMarginStatus: "Negative Margin Status",
        negativeMarginValue: "Negative Margin value",
        requestForApproval: "Request For Approval",
        customer: "Customer:",
        finalClient: "Final Client:",
        sample: "Sample:",
        packingType: "Packing Type:",
        itemName: "Item Name",
        group: "Group",
        ratio: "Ratio",
        conversion_ratio: "Conversion Ratio",
        perc: "Perc",
        percentage: "Percentage",
        conversion: "Conversion",
        factoryCode: "Factory Code",
        previousRates: "Previous Rates",
        dailyRates: "Daily Rates (onDate)",
        marketPriceMT: "Market Price MT",
        stockPriceMT: "Stock Price MT",
        INR: "INR",
        USD: "USD",
        comments: "Comments",
        yield: "Yield(%)",
        gc_orm_percentage: "GC/ORM Percentage",
        yields:"Yield",
        stockPrice: "Stock Price",
        marketPrice: "Market Price",
        exportGCOFP: "Green Coffee & Other Factors Pricing (USD)",
        domesticGCOFP: "Green Coffee & Other Factors Pricing (INR)",
        exportGCCP: "Green Coffee Configuration & Pricing (USD)",
        domesticGCCP: "Green Coffee Configuration & Pricing (INR)",
        pendingApprovalSuccess: "Pending Approval successfully",
        pendingApprovalNotinPicklist: "Status Pending Approval not found in viewpicklist",
        searchByItemNameOrCode: "Search by Item Name or Item Code",
        searchByFGName: "Search with FG Name at least 3 letters",
        srNo: 'Sr No.',
        fgname: "FG Name",
        bomName: "BOM Name",
        brandName: "Brand Name",
        bomLineItemName: "BOM Line Item Name",
        bomLineItem: "BOM Line Item",
        isArtWorkAvailable: "Is Artwork Available",
        viewArtWork: "View Artwork",
        preview: "Preview",
        quotationDetails: "Quotation Details",
        fgDetails: "Finished Good Details",
        billOfMaterialLines: "Bill of Material Lines",
        viewArtWorkDetails: "View Artwork Details",
        noArtWorkDetailsAvailable: "No Artwork Detail Available",
        previewArtWork: "Preview Artwork",
        fgAndBOMDetails: "FG and BOM Details",
        artWorkDetails: "Artwork Details",
        fgCreated: "FG Selected",
        fgDeleted: "FG Deleted",
        fgDeletedSuccessfully: "FG Deleted Successfully",
        quoteRejectedSuccessfully: "Quote Rejected Successfully",
        basePriceRejectedSuccessfully: "Base Price Rejected Successfully",
        quoteExpiredMessage: "This Quote is expired.",
        expired:"Expired",
      },
      FGquotationDetails: {
        quote_number: "Quote Number",
        account_name: "Account Name",
        quote_line_number: "Quote Line Item Number",
        quantity: "Quantity",
        packing_category: "Packing Category",
        sample_code: "Customer Sample Code",
        packing_name: "Packing Name",
      },
      fgBOMCols: {
        sr_no: "Sr No.",
        fg_name: "Finished Goods Name",
        bom_name: "Bill of Material Name",
        brand_name: "Brand Name",
      },
      fgDetails: {
        brand_name: "Brand Name",
        fg_name: "Finished Goods Name",
        bom_name: "Bill of Material Name",
      },
      bomLines: {
        sr_no: "Sr No.",
        bom_line_item_id: "BOM Line Item Id",
        bom_line_item_name: "BOM Line Item Name",
        is_art_work_available: "Is Artwork Available",
        date_created: "File Uploaded date",
        viewArtWork: "View Artwork",
      },
      artWorkCols: {
        sr_no: "Sr No.",
        art_work_id: "Artwork Id",
        art_work_name: "Artwork Name",
        art_work_uploaded_by: "Uploaded By",
        art_work_uploaded_date: "Uploaded Date",
        preview: "Preview"
      },
      statusBar: {
        basePriceReq: "Base Price Requested",
        inputCostReq: "Input Cost Requested",
        inputCostRec: "Input Cost Received",
        pendingApproval: "Pending Approval",
        basePriceRec: "Base Price Received",
        basePriceRej: "Base Price Rejected",
        newQuotes: "New Quotes",
        pricing: "Pricing",
        customerReview: "Customer Review",
        customerAppRej: "Customer Approved/Rejected",
        expired: "Expired",
        convertedQuote: "Converted Quote",
        quoteSubtoCus: "Quote Submitted to Customer",
        quoteAppbyCus: "Quote Approved by Customer",
        quoteRejbyCus: "Quote Rejected by Customer",
        quoteExpired: "Quote Expired",
        sampleExpired: "Sample Expired",
        convertedQuotes: "Converted Quotes",
        readyForOrder: "Ready for Order"
      },
      grid: {
        quote_number: "Quote Number",
        account_name: "Account Name",
        quote_line_item_number: "Quote Line Item Number",
        status: "Status",
        packingUnit: "Packing Unit",
        quarter_name: "Quarter",
        dispatch_month: "Dispatch Month",
        dispatch_period: "Dispatch Period",
        expected_quantity: "Expected Quantity",
        responsible_owner: "Responsible Owner",
        created_by: "Created By",
        requested_by: "Requested By",
        requested_date: "Requested Date",
        order_dispatch_number: "Order Dispatch Number",
        confirmed_order_quantity: "Quantity",
        allocation_percentage: "Allocation %",
        fg_code: "FG Code",
        created_date: "Created Date",
        balance_quantity: "Balance Quantity",
        allocated_quantity: "Allocated %",
        attachments_counts: "Attachment",
        productionUnit: "Production Unit",
        factoryCode: "Factory Code",
        approvedBy: "Approved By",
      },
      quoteStatusOverviewGrid: {
        quote_number: "Quote Number",
        account_name: "Account Name",
        total_confirmed_quantity: "Total Quantity(kgs)",
        scheduled_quantity: "Scheduled Quantity(kgs)",
        packed_quantity: "Packed Quantity(kgs)",
        shipped_quantity: "Shipped Quantity(kgs)",
        balance_quantity: "Balance Quantity(kgs)",
      },
      gcGroupCols: {
        item_name: "Item Name",
        item_code: "Item Code",
        price: "Weighted Average Price",
      },
      mandatoryMessageForFactoryCode: "Please select an Factory Code",
      updateFinishedGood: "Update Finished Goods",
      EditFinishedGood: "Edit Finished Goods",
      finishedGoodName: "Finished Good Name",
      selectFinishedGoods: "Select FG",
      proceed: "Proceed",
      deleteFG: "Delete FG",
      deleteFGConfirmation: "Are you sure you want to delete ",
      deleteFGConfirmationMsg: " Finished Good?",
      deleteFGSuccess: "FG Deleted Successfully",
      accountName: "Account Name",
      packingType: "Packing Type",
      quoteLineNumber: "Quote Line Number",
      quantity: "Quantity",
      fgSelectedSuccessfully: "FG selected successfully",
    },
    FGvalidity: {
      forms: {
        CreateFGvalidity: "Finished Good Validity",
        FG: "Finished Good",
        FGInfo: "Finished Good Information",
        FGDetails: "Finish Goods Validity details",
        Create: "Record created successfully",
        Update: "Record updated successfully",
        SelectCatType: "Select Category Type",
        createPackingTypeErrorTitle: "Warning: No Packing Type Available",
        createPackingDetailsErrorTitle: "Warning: No Packing Detail Available",
        createBOMDetailsErrorTitle: "Warning: No BOM Detail Available",
        createxistingErrorTitle: "Error: Record Exist.",
        reason: "Reason:",
        action: "Action Required:",
        createErrorMessageReason:
          " There is no valid packing type available in NetSuite for the selected FG Record.",
        createErrorMessageAction:
          " Please add a valid packing type for this FG record in NetSuite.",
        Warning: "Warning: ",
        WarningTitle: "Warning",
        warningmsg:
          "The packing type associated with the selected Finished Good (FG) does not contain UPC or Unit Net Weight details to proceed.",
        warningmsgbom:
          "The packing type associated with the selected Finished Good (FG) does not contain BOM details to proceed.",
        actionmsg:
          "Please select a different FG which have sufficient details.",
        actionmsgbom:
          "Please select a different FG which have sufficient details.",
        recordId: "Record Id",
        customer: "Customer",
        brand: "Brand",
        fgId: "FG ID",
        bomId: "BOM ID",
        bomName: "BOM Name",
        packingName: "Packing Name",
        packingTypeName: "Packing Type Name",
        customerSample: "Customer Sample",
        customerSampleName: "Customer Sample Name",
        masterSampleName: "Master Sample Name",
        alternativeSampleName: "Alternative Sample Name",
        validFrom: "Valid From",
        validTill: "Valid Till",
        remarks: "Remarks",
        alternativeSample: "Alternative Sample",
        masterSample: "Master Sample",
      },
      grid: {
        record_id: "Record ID",
        customer_name: "Customer",
        brand_name: "Brand",
        finished_good_name: "FG Name",
        customer_sample_code: "Customer Sample Code",
        valid_from: "Valid From",
        valid_to: "Valid Till",
      }
    },
    sample_recepie_tabs: {
      grinding_form: {
        add_grinding: "Add Grinding",
        view_grinding: "View Grinding",
        edit_grinding: "Edit Grinding",
      },
      vent_valve_position: {
        "0-BYPASS": "0-BYPASS",
        "1-ACTIVATE": "1-ACTIVATE",
      },
      green_coffee_blend: {
        "CCL-I": "CCL-I",
        "CCL-II": "CCL-II",
        "CCL-III": "CCL-III",
        "CCL-IV": "CCL-IV",
        "CCL-V": "CCL-V",
        "CCL-B": "CCL-B"
      },
      select_roaster: {
        "LillaRoaster": "Lilla Roaster",
        "probatTurboRoaster": "Probat Turbo Roaster",
        "Probatone25 Roaster": "Probatone25 Roaster",
      },
      select_extraction: {
        "Old Extraction": "Old Extraction",
        "New Extraction": "New Extraction"
      },
      select_grinding: {
        "Sieve Analysis(Old)": "Sieve Analysis(Old)",
        "Sieve Analysis(New)": "Sieve Analysis(New)",
        "Sieve analysis (Roast & Ground Coffee)": "Sieve analysis (Roast & Ground Coffee)",
      },
      recepie_tabs: {
        green_coffee: "Green Coffee",
        roasting: "Roasting",
        grinding: "Grinding",
        extraction: "Extraction",
        scc_aroma_unit: "SCC Aroma Unit",
        decanter: "Decanter",
        centrifuge: "Centrifuge",
        evaporator: "Evaporator",
        spray_drier: "Spray Drier",
        agglomeration: "Agglomeration",
        freeze_drier: "Freeze Drier",
        premix_process_settings: "3-in-1 Premix Process Settings",
        oil_expeller: "Oil Expeller",
      },
      recepie_btn: {
        add_grinding: "Add Grinding",
      },
      green_coffee: [
        {
          header: "RAW MATERIAL PARAMETERS",
          fields: {
            green_coffee_blend: "Green Coffee Blend",
            green_coffee_batch_no: "Batch Number",
            gc_perc_of_type: "% of Type",
            gc_grade_of_coffee: "Grade of Coffee",
            green_coffee_issue_qty: "Green Coffee Issued Quantity (kg)",
            green_coffee_received_qty: "Green Coffee Received Qty",
            green_coffee_output_qty: "Green Coffee Output Qty",
          },
        },
        {
          header: "COFFEE CLEANING",
          fields: {
            stones: "Stones (%)",
            dust: "Dust (%)",
            total_loss: "Cleaning Loss (%)",
          },
        },
      ],
      roasting: [
        {
          header: "ROASTING DETAILS",
          probatTurboRoasterFields: {
            roaster: "Selected Roaster",
            pr_green_coffee_intake: "Green Coffee Intake (kg)",
            pr_batch_size: "Batch Size (kg)",
            pr_receipe_name: "Recipe Name",
            pr_color_factor: "Colour Factor",
            pr_preheating_temp: "Pre-Heating Temperature (°C)",
            pr_preheating_time: "Pre-Heating Time (min)",
            pr_drying_chamber_blower_speed: "Drying Chamber Blower Speed (Hz)",
            pr_chamber_temp: "Chamber Temperature (°C)",
            pr_furnace_temp: "Furnace Temperature (°C)",
            pr_roasting_chamber_blower_speed: "Roasting Chamber Blower Speed (Hz)",
            pr_discharge_speed: "Discharge Speed (Hz)",
            pr_quenching_water_temp: "Quenching Water Temperature (°C)",
            pr_quenching_water: "Quenching Water (L)",
            pr_quenching_water_time: "Quenching Water Time (min)",
            pr_cooling_temp: "Cooling Temperature (°C)",
            pr_cooling_time: "Cooling Time (min)",
            pr_total_cycle_time: "Total Cycle Time (min)",
            pr_roasting_output: "Roasting Output (kg)",
            pr_roasting_loss: "Roasting Loss (%)",
            pr_moisture_content: "Moisture Content %",
            pr_bulk_density: "Bulk Density (g/cc)",
          },

          fields: {
            roaster: "Selected Roaster",
            lr_green_coffee_intake: "Green Coffee Intake (kg)",
            lr_roast_batch_size: "Roast Batch Size",
            lr_profile_name: "Profile Name",
            lr_color_factor: "Colour Factor",
            lr_preheating_temp_time: "Pre-Heating Temp. - Time",
            lr_roasting_time: "Roasting Time (min)",
            lr_roasting_temp: "Roasting Temperature (°C)",
            lr_quench_temp: "Quench Temperature (°C)",
            lr_quencing_water: "Quenching Water (L)",
            lr_cooling_time: "Cooling Time (min)",
            lr_cooling_temp: "Cooling Temperature (°C)",
            lr_hot_air_furnance_temp: "Hot Air Furnace Temperature (°C)",
            lr_moisture: "Moisture (%)",
            lr_bulk_density: "Bulk Density (g/cc)",
            lr_roast_output: "Roast Output (kg)",
            lr_roast_loss: "Roast Loss (%)",
            lr_total_cycle_time: "Total Cycling Time (min)",
          },
        },
      ],
      extraction: [
        {
          key: "Old",
          fields: {
            extraction: "Selected Extraction",
            oe_type_of_extraction: "Type of Extraction",
            oe_mode_of_extraction: "Mode of Extraction",
            oe_extraction_number: "Extraction Number",
            oe_filling_volume: "Filling Volume (kg/m3)",
            oe_feed_water_temp: "Feed Water Temperature (°C)",
            oe_soaking_water_temp: "Soaking Water Temperature (°C)",
            oe_feed_water_flow: "Feed Water Flow (L/hr)",
            oe_pressure_inmost_spent_ext: "Pressure Inmost Spent Extraction (kg/m3)",
            oe_draw_off_pressure: "Draw of Pressure (kg/cm2)",
            oe_draw_off_ratio: "Draw of Ratio",
            oe_number_of_draws: "Number of Draws",
            oe_intercooler_temp: "Intercooler Temperature (°C)",
            oe_aroma_duration_time: "Aroma Duration Time (min)",
            oe_cycle_time: "Cycle Time",
            oe_chicory: "Chicory",
            oe_weak_extract_concentration: "Weak Extract Concentration (%)",
            oe_weak_extract_quantity: "Weak Extract Quantity (kl)",
            oe_rework_added: "Rework Added (kg)",
            oe_roasted_yield: "Roasted Yield (%)",
            oe_cold_cells: "Cold Cells",
          },
        }, {
          key: "New",
          fields: {
            extraction: "Selected Extraction",
            ne_position_interm_cooling: "Position Intermediate Cooling",
            ne_draw_of_production: "Draw of Production",
            ne_draw_of_startup: "Draw of Startup",
            ne_draw_of_shutdown: "Draw of Shutdown",
            oe_draw_off_ratio: "Draw of Ratio",
            ne_feed_rg_coffee: "Feed R&D Coffee (kg)",
            ne_moisturising_water_flow: "Moisturising Water Flow (LPH)",
            ne_moisturising_water_ratio: "Moisturising Water Ratio (X)",
            ne_moisturising_water_quantity: "Moisturising Water Quantity (L)",
            ne_temp_intermediate_cooling: "Temperature Intermediate Cooling (°C)",
            ne_pressure_control_of_draw: "Pressure Control of Draw (bar)",
            ne_feed_water_temp: "Feed Water Temperature (°C)",
            ne_feed_water_flow: "Feed Water Flow (LPH)",
            ne_drag_chain_conveyor_stopping_time: "Drag chain conveyor stopping time (sec)",
            ne_steam_setpoint_for_blowdown: "Steam Setpoint for Blow-Down (bar)",
            ne_line_vaccum_time_delay_setpoint: "Line Vacuum Time Delay Setpoint (sec)",
            ne_percolator_vaccumtime_delay_setpoint: "Percolator Vacuum Time Delay Setpoint (sec)",
            ne_discharge_valve_closing_time: "Discharge Valve Closing Time (sec)",
            ne_discharge_valve_cls_delay_setpoint: "Discharge Valve Closing Delay Setpoint (sec)",
            ne_reserved_weight_in_weighing_hopper: "Reserved Weight in Weighing Hopper (kg)",
            ne_lowlevel_signal_delaytime_filling: "Low Level Signal Delay Time During Filling (sec)",
            ne_preheater_outlet_tempsetpoint_stop: "Perheater Outlet Temperature Setpoint during Stopping (°C)",
            ne_perculator_dp_reverse_sp: "Perculator DP Reverse SP (bar)",
            ne_perculator_dp_normal_sp: "Perculator DP Normal SP (bar)",
            ne_perculator_max_pressure_sp: "Perculator Max Pressure SP (bar)",
            ne_hp_line_max_pressure_sp: "HP Line Max Pressure SP (bar)",
            ne_ventvalve_close_delay_time: "Vent Valve Close Delay Time (sec)",
            ne_ventvalve_position_selection: "Vent Valve Position",
            ne_ventvalve_cls_delaytime_aftr_moist: "Vent Valve Close Delay Time After Moisturising (sec)",
            ne_inline_filter_diff_pressure_alarm: "Inline Filter Differntial Pressure Alarm (bar)",
            ne_ic_dp_alarm_sp: "IC DP Alarm SP",
            ne_cooler1_dp_alarm_sp: "Cooler 1 DP Alarm SP",
            ne_cooler2_dp_alarm_sp: "Cooler 2 DP Alarm SP",
            ne_number_of_draws: "Number of Draws",
            ne_cycle_time: "Cycle Time (min)",
            ne_weak_extract_concentration: "Weak Extract Concentration (%)",
            ne_weak_extract_quantity: "Weak Extract Quantity (kl)",
            ne_rework_added: "Rework Added (kg)",
            ne_roasted_yield: "Roasted Yield (%)",
            ne_cold_cells: "Cold Cells",
          },
        }, {
          sub_header: "IES Cold Brew",
          header: "Slurry SCC Unit",
          fields: {
            scc_slurry_ratio: "Slurry Ratio (%)",
            scc_mode: "Mode",
            scc_liquid_flow: "SCC Liquid Flow (LPH)",
            scc_internal_strip_rate: "SCC Internal Strip Rate (%)",
            scc_offset_temp: "SCC Offset Temperature (°C)",
            scc_external_strip_rate: "SCC External Strip Rate (%)",
            scc_partial_drain: "SCC Partial Drain (%)",
            scc_hot_cool_mode: "Hot/Cool Mode",
            scc_washtank_slurry_ratio: "Wash Tank Slurry Ratio (%)",
          },
        }, {
          header: "RDC Reciepe",
          fields: {
            rdc_temp_setpoint: "RDC Temp. Setpoint (°C)",
            rdc_pressure_setpoint: "RDC Pressure Setpoint (bar)",
            rdc_inlet_temp: "RDC Inlet Temperature (°C)",
            rdc_outlet_temp: "RDC Outlet Temperature (°C)",
            rdc_liquid_steeping_time: "Liquid Steeping Time (hr)",
            rdc_raw_extract_outlet_concentration: "Raw Extract Outlet Concentration (%)",
            rdc_raw_extract_qty: "Raw Extract Quantity (kl)",
            rdc_roasted_coffee_yield: "Roasted Coffee Yield (%)",
            rdc_slurry_mixing_tanklevel: "Slurry Mixing Tank Level (%)",
            rdc_product_feed_flow: "Product Feed Flow L/hr",
          },
        }, {
          header: "RDC Analogue Values",
          fields: {
            rdc_product_inlet_temp: "Product Inlet Temperature (°C)",
            rdc_regen_heater_product_outlet_temp: "Regen Heater Product Outlet Temperature (°C)",
            rdc_product_heater_temp: "Product Heater Temperature (°C)",
            rdc_top_temp: "RDC Top Temperature (°C)",
            rdc_product_cooler_temp: "Product Cooler Temperature (°C)",
            rdc_cooling_tower_water_inlet_temp: "Cooling Tower Water Inlet Temperature (°C)",
            rdc_hot_water_tank_temp: "Hot Water Tank Temperature (°C)",
            rdc_regen_cooler_water_outlet_temp: "Regen Cooler Water Outlet Temperature (°C)",
            rdc_regen_cooler_water_inlet_temp: "Regen Cooler Water Inlet Temperature (°C)",

            rdc_inlet_pressure_kpa: "RDC Inlet Pressure (kPa)",
            rdc_discharge_pressure_kpa: "RDC Discharge Pressure (kPa)",
            rdc_discharge_pump_inlet_pressure_kpa: "RDC Discharge Pump Inlet Pressure (kPa)",
            rdc_discharge_pump_pressure_kpa: "RDC Discharge Pump Pressure (kPa)",
            rdc_seal_water_pressure_kpa: "Seal Water Pressure (kPa)",
            rdc_product_feed_pump_discharge_pressure_kpa: "Product Feed Pump Discharge Pressure (kPa)",
            rdc_high_pressure_water_pressure_kpa: "High Pressure Water Pressure (kPa)",

            rdc_bottom_bearing_temp: "RDC Bottom Bearing Temperature (°C)",
          },
        }, {
          header: "SCC Analogue Values",
          fields: {
            slurry_mixing_tanklevel: "Slurry Mixing Tank Level (%)",
            slurry_water_flow: "Slurry Water Flow (L/hr)",
            mass_flow: "Mass Flow (kg/hr)",
            product_inlet_temp: "Product Inlet Temperature (°C)",
            product_feed_flow_rate: "Product Feed Flow Rate (L/hr)",
            product_feed_pump_pressure_kpa: "Product Feed Pump Pressure (kPa)",
            regeneration_hex_outlet_temp: "Regeneration Hex Outlet Temperature (Feed Side) (°C)",
            product_heater_temp: "Product Heater Temperature (°C)",
            product_discharge_temp: "Product Discharge Temperature (°C)",

            scc_top_vapour_temp: "SCC Top Vapour Temperature (°C)",
            scc_bottom_product_temp: "SCC Bottom Product Temperature (°C)",
            scc_stripping_steam_flow: "SCC Stripping Steam Flow (kg/hr)",
            scc_inlet_strip_rate: "SCC Inlet Strip Rate (%)",
            scc_discharge_level: "SCC Discharge Level (%)",
            scc_discharge_pump1_pressure_kpa: "SCC Discharge Pump 1 Pressure (kPa)",
            scc_discharge_pump2_pressure_kpa: "SCC Discharge Pump 2 Pressure (kPa)",

            system_vacuum_pressure_kpa: "System Vacuum Pressure (kPa)",
            condensate_flow: "Condensate Flow (kg/hr)",
            condensate_strip_rate: "Condensate Strip Rate (%)",
            condensate_temp: "Condensate Temperature (°C)",
            condensate_subcooler_temp: "Condensate Sub Cooler Temperature (°C)",
            condensate1_ctw_return_temp: "Condensate 1 CTW Return Temperature (°C)",

            regen_heater_water_inlet_temp: "Regen Heater Water Inlet Temperature (°C)",
            regen_heater_water_outlet_temp: "Regen Heater Water Outlet Temperature (°C)",

            mill_motor_current: "Mill Motor Current",
            decanter1_back_pressure: "Decanter 1 Back Pressure (kPa)",
            aroma_tank_temp: "Aroma Tank Temperature (°C)",
            aroma_tanklevel: "Aroma Tank Level",
            chilled_water_inlet_temp: "Chilled Water Inlet Temperature (°C)",
            process_water_4pressure: "Process Water 4 Pressure (kPa)",
            ctw_inlet_temp: "CTW Inlet Temperature (°C)",
          },
        }, {
          sub_header: "NCL GEA FIC Extraction",
          header: "Time Setting of all Modes",
          fields: {
            after_run_empty: "After Run Empty (sec)",
            mixing_time: "Mixing Time (sec)",
            mixer_emptying: "Mixer Emptying (sec)",
            blow_out_1st_time: "Blow Out 1st Time (sec)",
            vessel_flush_cool: "Vessel Flush & Cool (sec)",
            vessel_inlet_flush: "Vessel Inlet Flush (sec)",
            preheat_spend_ground_pipe: "Pre-Heat Spend Ground Pipe (sec)",
            vessel_vacuum_suction: "Vessel Vacuum Suction (sec)",
          },
        }, {
          header: "Control Setting of all Modes",
          fields: {
            coffee_bean_batch_size: "Coffee Bean Batch Size (Kg)",
            water_amount_mixer: "Water Amount Mixer",
            draw_off_pressure: "Draw Off Pressure",
            feed_water_start_temp: "Feed Water Start Temp. (°C)",
            feed_water_operating_temp: "Feed Water Operating Temp. (°C)",
            feed_water_pressure: "Feed Water Pressure",
            feed_water_flow: "Feed Water Flow",
            soaking_water_pressure: "Soaking Water Pressure",
            service_water_pressure: "Service Water Pressure",
          },
        }, {
          header: "Timer Settings for Dual Split Mode",
          fields: {
            td_hydrolysis_draw_off_time: "Hydrolysis Draw Off Time (sec)",
            td_aroma_draw_off_time: "Aroma Draw Off Time (sec)",
            td_post_run_draw_off_time: "Post Run Draw Off Time (sec)",
            td_soaking_waiting_time: "Soaking Waiting Time (sec)",
          },
        }, {
          header: "Control Settings for Dual Mode",
          fields: {
            cd_soaking_water_flow: "Soaking Water Flow",
            cd_soaking_water_temp: "Soaking Water Temp. (°C)",
          },
        }, {
          header: "Timer Settings for Single Split Mode",
          fields: {
            ts_hydrolysis_draw_off_time: "Hydrolysis Draw Off Time (sec)",
            ts_aroma_draw_off_time: "Aroma Draw Off Time (sec)",
            ts_post_run_draw_off_time: "Post Run Draw Off Time (sec)",
            ts_pressure_build_up: "Pressure Build Up (sec)",
            ts_hydrolysis_draw_off_weight: "Hydrolysis Draw Off Weight (kg)",
            ts_aroma_draw_off_weight: "Aroma Draw Off Weight (kg)",
            ts_flash_tank_ratio: "Flash Tank Ratio (%)",
          },
        }, {
          header: "Control Settings for Single Split Mode",
          fields: {
            cs_extract_reheat_temp: "Extract Re-Heat Temp. (°C)",
            cs_soaking_water_flow: "Soaking Water Flow",
            cs_soaking_water_temp: "Soaking Water Temp. (°C)",
          },
        }
      ],
      grinding: [{
        tableHeader: {
          grind_name: "Grinder Name",
          action: "Action",
        },
        details: [
          {
            type: "Sieve Analysis(Old)",
            fields: {
              grind_name: "Selected Grinder",
              sieve_plus_30: "5",
              sieve_plus_40: "8",
              sieve_plus_50: "12",
              sieve_plus_60: "18",
              pan: "Pan",
              moisture: "Moisture (%)",
              bulk_density: "Bulk Density (g/cc)",
            }
          },
          {
            type: "Sieve Analysis(New)",
            fields: {
              grind_name: "Selected Grinder",
              sieve_plus_30: "5",
              sieve_plus_40: "10",
              sieve_plus_50: "20",
              sieve_plus_60: "35",
              pan: "Pan",
              moisture: "Moisture (%)",
              bulk_density: "Bulk Density (g/cc)",
            }
          },
          {
            type: "Sieve analysis (Roast & Ground Coffee)",
            fields: {
              grind_name: "Selected Grinder",
              sieve_plus_30: "30",
              sieve_plus_40: "40",
              sieve_plus_50: "50",
              sieve_plus_60: "60",
              pan: "Pan",
              moisture: "Moisture (%)",
              bulk_density: "Bulk Density (g/cc)",
              microns: "Microns (mm)"
            }
          }
        ]
      }],
      scc_aroma_unit: [{
        fields: {
          au_feed_liquid_flow: "Feed Liquid Flow (kl)",
          au_internal_strip_rate: "Internal Strip Rate (%)",
          au_offset_temp: "Offset Temperature (°C)",
          au_external_strip_rate: "External Strip Rate (%)",
          au_partial_drain: "Partial Drain (%)",
          au_aroma_recovered: "Aroma Recovered (L)",
          au_hot_cool_mode: "Hot/Cool Mode"
        },
      }],
      decanter: [{
        fields: {
          dp_recovery: "Recovery",
        }
      }],
      centrifuge: [{
        fields: {
          rpm: "RPM",
          cp_feed_flow: "Feed Flow (kl)",
          cp_total_ejection_time: "Total Ejection Time",
        }
      }],
      evaporator: [{
        sub_header: "Evaporation Parameters",
        fields: {
          ep_feed_flow: "Feed Flow (m3/hr)",
          ep_feed_concentration: "Feed Concentration (%)",
          ep_qty_of_output: "Qty of Output (kl)",
          ep_input_extract_qty: "Input Extract Qty (kl)",
          ep_output_extract_concentration: "Output Extract Concentration (%)",

          ep_evaporator: "Evaporator",
          ep_type: "Type",
          ep_coffee_flow_inlet: "Coffee Flow Inlet (kl)",
          ep_coffee_flow_outlet: "Coffee Flow Outlet (kl)",
          ep_first_effect: "1st Effect",
          ep_second_effect: "2nd Effect",
          ep_third_effect: "3rd Effect",
          ep_fourth_effect: "4th Effect",
          ep_fifth_effect: "5th Effect",
          ep_finisher: "Finisher",
          ep_inlet_concentration: "Inlet Concentration (%)",
          ep_outlet_concentration: "Outlet Concentration (%)",
        }
      }],
      spray_drier: [{
        fields: {
          sd_spray_drier_no: "Spray Drier No.",
          sd_feed_flow: "Feed Flow",
          sd_infeed_concentration: "Infeed Concentration (%)",
          sd_infeed_temp: "Infeed Temperature (°C)",
          sd_air_inlet_temp: "Air Inlet Temperature (°C)",
          sd_air_outlet_temp: "Air Outlet Temperature (°C)",
          sd_chamber_pressure: "Chamber Pressure (mmwc)",
          sd_spray_pressure: "Spray Pressure (kg/cm2)",
          sd_no_of_nozzles: "No. of Nozzles/WC/WI",
          sd_phe_temp: "P.H.E Temperature (°C)",
          sd_nozzle_pressure: "Nozzle Pressure",
          sd_exhaust_air_damper_pos: "Exhaust Air Damper Position (%)",
          sd_cooling_air_damper_pos: "Cooling Air Damper Position (%)",
          sd_supply_air_damper_pos: "Supply Air Damper Position (%)",
          sd_co2: "CO2 (%)",
          sd_bulk_density: "Bulk Density (g/cc)",
          sd_moisture: "Moisture (%)",
          sd_colour_factor: "Colour Factor",
          sd_aroma_dosing: "Aroma Dosing",
          sd_cg_filter: "CG/Filter (%)",
          sd_microground: "Microground (%)"
        },
      },
      {
        header: "NCL-Multi Stage Dryer: Start Air",
        fields: {
          chamber_inlet_airfan_speed_h1e1g01: "Chamber Inlet Air Fan Speed H1E1G01 (%)",
          chamber_pressure_production_h1e1k03: "Chamber Pressure Production H1E1K03 (mbar)",
          chamber_pressure_atstartup_h1e1k03: "Chamber Pressure at Startup H1E1K03 (mbar)",
          sfb_inlet_airflow_h1e1k05: "SFB Inlet Air Flow H1E1K05 (%)",
          vf1_inlet_airflow_h1g1k01: "VF1 Inlet Air Flow H1G1K01 (%)",
          vf2_inlet_airflow_h1g1k04: "VF2 Inlet Air Flow H1G1K04 (%)",
          fines_return_airblower_speed_h1h1g01: "Fines Return Air Blower Speed H1H1G01 (%)",
          fines_return_blow_tough_valve_speed_h1h1r02: "Fines Return Blow Tough Valve Speed H1H1R02 (%)",
          feed_supply_pressure_h1b1k03: "Feed Supply Pressure H1B1K03 (bar)",
          feed_temp_start_output: "Feed Temperature Start Output (°C)",
          sa_feed_temp_h1b1k50: "Feed Temperature H1B1K50 (°C)",
          sa_nozzle_pressure: "Nozzle Pressure (bar)",
          chamber_inlet_air_temp_production: "Chamber Inlet Air Temperature – Production (°C)",
          chamber_outlet_air_temp: "Chamber Outlet Air Temperature (°C)",
          waiting_time_before_opening_nozzle2: "Waiting Time before Opening 2 Nozzle (sec)",
          waiting_time_before_opening_nozzle3: "Waiting Time before Opening 3 Nozzle (sec)",
          waiting_time_before_opening_nozzle4: "Waiting Time before Opening 4 Nozzle (sec)",
          waiting_time_before_opening_nozzle5: "Waiting Time before Opening 5 Nozzle (sec)",
          waiting_time_before_opening_nozzle6: "Waiting Time before Opening 6 Nozzle (sec)",
          hp_pump_spd_with_nozzle1: "HP Pump Speed with 1 Nozzle (%)",
          pr_sp_before_hp_pump_speed_controller_outo: "Pr. SP before Hp Pump Speed Controller Outo (bar)",
          nozzle_pressure_with_nozzle1_step2: "Nozzle Pressure with 1 Nozzle (Second Step)",
          nozzle_pressure_with_nozzle1_and_2_step1: "Nozzle Pressure with 1 & 2 Nozzle (First Step) (bar)",
          nozzle_pressure_with_nozzle2_step2: "Nozzle Pressure with 2 Nozzle (Second Step) (bar)",
          nozzle_pressure_with_nozzle3_step1: "Nozzle Pressure with 3 Nozzle (First Step) (bar)",
          nozzle_pressure_with_nozzle3_step2: "Nozzle Pressure with 3 Nozzle (Second Step) (bar)",
          nozzle_pressure_with_nozzle4_step1: "Nozzle Pressure with 4 Nozzle (First Step) (bar)",
          nozzle_pressure_with_nozzle4_step2: "Nozzle Pressure with 4 Nozzle (Second Step) (bar)",
          nozzle_pressure_with_nozzle5_step1: "Nozzle Pressure with 5 Nozzle (First Step) (bar)",
          nozzle_pressure_with_nozzle5_step2: "Nozzle Pressure with 5 Nozzle (Second Step) (bar)"
        },
      },
      {
        header: "Start Heat",
        fields: {
          chamber_inlet_air_temp_h1e1k01: "Chamber Inlet Air Temperature H1E1K01 (°C)",
          sfb_inlet_air_temp_h1e1k06: "SFB Inlet Air Temperature H1E1K06 (°C)",
          vf1_inlet_air_temp_h1g1k02: "VF1 Inlet Air Temperature H1G1K02 (°C)",
          vf2_inlet_air_temp_h1g1k03: "VF2 Inlet Air Temperature H1G1K03 (°C)"
        },
      },
      {
        header: "Production Stop Parameters",
        fields: {
          feed_tanklevel_production_stop_sp: "Feed Tank Level Production Stop SP (%)",
          density_limit_production_stop: "Density Limit, Production Stop (kg/m3)"
        },
      },
      {
        header: "CIP Parameters",
        fields: {
          feed_tanklevel_cip: "Feed Tank Level, CIP (%)",
          evap_return_line_conductivity_sp: "Evap Return Line Conductivity SP (mS)"
        },
      },
      {
        header: "Dryer Operation Screen",
        fields: {
          co2_h1b1k30: "CO2 H1B1K30 (kg/hr)",
          n2_h1b1k31: "N2 H1B1K31 (kg/hr)",
          do_feed_temp_h1b1k50: "Feed Temp. H1B1K50 (°C)",
          feed_pressure_h1b1k60: "Feed Pressure H1B1K60 (bar)",
          concentrate_pump_h1b1k03: "Concentrate Pump H1B1K03 (bar)",
          dryer_feed_h1b1p20: "Dryer Feed H1B1P20 (kg/hr)",
          inlet_airflow_h1e1g01: "Inlet Air Flow H1E1G01 (%)",
          inlet_airtemp_h1e1k01: "Inlet Air Temp. H1E1K01 (°C)",
          outlet_airtemp_h1e1k02: "Outlet Air Temp. H1E1K02 (°C)",
          chamber_pressure_h1e1k03: "Chamber Pressure H1E1K03 (mbar)",
          pressure_to_open_gasket_in_sd_to_fbd_h1e1k04: "Pressure to open Gasket in SD to FBD H1E1K04 (mbar)",
          bottom_airflow_h1e1k05: "Bottom Air Flow H1E1K05 (%)",
          airtemp_to_bottom_of_sd_h1e1k06: "Air Temp. to bottom of SD H1E1K06 (°C)",
          hotair_to_fbd_flow_h1g1k01: "Hot Air to FBD Flow H1G1K01 (%)",
          hotair_to_fbd_temp_h1g1k02: "Hot Air to FBD Temp. H1G1K02 (°C)",
          fbd_outlet_airtemp_h1p1p09: "FBD Outlet Air Temp. H1P1P09 (°C)",
          bottom_temp_h1e1p05: "Bottom Temp. H1E1P05 (°C)",
          coldair_to_fbd_flow_h1g1k04: "Cold Air to FBD Flow H1G1K04 (%)",
          fines_return_airblower_speed_h1h1g01: "Fines Blower H1H1G01 (%)",
          fines_return_blow_tough_valve_speed_h1h1r02: "Gate Valve on bottom of BFH H1H1R02 (%)",
          bag_filter_house_bottom_pressure_h1h1p04: "Bag Filter House bottom Pressure H1H1P04 (mbar)",
          bag_house_pressure_h1f1p01: "Bag House Pressure H1F1P01 (mbar)",
          steam_pressure_to_airheat_exhaust_h1e1k31l: "Steam Pressure to Air Heat Exhaust H1E1K31L (bar)",
          coldair_to_fbd_temp_h1g1k03: "Cold Air to FBD Temp. H1G1K03 (°C)",
        }
      }, {
        header: "Stop Feed",
        fields: {
          nozzle_pressure_before_stopping_with_nozzle1: "Nozzle Pressure before Stopping with Nozzle 1 (bar)",
          nozzle_pressure_before_stopping_with_nozzle2: "Nozzle Pressure before Stopping with Nozzle 2 (bar)",
          nozzle_pressure_before_stopping_with_nozzle3: "Nozzle Pressure before Stopping with Nozzle 3 (bar)",
          nozzle_pressure_before_stopping_with_nozzle4: "Nozzle Pressure before Stopping with Nozzle 4 (bar)",
          nozzle_pressure_before_stopping_with_nozzle5: "Nozzle Pressure before Stopping with Nozzle 5 (bar)",
          nozzle_pressure_before_stopping_with_nozzle6: "Nozzle Pressure before Stopping with Nozzle 6 (bar)",
        }
      }, {
        header: "Emptying",
        fields: {
          chamber_inlet_airfan_speed: "Chamber Inlet Air Fan Speed (%)",
          waiting_time_emptying_dryer: "Waiting Time Emptying Dryer (sec)"
        }
      }, {
        header: "Dryer feed system CIP",
        fields: {
          feed_supply_pressure: "Feed Supply Pressure (bar)",
          cip_flush_time_for_dryer_feed_system: "CIP Flush Time for Dryer Feed System (sec)",
        }
      },
      {
        header: "Sub Loop Control",
        fields: {
          sfb_powder_layer_max_dpm: "SFB Powder Layer, max DP M (bar)",
          sfb_valve_opening_time: "SFB Valve Opening Time (sec)",
          factor_for_co2_injector: "Factor for CO2 Injector (g/kg)",
          factor_for_n2_injection: "Factor for N2 Injector (g/kg)",
          co2_injection: "CO2 Injection",
          n2_injection: "N2 Injection"
        }
      }
      ],
      agglomeration: [{
        header: "Preconditioning (Feed, Milling & Agglomeration)",
        fields: {
          feed_hopper_wt: "Feed Hopper Wt.",
          storage_hopper: "Storage Hopper DP (mmwc)",
          exhaust_hopper: "Exhaust Hopper DP (mmwc)",
          feed_rate_feed_line_damper: "Feed Rate/Feed Line Damper (%)",
          mill: "Mill (Hz of RPM)",
          vibrator: "Vibrator (%)",
          shrv: "SHRV (Hz or RPM or %)",
          pre_heater: "Pre-heater (bar)",
          steam: "Steam (°C)",
          number_of_nozzles: "Number of Nozzles",
          feed_nozzle_pressure: "Nozzle Pressure (bar)",
          water_dosing: "Water Dosing (L/hr)"
        }
      },
      {
        header: "Drying of Agglomerates (Main Tower Dryer & Fluid Bed Dryer)",
        fields: {
          agglo_drying_tower_process_airtemp: "Agglo Drying Tower-Process Air Temp. (°C)",
          blower1_temp1: "Blower-1 Temp. (°C)",
          blower2_temp: "Blower-2 Temp. (°C)",
          blower3_temp: "Blower-3 Temp. (°C)",
          blower1_temp2: "Blower-1 Temp. (°C) 2",
          supply_fan_dampler_position: "Supply Fan Dampler Position (%)",
          exhaust_fan_dampler_position: "Exhaust Fan Dampler Position (%)",
          fb_outlet_dampler_position: "FB Outlet Dampler Position (%)"
        }
      },
      {
        header: "Output Product Specifications",
        fields: {
          ops_moisture: "Moisture (%)",
          ops_bulk_density: "Bulk Density (g/cc)",
          ops_colour_factor_on_agtron: "Colour Factor on Agtron",
          ops_granules_strength_stability: "Granules Strength/Stability",
          ops_sediments_grade: "Sediments-Grade",
          ops_fines_percentage_pan_limit: "Fines Percentage/PAN limit (on 40/100/150 Mesh Size)"
        }
      },
      {
        header: "Particle Size Distribution/Size Separation/Oversize (Mesh sizes)",
        fields: {
          mesh_size_8: "8",
          mesh_size_12: "12",
          mesh_size_16: "16",
          mesh_size_20: "20",
          mesh_size_40: "40"
        }
      }
      ],
      freeze_drier: [{
        header: "Batch Dryer (FD-1): Pre-freezing, Foaming & Freezing",
        fields: {
          fd1_foaming_ratio: "Foaming Ratio (%)",
          fd1_extract_flow: "Extract Flow",
          fd1_air_mixing_flow: "Air Mixing Flow",
          fd1_slab_thickness: "Slab Thickness",
          fd1_belt_speed: "Belt Speed",
          fd1_bulk_density: "Bulk Density (g/cc)",
          fd1_coffee_flow_on_belt: "Coffee Flow on Belt",
          fd1_prefrezer_temp: "Pre-Freezer Temp.",
          fd1_co2_n2_pressure: "CO2/N2 Pressure",
          fd1_fines_melter_level_setpoint: "Fines Melter Level Setpoint",
          fd1_fines_melter_outlet_liquid_tempsetpoint: "Fines Melter Outlet Liquid Temeperature - Setpoint",
          fd1_fines_melter_motor_speed: "Fines Melter Motor Speed (%)",
          fd1_buffer_tanklevel_setpoint: "Buffer Tank Level Setpoint",
          fd1_buffer_tankmixer_motor_speed: "Buffer Tank Mixer Motor Speed (%)"
        }
      },
      {
        header: "Granulation & Tray Filling",
        fields: {
          fd1_prebreaker_speed: "Pre-Breaker Speed",
          fd1_mainbreaker_speed: "Main Breaker Speed",
          fd1_stage1_granulator1_speed: "Stage-1 Granulator-1 Speed",
          fd1_stage1_granulator1_temp: "Stage-1 Granulator-1 Temp.",
          fd1_stage1_granulator2_speed: "Stage-1 Granulator-2 Speed",
          fd1_stage1_granulator2_temp: "Stage-1 Granulator-2 Temp.",
          fd1_stage2_granulator_speed: "Stage-2 Granulator Speed",
          fd1_stage2_granulator_temp: "Stage-2 Granulator Temp.",
          fd1_tray_feeder_silo_product_temp: "Tray Feeder Silo Product Temp."
        }
      },
      {
        header: "Batch Dryer Heat Profile Settings",
        fields: {
          step1_ramptime_temp: "Step-1: Ramp Time & Temp.",
          step2_ramptime_temp: "Step-2: Ramp Time & Temp.",
          step3_ramptime_temp: "Step-3: Ramp Time & Temp.",
          step4_ramptime_temp: "Step-4: Ramp Time & Temp.",
          step5_ramptime_temp: "Step-5: Ramp Time & Temp.",
          step6_ramptime_temp: "Step-6: Ramp Time & Temp.",
          step7_ramptime_temp: "Step-7: Ramp Time & Temp.",
          step8_ramptime_temp: "Step-8: Ramp Time & Temp.",
          step9_ramptime_temp: "Step-9: Ramp Time & Temp."
        }
      },
      {
        header: "CONRAD (FD-2): Pre-freezing, Foaming & Freezing",
        fields: {
          fd2_foaming_ratio: "Foaming Ratio (%)",
          fd2_extract_flow: "Extract Flow",
          fd2_airmixing_flow: "Air Mixing Flow",
          fd2_slab_thickness: "Slab Thickness",
          fd2_belt_speed: "Belt Speed",
          fd2_bulk_density: "Bulk Density (g/cc)",
          fd2_coffee_flow_on_belt: "Coffee Flow on Belt",
          fd2_prefrezer_temp: "Pre-Freezer Temp.",
          fd2_co2_n2_pressure: "CO2/N2 Pressure",
          fd2_fines_melterlevel_setpoint: "Fines Melter Level Setpoint",
          fd2_fines_melter_outlet_liquid_tempsetpoint: "Fines Melter Outlet Liquid Temeperature - Setpoint",
          fd2_fines_melter_motor_speed: "Fines Melter Motor Speed (%)",
          fd2_buffer_tanklevel_setpoint: "Buffer Tank Level Setpoint",
          fd2_buffer_tankmixer_motor_speed: "Buffer Tank Mixer Motor Speed (%)"
        }
      }, {
        header: "Granulation & Tray Filling",
        fields: {
          fd2_prebreaker_speed: "Pre-Breaker Speed",
          fd2_mainbreaker_speed: "Main Breaker Speed",
          fd2_stage1_granulator1_speed: "Stage-1 Granulator-1 Speed",
          fd2_stage1_granulator1_temp: "Stage-1 Granulator-1 Temp.",
          fd2_stage1_granulator2_speed: "Stage-1 Granulator-2 Speed",
          fd2_stage1_granulator2_temp: "Stage-1 Granulator-2 Temp.",
          fd2_stage2_granulator_speed: "Stage-2 Granulator Speed",
          fd2_stage2_granulator_temp: "Stage-2 Granulator Temp.",
          fd2_tray_feeder_silo_product_temp: "Tray Feeder Silo Product Temp.",
          fd2_tray_weight: "Tray Weight"
        }
      },
      {
        header: "Temperature Profile",
        fields: {
          cycle_time: "Cycle Time",
          heating_zone1_temp_sp: "Heating Zone-1 Temp. SP",
          heating_zone2_temp_sp: "Heating Zone-2 Temp. SP",
          heating_zone3_temp_sp: "Heating Zone-3 Temp. SP",
          heating_zone4_temp_sp: "Heating Zone-4 Temp. SP",
          heating_zone5_temp_sp: "Heating Zone-5 Temp. SP",
          heating_zone6_temp_sp: "Heating Zone-6 Temp. SP",
          heating_zone7_temp_sp: "Heating Zone-7 Temp. SP",
          heating_zone8_temp_sp: "Heating Zone-8 Temp. SP",
          heating_zone9_temp_sp: "Heating Zone-9 Temp. SP",
          heating_zone10_temp_sp: "Heating Zone-10 Temp. SP",
          heating_zone11_temp_sp: "Heating Zone-11 Temp. SP",
          heating_zone12_temp_sp: "Heating Zone-12 Temp. SP"
        }
      },
      {
        header: "Product Specifications",
        fields: {
          ps_final_product_colour_factor: "Final Product Colour Factor",
          ps_output_bulk_density: "Output Bulk Density (g/cc)",
          ps_moisture: "Moisture (%)",
          ps_flavour_add_at_foaming: "Flavour Addition at Foaming (%)",
          ps_microground: "Microground (%)"
        }
      }
      ],
      premix_process_settings: [{
        fields: {
          pc_type: "Type",
          pc_ndc: "NDC (%)",
          pc_dc: "DC (%)",
          pc_coffee: "Coffee (%)",
          pc_sugar: "Sugar (%)",
          pc_salt: "Salt (%)",
          pc_flavour: "Flavour (%)",
          pc_foaming_creamer: "Foaming Creamer (%)",
          pc_other_ingredients: "Other Ingredients (micro)",
          pc_rpm_of_the_blender: "RPM of the Blender",
          pc_blending_time: "Blending Time",
          pc_bulk_density_of_finished_product: "Bulk Density of Finished Product"
        }
      }],
      oil_expeller: [{
        fields: {
          rg_type: "Beans Temp",
          rg_bean_type1: "Expeller Amps",
          rg_colour_factor1: "Expeller Frequency",
          rg_bean_type2: "Screw Feed RPM",
          rg_colour_factor2: "Oil Yield in Kgs",
          rg_chicory: "Oil Yield Ratio",
        }
      }],
    },
  },
  commercial: {
    SoftSchedule: {
      forms: {
        softSchedule: "Soft Schedule",
        softScheduleInfo: "Soft Schedule Information",
        softScheduleDetails: "Soft Schedule Details",
        softScheduleLines: "Soft Schedule Lines",
        noRecordsFound: "No Schedules",
        this_month: "This Month",
        this_week: "This Week",
        today: "Today",
        next_month: "Next Month",
        all: "All",
        noSchedulesThisMonth: "No Schedules in this month",
        noSchedulesThisWeek: "No Schedules in this week",
        noSchedulesToday: "No Schedules today",
        noSchedulesNextMonth: "No Schedules in next month",
        totalCapacityConsumed: "Total Capacity Consumed",
        sd: "SD",
        fd: "FD",
        algo: "Aglo",
        firstDate: "First Schedule Date",
        capacityProd: "Capacity Consumed",
        productionCapacity: "Production Capacity/day",
        capacityLeft: "Capacity Left",
        productionUnit: "Production Unit",
        customer: "Customer Sample Name",
        finalSchedule: "Final Schedule Date",
        orderNo: "Order No",
        orderLineNo: "Order Line No",
        orderDispatchNo: "Order Dispatch No",
        alternateSample: "Alternate Sample",
        customerSampleCode: "Customer Sample Code",
        confirm: "Confirm Production Plan",
        softNo: "Soft Schedule No",
        recordNo: "Record No",
        softScheduleLine: "Order Dispatch No",
        softScheduleDate: "Soft Schedule Date",
        orderQtyProd: "Order Qty to be Produced",
        capacityLeftPercentage: "Capacity Left Percentage",
        orderQtyLeft: "Order Qty Left",
        status: "Status",
        confirmProduction: "Confirm Production",
        productionScheduleRecordNumber: "Production Schedule Record Number",
      },
      grid: {
        record_id: "Soft Schedule No",
        order_number: "Order No",
        order_dispatch_number: "Order Dispatch No",
        alternative_sample: "Alternative Sample Code",
        customer_sample_code: "Customer Sample Code",
        production_unit: "Production Unit (Entity)",
        capacity_per_day: "Production Capacity/day",
        schedule_start_date: "First Schedule Date",
        schedule_end_date: "Final Schedule Date",
        status: "Status",
        attachments_count: "Attachment"
      }
    },
    ProductionSchedule: {
      statusBar: {
        productionPlan: "Production Plan",
        pendingwithProductionAssistant: "Pending with Production Assistant",
        pendingwithCommercial: "Pending with Commercial",
        containerInfo: "Container Information",
        cleaning: "Cleaning",
        shutdown: "Shutdown",
        closed: "Closed",
        cancelled: "Cancelled",
      },
      forms: {
        productionSchedule: "Production Schedule",
        factoryCode: "Factory Code",
        production_unit: "Production Unit",
        packingUnit: "Packing Unit",
        calendarBlockingSuccess: "Date blocked successfully.",
        plannedDate: "Planned Date",
        dispatchDetails: "Dispatch Details",
        category: "Category",
        Create: "Record created successfully",
        ODInfo: "Order Dispatch Details",
        QuoteInfo: "Quote Details",
        SSLineInfo: "Soft Schedule Line Details",
        PPInfo: "Planned Production Details",
        ActualProductionInfo: "Actual Production Details",
        ContainerDetails: "Container Details",
        createContainer: "Add Container Details",
        editContainer: "Edit Container Details",
        createPP: "Create Planned Production",
        updatePP: "Update Planned Production",
        add: "Add",
        update: "Update",
        updateSuccess: "Record Updated Successfully.",
        edit: "Edit",
        sendToMC: "Send to Manager Commercial",
        sendToMCSuccess: "Record sent to Manager Commercial Successfully.",
        sendToPA: "Send to Production Assistant",
        startDateTodayNote: "Please change the Planned Start Date. The Planned Start Date cannot be the current date when submitting to Production.",
        closeRecord: "Close Record",
        sendToPASuccess: "Record sent to Production Assistance Successfully.",
        closedSuccess: "Record closed Successfully.",
        psInfo: "Production Schedule Information",
        shiftInfo: "Blocked Shift Information",
        containerPlannedDate: "Container Planned Date",
        logisticsDate: "Logistics Date",
        portOfLoading: "Port Of Loading",
        venderName: "Vendor Name",
        shippingLines: "Shipping Lines",
        containerSailDate: "Container Sail Date",
        actualDispatchDate: "Actual Dispatch Date",
        actualDeliveryDate: "Actual Delivery Date",
        emptyContainerDate: "Empty Container Date",
        sizeOfContainer: "Size of Container",
        customerHandlingAgent: "Customer Handling Agent",
        indentedQuantity: "Indent Quantity",
        tentativeSailingDate: "Tentative Sailing Date",
        freightStatus: "Freight Status",
        freightStatusOther: "Freight Status Details",
        freightStatusPrepaid: "Prepaid",
        freightStatusCollect: "Collect",
        freightStatusOtherOption: "Other",
        freightAmount: "Freight Amount",
        currency: "Currency",
        freightStatusOtherPlaceholder: "Enter freight status details (max 100 characters)",
        freightAmountPlaceholder: "Enter amount (max 8 digits, 3 decimals)",
        remarksPlaceholder: "Enter remarks (max 250 characters)",
        allocationInformation: "Allocation Information",
        allocationInfo: "allocation_info",
        allocation_details: "Allocation Details",
        blendSheetInformation: "Blend Sheet Information",
        blendSheetInfo: "blend_sheet_info",
        sample_information: "Sample Information",
        production_schedule_start_date: "Production Schedule Start Date",
        issue_days: "Issue Days",
        issue_date: "Issue Date",
        production_schedule_end_date: "Production Schedule End Date",
        production_end_date: "Production End Date",
        production_start_date: "Production Start Date",
        end_date: "End Date",
        from_date: "From Date",
        to_date: "To Date",
        planned_quantity: "Planned Quantity ",
        to_be_planned_quantity: "To Be Planned Quantity",
        actual_produced_quantity: "Actual Produced Quantity",
        actual_produced_quantity_tooltip: "Shift 1 + Shift 2 + Shift 3",
        production_unit: "Production Unit",
        production_line: "Production Line",
        alternative_sample: "Alternative Sample",
        alternativeCode: "Alternative Sample Code",
        remarks: "Remarks",
        per_hour_capacity: "Per Hour Capacity",
        planned_quantity_kg: "Planned Qty (KG)",
        planning_mode: "Planning Mode",
        production_capacity: "Production Capacity (KG/hr)",
        status: "Status",
        auto: "Auto",
        manual: "Manual",
        single_day: "Single Day",
        multiple_days: "Multiple Days",
        day_shift: "Day Shift",
        cross_shift: "Cross Shift",
        actual_day_shift: "Actual Day Shift",
        actual_cross_shift: "Actual Cross Shift",
        actual_production_start_date: "Actual Production Start Date",
        actual_shift1: "Actual Shift 1",
        actual_production_end_date: "Actual Production End Date",
        actual_shift2: "Actual Shift 2",
        any_deviation: "Any Deviation",
        actual_shift3: "Actual Shift 3",
        actual_produced_quantity: "Actual Produced Quantity",
        shift1: "Shift 1",
        shift2: "Shift 2",
        shift3: "Shift 3",
        shift1Time: "Shift 1 (06:00 - 14:00)",
        shift2Time: "Shift 2 (14:00 - 22:00)",
        shift3Time: "Shift 3 (22:00 - 06:00)",
        ODPendingQty: "OD Pending Qty after this line",
        ODPendingQtyTooltip: "To be planned quantity - planned quantity",
        start_date: "Start Date",
        end_date: "End Date",
        addition: "+ Add",
        contractReports: "Contract Reports",
        autoIssueNote: "Note: Please add issue details for all planned production records.",
        dateFilter: "Date Filter",
        dateFilterApplied: "Date Filter Applied:",
        applyFilter: "Apply Filter",
        clearFilter: "Clear Filter",
        calendarBlocking: "Calendar Blocking",
        quickPreview: "Quick Preview",
        calendar: "Calendar",
        confirmBlock: "Confirm Block",
        insufficientCapacityMsg: "Selected date does not have sufficient shift capacity.",
        cancelPSRecord: "Cancel PS Record",
        cancelSchedule: "Cancel Schedule",
        cancelScheduleHeader: "Confirm Production Schedule Cancellation",
        cancelShutDownHeader: "Confirm Shutdown Day Cancellation",
        cancelCleaningHeader: "Confirm Cleaning Day Cancellation",
        cancelledSuccess: "Production Schedule Cancelled Successfully.",
        cancelScheduleAboutTo: "You are about to cancel",
        cancelScheduleActionsWill: "The following actions will occur automatically:",
        calendarBlocksReleased: "Calendar Blocks to be Released",
        capacityRestored: "Capacity to be Restored",
        odPendingQtyUpdated: "OD Pending Quantity After Cancellation",
        cancelScheduleCannotUndo: "Cancellation Impacts",
        cancelScheduleBullet1: "Status will change from Planned → Cancelled",
        cancelScheduleBullet2: "Reserved calendar slots will be released",
        cancelScheduleBullet3: "OD Pending Quantity will increase by ",
        cancelScheduleBullet4: "Record will remain available for audit purposes",
        cancelScheduleBullet5: "This action cannot be Undone",
        shutDownCancelScheduleBullet1: "Reserved calendar slot ",
        shutDownCancelScheduleBullet1_1: " will be released for capacity blocking",
        shutDownCancelScheduleBullet2: "Record will remain available for audit purposes",
        shutDownCancelScheduleBullet3: "This action cannot be Undone",
        kg: " Kgs",
        to: " to ",
        addContainer: "+ Add Container",
        containerUpdate: "Container Update",
        createshiftHeader: "Create Production Schedule Line",
        editshiftHeader: "Update Production Schedule Line",
        deleteShift: "Delete Production Schedule Shift",
        deleteRecordMsg: "Are you sure you want to delete this record?",
        createActualshiftHeader: "Create Actual Production Schedule Line",
        editActualshiftHeader: "Update Actual Production Schedule Line",
        deleteActualShift: "Delete Actual Production Schedule Shift",
        sumofshifts: "Sum of Actual Shifts cannot be 0.",
        number_of_containers: "Number Of Containers",
        actual_day_shift_label: "Actual Day Shift",
        actual_cross_shift_label: "Actual Cross Shift",
        total_planned_quantity: "Total Planned Quantity",
        total_quantity: "Total Quantity",
        total_quantity_tooltip: "Sum of Actual Quantity",
        actualShiftCreateSuccess: "Actual Production Schedule Created Successfully.",
        actualShiftUpdateSuccess: "Actual Production Schedule Updated Successfully.",
        actualShiftDeleteSuccess: "Actual Production Schedule Deleted Successfully.",
        actualDeleted: "Actual Production Schedule Deleted",
        actualCreated: "Actual Production Schedule Created",
        editActualPSRecord: "Edit Actual Production Schedule Record",
        deleteActualPSRecord: "Delete Actual Production Schedule Record",
        selectOD: "Select Order Dispatch Number",
        ODNumber: "Order Dispatch Number",
        availableOn: "Available On",
        shift1Label: "Shift 1: ",
        shift2Label: "Shift 2: ",
        shift3Label: "Shift 3: ",
        cleaningShutdown: "Cleaning / Shutdown",
        availableLabel: "Available",
        partiallyBlockedLabel: "Partially Blocked",
        shutdownLabel: "Shutdown",
        cleaningLabel: "Cleaning",
        shutdownCleaningLabel: "Shutdown / Cleaning",
        fullyBooked: "Blocked",
        partiallyAvailable: "Partially Available",
        partially: "Partially",
        available: "Available",
        date: "Date",
      },
      orderDispatchDetailsString: {
        order_dispatch_number: "Order Dispatch Number",
        customer_required_date: "Customer Required Date",
        order_line_number: "Order Line Item",
        shipment_date: "Expected Dispatch Date",
        order_number: "Order Number",
        expected_readiness_date: "Expected Readiness Date",
        packing_configuration: "Packing Configuration",
        ready_for_dispatch_date: "Ready For Dispatch Date",
        contract_number: "Contract Number",        
        contract_date: "Contract Date",
        finalized_sample_code: "Alternative Sample Code",
        packing_unit: "Packing Unit",
        order_dispatch_quantity: "Order Dispatch Quantity",
        shipment_information: "Shipping Information",
        to_be_planned_quantity: "To Be Planned Quantity",
        product_code: "Product Code",
      },
      orderDispatchCreateEditString: {
        order_dispatch_number: "Order Dispatch Number",
        customer_required_date: "Customer Required Date",
        order_line_number: "Order Line Item",
        expected_dispatch_date: "Expected Dispatch Date",
        order_number: "Order Number",
        expected_readiness_date: "Expected Readiness Date",
        to_be_planned_quantity: "To Be Planned Quantity",
        ready_for_dispatch_date: "Ready For Dispatch Date",
        order_dispatch_quantity: "Order Dispatch Quantity",
        packing_configuration: "Packing Configuration",
        packing_unit: "Packing Unit",
        finalized_sample_code: "Alternative Sample Code",
        product_code: "Product Code",
      },
      softScheduleLineDetailsString: {
        record_id: "Record Number",
        order_dispatch_number: "Order Dispatch Number",
        scheduling_date: "Soft Schedule Date",
        capacity_per_day: "Production Capacity/Day",
        capacity_occupied: "Capacity Consumed",
        order_quantity_left: "Order Quantity Left",
        capacity_left: "Capacity Left",
        capacity_left_percentage: "Capacity Left Percentage",
        status: "Soft Schedule Status"
      },
      quoteDetailsString: {
        quote_number: "Quote Number",
        account_name: "Customer Name",
        quote_line_number: "Quote Line Item Number",
        confirm_order_quantity: "Confirmed Quantity",
        customer_sample_code: "Customer Sample",
        customer_sample_name: "Customer Sample Name",
        port_loading_name: "Port Of Loading",
        destination: "Destination",
        quote_category: "Quote Category"
      },
      plannedProductionStrings: {
        production_unit_name: "Production Unit",
        issue_date: "Issue Date",
        production_line: "Production Line",
        issue_days: "Issue Days",
        production_alternative_sample_code: "Alternative Sample Code",
        shift1: "Shift 1",
        production_alternative_sample_remarks: "Alternative Sample Remarks",
        shift2: "Shift 2",
        per_hour_capacity: "Per Hour Capacity",
        shift3: "Shift 3",
        production_schedule_start_date: "Planned Start Date",
        planned_quantity: "Planned Quantity",
        production_schedule_end_date: "Planned End Date",
      },
      containerColsString: {
        record_id: "Container Record Id",
        logistic_date_formatted: "Logistics Date",
        container_planned_date_formatted: "Container Planned Date",
        vendor_name: "Vendor Name",
        port_of_loading_formatted: "Port Of Loading",
        empty_container_date_formatted: "Empty Container Date",
        shipping_lines: "Shipping Lines",
        container_sail_date_formatted: "Container Sail Date",
        actual_dispatch_date_formatted: "Actual Dispatch Date",
        actual_delivery_date_formatted: "Actual Delivery Date",
        size_of_container_id_formatted: "Size Of Container",
        customer_handling_agent: "Customer Handling Agent",
        indent_quantity: "Indent Quantity",
        tentative_sailing_date_formatted: "Tentative Sailing Date",
        freight_status_formatted: "Freight Status",
        freight_status_other: "Freight Status Details",
        freight_amount: "Freight Amount",
        currency_formatted: "Currency",
        remarks: "Remarks",
        action: "Action"
      },
      actualPlannedDetailsString: {
        record_number: "Record Number",
        actual_production_start_date_formatted: "Actual Start Date",
        actual_production_end_date_formatted: "Actual End Date",
        actual_shift1: "Shift 1 (06:00 - 14:00)",
        actual_shift2: "Shift 2 (14:00 - 22:00)",
        actual_shift3: "Shift 3 (22:00 - 06:00)",
        actual_produced_quantity: "Actual Produced Quantity",
      },
      plannedColsString: {
        index: "Sr. No.",
        production_schedule_start_date: "Start Date",
        production_schedule_end_date: "End Date",
        shift1_quantity: "Shift 1 (06:00 - 14:00)",
        shift2_quantity: "Shift 2 (14:00 - 22:00)",
        shift3_quantity: "Shift 3 (22:00 - 06:00)",
        issue_days: "Issue Days",
        issue_date: "Issue Date",
        planned_quantity: "Planned Quantity",
        action: "Action"
      },
      actualPlannedColsString: {
        record_number: "Record Number",
        actual_production_start_date_formatted: "Actual Start Date",
        actual_production_end_date_formatted: "Actual End Date",
        actual_shift1: "Shift 1 (06:00 - 14:00)",
        actual_shift2: "Shift 2 (14:00 - 22:00)",
        actual_shift3: "Shift 3 (22:00 - 06:00)",
        actual_produced_quantity: "Actual Produced Quantity",
        action: "Action"
      },
      blendSheetGridCols: {
        batch_number: "Batch Number",
        entity_name: "Entity",
        product_category: "Product Category",
        powder_required_kgs: "Powder Required Qty",
        production_quantity: "Production Quantity",
        status: "Status",
      },
      errorMsgs: {
        ProdStartDateCannotAfterProdEndDate:
          "Production Start Date cannot be after Production End Date",
        pleaseSelectTheProdEndDate: "Please select the production end date",
      },
      view: {
        record_number: "Record Number",
        status: "Status",
      },
      cleaningShutdownDetails: {
        record_id: "Record Number",
        production_schedule_status_name: "Status",
        production_unit_name: "Production Unit",
        schedule_type: "Schedule Type",
        production_line: "Production Line",
        production_schedule_start_date: "Schedule Start Date",
        production_schedule_end_date: "Schedule End Date",
      },
      shiftInfoDetails: {
        shift1_blocked_hours: "Shift 1 (06:00–14:00)",
        shift2_blocked_hours: "Shift 2 (14:00–22:00)",
        shift3_blocked_hours: "Shift 3 (22:00–06:00)",
      },
      grid: {
        record_no: "Record Number",
        customer: "Customer",
        customer_sample_name: "Customer Sample Name",
        order_dispatch: "Order Dispatch",
        quantity_schedule: "Order Dispatch Quantity",
        production_unit: "Production Unit",
        packing_unit: "Packing Unit",
        production_line: "Production Line",
        packing_configuration: "Packing Configuration",
        planned_quantity: "Planned Quantity",
        production_schedule_start_date: "Start Date",
        production_schedule_end_date: "End Date",
        alternative_sample_name: "Finalized Alternative Sample",
        actual_production_start_date: "Actual Production Start Date",
        actual_production_end_date: "Actual Production End Date",
        actual_produced_quantity: "Actual Produced Quantity",
        container_count: "Container Count",
        production_schedule_record_number: "Record Number",
        order_dispatch_number: "Order Dispatch Number",
        order_dispatch_quantity: "Order Dispatch Quantity",
        account_name: "Customer Name",
        vendor_name: "Vendor Name",
        shipping_lines: "Shipping Line",
        empty_container_date: "Empty Container Date",
        container_planned_date: "Container Planned Date",
        port_of_loading_name: "Port of Loading",
        size_of_container: "Container Size",
        indent_quantity: "Indent Quantity",
        created_by: "Created By",
        created_date: "Created Date",
      },
      allocationInfo: {
        po_number: "Purchase Order Number",
        item_name: "Item Name",
        po_qty: "PO Quantity",
        allocated_qty: "Allocated Quantity",
        status_of_po: "Status of PO",
        delivered_qty: "Delivered Quantity",
        balance_qty: "Balance Quantity",
        item_code: "Item Code",
        type_of_gc: "Type of Green Coffee",
        conversion_ratio: "Conversion Ratio",
        percentage: "Percentange",
        required_qty: "Required Quantity (kgs)",
        allocation_info: "Allocation information",
        planned_qty: "Planned Quantity",
        altrenative_sample_code: "Alternative Sample Code",
        remarks: "Remarks",
        production_unit: "Production Unit"
      },
      dispatchDetails: {
        dispatch_id: "Dispatch Detail",
        expected_quantity: "Quantity",
        dispatch_date: "Date",
        quantity_received: "Delivered",
        balance_quantity: "Balance",
        dispatch_status: "Dispatch Status"
      },
      calendarBlocking: {
        dateStatusAvailable: "Available",
        dateStatusPartially: "Partially Blocked",
        dateStatusPartial: "Partial",
        dateStatusBlocked: "Blocked",
        productionUnitLabel: "Production Unit *",
        productionLineLabel: "Production Line *",
        monthLabel: "Month",
        yearLabel: "Year",
        selectionPrefix: "Selection:",
        emptyState: "Select a Production Unit and Production Line to view the calendar.",
        hideDetails: "Hide details",
        showDetails: "Show details",
        shiftDetails: "Schedule Details",
        shift1: "Shift 1",
        shift2: "Shift 2",
        shift3: "Shift 3",
        shift1WithTime: "Shift 1 (06:00–14:00)",
        shift2WithTime: "Shift 2 (14:00–22:00)",
        shift3WithTime: "Shift 3 (22:00–06:00)",
        total: "Total",
        unit: "KG",
        selectDatePrompt: "Select an available date to view shift details",
        confirmTitle: "Confirm block type for",
        shutdownTitle: "Shutdown Day",
        shutdownSubtitle: "Full production halt",
        cleaningTitle: "Cleaning Day",
        cleaningSubtitle: "Scheduled cleaning",
        confirmNoteStart: "Are you sure you want to proceed? Once confirmed,",
        confirmNoteMid: "will be blocked and unavailable for any Schedule on",
        confirmNoteEnd: ". Unblock anytime by clicking the date.",
        unblockSuccess: "Date unblocked successfully.",
        selectedLabel: "Selected",
        calendarBlockingModeLabel: "Calendar Blocking Mode",
        on: "ON",
        off: "OFF",
        selectedDatesHeader: "Selected Dates",
        day: "day",
        days: "days",
        hrs: "Hours",
        clearAll: "Clear all",
        removeDate: "Remove",
        totalAvailableLabel: "Total hours available across the selected days:",
        hrsAvailableSuffix: "Hours Available",
        nextChooseBlockType: "Next — Choose block type",
        hoursCleaningSuffix: " Hours Cleaning",
        hoursPSSuffix: " Hours Scheduled",
        hoursShutSuffix: " Hours Shutdown",
        hoursAvailSuffix: " Hours Available",
        hoursSuffix: "Hours",
        availHrsLabel: "Available Hours",
        plannedHrsLabel: "Planned Hours",
        shutdownHrsLabel: "Shutdown Hours",
        cleaningHrsLabel: "Cleaning Hours",
        totalHoursLabel: "Total Hours",
        totalBookedHrsLabel: "Blocked Hours",
        blockTypeLabel: "Block Type",
        shutdownOption: "Shutdown",
        cleaningOption: "Cleaning",
        quickApplyLabel: "Quick Apply:",
        applyToLabel: "Apply To",
        defaultShiftToApplyLabel: "Default shift to apply",
        allShiftsOption: "All Shifts",
        selectShiftsOption: "Select Shifts",
        customOption: "Custom",
        defaultHoursPerDayLabel: "Default Hours Per Shift",
        fullDayBlockLabel: "Full Day Block",
        fullDayBlockInfoTooltip: "Blocks all available hours for the selected shift(s) on this date.",
        hoursUnitSuffix: "h",
        shiftsLabel: "Shifts",
        defaultHourSuffix: "default hour",
        availableHoursPlaceholderSuffix: "h available",
        tableSNo: "S No",
        tableDate: "Date",
        tableAvailableHrs: "Available Hours",
        tableShiftHoursSuffix: "hours",
        tableTotalHoursBlocked: "Total Hours Blocked",
        tableRemainingHrs: "Remaining Hours",
        totalAcrossDaysLabel: "Total Across",
        daysSuffix: "Days",
        daySuffix: "Day",
        blockedOrdersTitle: "Blocked Orders",
        odNumberLabel: "OD Number",
        blockedQtyLabel: "Blocked Qty",
        blockedQtyUnitSuffix: "Kgs",
        todayLabel: "Today",
        blockingConfigurationTitle: "Blocking Configuration",
        addMoreDatesLabel: "Add More Dates",
        selectedDatesTitle: "Selected Dates",
        tableAvailableSubLabel: "Available",
        tableHoursToBlockSubLabel: "Hours to Block",
        blockingSummaryTitle: "Blocking Summary",
        daysSelectedLabel: "Days Selected",
        totalAvailableHoursLabel: "Total Available Hours",
        totalHoursToBlockLabel: "Total Hours to Block",
        shutdownHoursBlockedLabel: "Shutdown Hours Blocked",
        cleaningHoursBlockedLabel: "Cleaning Hours Blocked",
        remainingHoursAfterBlockingLabel: "Remaining Hours After Blocking",
        noteLabel: "Note:",
        blockingInfoNote: "Available hours are calculated per shift. Total available hours for the day may not always be 24 hours.",
        confirmBlockingLabel: "Confirm Blocking",
      }
    },
    orderLineItem: {
      forms: {
        orderLineItem: "Order Line Item"
      },
      view: {
        recordId: "Record ID",
        orderLineNo: "Order Line No",
        brand: "Brand",
        paymentTerms: "Payment Terms",
        dispatchSchedule: "Dispatch Schedule",
        sample: "Sample",
        orderNumber: "Order Number",
        relatedQli: "Related to QLI",
        customerName: "Customer Name",
        incoTerms: "Incoterms",
        customerCurrency: "Customer Currency",
        productType: "Product Type",
        entity: "Entity",
        finalRate: "Final Rate",
        skuType: "SKU Type",
        skuUnitWeight: "Sku Unit Weight",
        sampleName: "Sample Name",
        palletization: "Palletization",
        quantity: "Quantity",
        containerSize: "Container Size",
        noCartons: "No. of Cartons",
        shipmentPeriod: "Shipment Period",
        packingConfiguration: "Packing Configuration",
        brandName: "Brand Name",
        fgName: "Finished Goods Name",
        createdBy: "Created By",
        modifiedBy: "Modified By",
        createdDate: "Created Date",
        modifiedDate: "Modified Date",
        orderItemDetails: "Order Item Details",
        packingDetails: "Packing Details",
        bomDetails: "BOM Details",
        orderLineItemUpdated: "Order Line Item Updated",
        orderDispatches: "Order Dispatches",
        orderLineItems: "Order Line Items",
      },
      grid: {
        order_line_item_number: "Order Line Item Number",
        order_number: "Order Number",
        created_date: "Order Line Created Date",
        customer_name: "Customer Name",
        sample_code: "Sample Code",
        product_type: "Product Type",
        category: "Category",
        category_type: "Category Type",
        weight: "Weight",
        upc: "UPC",
        quantity: "Quantity",
        shipment_date: "Shipment Period",
        attachments_count: "Attachments"
      }
    }
  },
  auditReports: {
    forms: {
      auditReports: "Audit Reports",
      toDate: "To Date",
      fromDate: "From Date"
    }
  },
  authenticator: {
    errormsg: "The code you entered is incorrect or has expired. Please try again.",
    invalidOtp: "Invalid OTP. Please try again.",
    sessionExpired: "Session expired. Please log in again.",
    sessionExpiredStorageKey: "otpSessionExpiredMessage",
    authenticate: "Authenticate",
    otpError: "Please Enter 6 digit OTP code.",
    headerMsg: "Two Step Verification",
    headertwo: "Open your Authenticator app and Enter the 6-digit code",
    scan: "Scan this code with the Authenticator App.",
  },
  commonStrings: {
    logoAlt: "Continental Coffee",
    passwordExpiryWarning: "Your password should be changed! It passed the 180 day deadline.",
    a2Z: "A2Z",
    development: 'Development',
    qa: 'Sandbox',
    production: 'Production',
    created: "Created",
    container: "Container",
    confirmation: "Confirmation",
    notification_send_success: "Notification Send Successfully",
    gc: "GC",
    orm: "ORM",
    rc: "RC",
    selectCompanyName: "Select Company Name",
    itemType: "Item Type",
    loadMore: "Load More",
    valueCannotBeGreaterThan: "Value cannot be greater than ",
    errormessage: "Please fill valid details",
    all: "All",
    filterOptions: "Filter Options",
    Exporting: "Exporting...",
    ExportToExcel: "Export to excel",
    createPrefix: "Create ",
    view: "View",
    updateSuccess: "Updated Successfully",
    createSuccess: "Created Successfully",
    generatePDF: "Generate PDF",
    dataSaving: "Data is Saving, Please wait...",
    noDataToExport: "No data found to export",
    noData: "No data found",
    passwordRequirements: "Password must be minimum 8 character long along with uppercase, lowercase, special character and numbers",
    passwordUpdatedSuccess: "Password Updated Successfully",
    noOptions: "No options available",
    serverError: "Server Error. Please contact administrator",
    duplicateInvoiceNumber: "Invoice Number already exists. Please enter a unique Invoice Number.",
    requestSubmittedForQuoteNumber: "Request Submitted for Quote number: ",
    andEmailSentSuccessfully: " and email sent successfully",
    error: "error",
    pickList: "View Pick List",
    company_name: "Company Name",
    ccl: "CCL",
    ncl: "NCL",
    generateSampleCode: "Generate Sample Code",
    pendingWithGeneralDirector: "Pending with General Director",
    pendingWithReview : "Pending Review",
    pendingApprovalFromGD:"Pending Approval from General Director",
    category: "View Category",
    company: "Company",
    noChanges: "No Changes Detected.",
    auditSuccess: "Audit log successfully created",
    auditFailed: "Audit log failed",
    auditError: "Error while creating audit log",
    logoutRequestFailed: "Logout request failed",
    tokenRefreshFailed: "Token refresh failed",
    pleaseEnterValidEmail: "Please enter valid email",
    emailCapitalError: "Email id should not contain capital letter.",
    userAlreadyExists: "User with same email already exists",
    userCreatedSuccess: "User created successfully",
    auditInformation: "Audit Information",
    approvalSetting: "Approval Setting",
    location: "Location",
    loginDate: "Login Date",
    browserUsed: "Browser Used",
    deviceUsed: "Device Used",
    active: "Active",
    inactive: "In Active",
    noDataFound: "No Data Found",
    noRecordsFound: "No Records Found",
    search: "Search...",
    noRecords: "No records to display",
    noDataToExport: "No Data To Export",
    exportToExcel: "Export to Excel",
    import: "Import",
    domestic: "Domestic",
    export: "Export",
    merchantExport: "Merchant Export",
    exportMerchantExport: "Export/Merchant Export",
    cancel: "Cancel",
    edit: "Edit",
    submit: "Submit",
    confirm: "Confirm",
    add: "Add",
    close: "Close",
    filter: "Filter",
    remove: "Remove",
    status: "Status",
    pleaseGiveMandatoryFields: "Please check and give mandatory fields to save",
    pleaseEnterValidDetails: "Please enter valid details",
    pleaseAllRequiredFields: "Please fill all the required fields",
    emailinvalid: "Please enter valid email address",
    greenCoffeeParameters: "Green Coffee Parameter",
    greenCoffeeItemInformation: "Green Coffee Item Information",
    dataLoading: "Data is Loading, Please wait...",
    inprogress: "inprogress",
    completed: "completed",
    incomplete: "incomplete",
    recordCreating: "Please wait, Record is Creating...",
    recordUpdating: "Please wait, Record  Is Updating...",
    Approve: "Approve",
    Reject: "Reject",
    approveNReject: "Approve / Reject",
    New: "New",
    Approved: "Approved",
    Rejected: "Rejected",
    pendingForPricing: "Pending for Pricing",
    pendingForApproval: "Pending for Approval",
    success: "success",
    successfully: "Successfully",
    previous: "Previous",
    Success: "Success",
    Required: "Required",
    update: "Update",
    addNew: "Add New",
    rescheduled: "Rescheduled",
    create: "Create",
    delete: "Delete",
    actions: "Actions",
    deleted: "Deleted",
    updated: "Updated",
    deleteConfirmation: "Are you sure you want to delete this record?",
    proceed: "Proceed",
    exportMerchantExport: "Export/Merchant Export",
    send: "Send",
    ok: "Ok",
    no: "No",
    yes: "Yes",
    userAlreadyExists: "User with same email already exists",
    userCreatedSuccess: "User created successfully",
    userEditedSuccess: "User edited successfully",
    serverError: "Server Error. Please contact administrator",
    pleaseEnterValidEmail: "Please enter valid email",
    emailCapitalError: "Email id should not contain capital letter.",
    submit: "Submit",
    expire: "Expire",
    fetchingData: "Fetching Data, Please wait...",
    warning: "Warning",
    INRPerKg: "(INR/KG)",
    USDPerKg: "(USD/KG)",
    back: "Back",
    save: "Save",
    loading: "Loading...",
    auditLog: "Audit Log",
    notes: "Notes",
    note: "Note: ",
    attachment: "Attachments",
    systemInformation: "System Information",
    netsuiteInProgress: "Please wait, NetSuite integration is in progress...",
    goBack: "Go Back",
    from: "From",
    to: "To",
    done: "Done",
    categoryPayload: "Category",
    download: "Download",
    exit: "Exit",
    notificationSent: "Notification Sent Successfully",
    notificationFailed: "Failed to send Notification",
    noRecordinNetsuite: "No record found in NetSuite",
    netsuiteNotCreated: "NetSuite record not Created successfully",
    netsuiteCreated: "NetSuite record Created successfully",
    netsuiteNotUpdated: "NetSuite record not Updated successfully",
    netsuiteUpdated: "NetSuite record Updated successfully",
    exceededMaxLength: "Exceeded maximum length",
    fillFieldValue: "Please fill the field value.",
    fieldMissed: "Please fill mandatory fields to save",
    fillMandatory: "Please fill all mandatory fields to continue",
    fileExistError: "Uploaded file is already exist. Please upload new file.",
    fileTypeError: "Uploaded file type is not supported. Please upload only image, PDF, or Excel files.",
    invalidAcceptType: "Only {formats} files are accepted.",
    fileTooLarge: "File Size is too large, system is not allow to upload more than 5 MB document.",
    fileDownloadSuccess: "File downloaded successfully",
    next: "Next",
    fileName: "File Name",
    uri: "URI",
    createdBy: "Created By",
    createdDate: "Created Date",
    field: "Field",
    oldValue: "Old value",
    newValue: "New value",
    description: "Description",
    modifiedBy: "Modified By",
    modifiedDate: "Modified Date",
    regular: "Regular",
    compositeDealer: "Composite Dealer",
    sez: "SEZ",
    unRegistered: "Unregistered",
    overseas: "Overseas",
    notApplicable: "Not Applicable (NA)",
    flavoured: "Flavoured (FL)",
    coldBrew: "Cold Brew (CB)",
    ies: "IES (IE)",
    microGround: "Micro Ground (MG)",
    dryBlend: "Dry Blend Chicory Agglo (CA)",
    semiFinished: "Semi Finished (SF)",
    viewAllRecords: "View All Records ",
    viewSelectedRecords: "View Selected Records ",
    showing: "Showing",
    of: "of",
    records: "Records",
    resetSelection: "Reset Selection",
    page: " / page",
    factoryCode: {
      fnb: "F&B",
      duggirala: "Duggirala",
      sez: "SEZ",
      vietnam: "Vietnam",
      switzerland: "Switzerland",
    },
    productCodes: {
      sprayDredCoffee: "Spray Dried Coffee Powder",
      freezeDrried: "Freeze Dried Coffee",
      agglomaratedCoffee: "Agglomerated Coffee",
      coffeeOil: "Coffee Oil",
      roastedCoffee: "Roasted Coffee",
      concentratedLiquid: "Concentrated Liquid Coffee",
      RoastednGroundCoffee: "Roasted & Ground Coffee",
      instantCoffeePremix: "Instant Coffee Premix",
      teaPremix: "Tea Premix",
      sdChicoryCoffee: "SD Coffee Chicory Mix",
      fdChicoryCoffee: "FD Coffee Chicory Mix",
      agglomaratedChicoryCoffee: "Agglomerated Coffee Chicory Mix"
    },
    productSubtypeCodes: {
      notApplicable: "Not Applicable",
      flaoured: "Flavoured",
      coldBrew: "Cold Brew",
      ies: "IES",
      microground: "Micro Ground",
      dryBlend: "Dry Blend Chicory Agglo",
      semiFinished: "Semi Finished"
    },
    aromaCodes: {
      ies: "IES",
      withoutAroma: "Without Aroma",
      ssc: "SCC"
    },
    containerOptions: {
      "20'": "20'",
      "20'RF": "20'RF",
      "40'HC": "40'HC",
      "40'RF": "40'RF",
    },
    continent: {
      southAmerica: "South America",
      oceania: "Oceania",
      northAmerica: "North America",
      europe: "Europe",
      asia: "Asia",
      antarctica: "Antarctica",
      africa: "Africa"
    },
    changePasswordTitle: "Change password",
    changePasswordSubtitle: "Password must contain atleast 8 characters and a combination of numbers, uppercase, lowercase and special characters.",
    oldPasswordLabel: "Old password",
    newPasswordLabel: "New password",
    changePasswordBtn: "Change password",
    changePasswordLoading: "Loading...",
    oldPasswordRequired: "Old password required to continue",
  },
  attachments: {
    noFile: "No file attached yet.",
    fileTypeError:
      "Uploaded file type is not supported. Please upload only image, PDF, or Excel files.",
    attach: "Attach",
    attachFile: "attach_file",
    upload: "Upload",
    cloudUpload: "cloud_upload",
    UploadToS3: "Upload to S3",
    fileDownloadSuccess: "File downloaded successfully",
    attachmentsErr: "Attachment is required",
  },
  notes: {
    addNote: "Add Note",
    noNotes: "No Notes to display",
    notes: "Note",
  },
  users: {
    forms: {
      createUser: "Create User",
      users: "Users",
      entity: "Entity",
      requiredFields: "Entity is required for the selected Role",
      rdDepartmentRequired: "Department must be R & D for the selected Role",
      firstName: "First Name",
      middleName: "Middle Name",
      lastName: "Last Name",
      alias: "Alias",
      email: "Email",
      empCode: "EMP Code",
      phone: "Phone",
      mobile: "Mobile",
      active: "Active",
      designation: "Designation",
      company: "Company",
      department: "Department",
      division: "Division",
      role: "Role",
      category: "Category",
      destinationPort: "Destination Port",
      profile: "Profile",
      employee: "Employee",
      title: "Title",
      generalInformation: "General Information",
      userInformation: "User Information",
      profileInformation: "Profile Information",
      username: "User Name",
      ext: "Ext",
      approverSettings: "Approver Settings",
      delegatedApprover: "Delegated Approver",
      manager: "Manager",
      mailingAddress: "Mailing Address",
      country: "Country",
      stateProvince: "State/Province",
      address: "Address",
      city: "City",
      zipPostalCode: "Zip/Postal code",
    },
    grid: {
      email_id: "Email ID",
      first_name: "First Name",
      department: "Department",
      role: "Role",
      title: "Title",
      active: "Active",
    },
    auditInfoGrid: {
      location_info: "Location",
      login_date: "Login Date",
      browser_info: "Browser Used",
      device: "Device Used",
    },
    pageSizeStorageKey: "selectedpagesize",
    companySessionKey: "company",
    landing: {
      brandName: "CCL Products (India) Limited",
      brandTagline: "Enterprise Application",
      defaultUserName: "there",
      timePeriods: {
        midnightGrind: "Burning Midnight Grind",
        riseAndBrew: "Rise and Brew",
        happyMorning: "Happy Morning",
        middayMomentum: "Midday Momentum",
        eveningWrapUp: "Evening Wrap-Up",
        windingDown: "Winding Down",
      },
      /* Generic re-engagement titles, rotated independently of the active time period */
      welcomeTitles: [
        "Welcome",
        "Welcome Back",
        "Great to See You",
        "Hello Again",
        "Good to Have You Here",
        "Glad You’re Back",
        "Nice to See You",
        "Ready to Get Started?",
        "Let's Get to Work",
      ],
      messagesByPeriod: {
        "Burning Midnight Grind": [
          "Working late — don't forget to rest.",
          "Quiet hours. Everything’s still tracking fine.",
          "The desks in Zug and Houston are still active.",
          "Late one tonight — take care of yourself.",
          "Off-hours check-in. Nothing urgent is waiting.",
        ],
        "Rise and Brew": [
          "Ready to start the day strong.",
          "Here's to a focused morning ahead.",
          "Fresh day, fresh priorities. Let’s go.",
          "Wishing you a productive morning.",
          "First things first — here’s your workspace.",
        ],
        "Happy Morning": [
          "Hope the morning is treating you well.",
          "Good stretch to knock out priorities.",
          "Your workspace is all set and waiting.",
          "Good time to line up today's priorities.",
          "Steady progress already — nice work.",
        ],
        "Midday Momentum": [
          "Hope your day is going well so far.",
          "Halfway through — keep the momentum going.",
          "Here's your workspace, ready when you are.",
          "Good time for a quick check-in on today's priorities.",
          "Making good progress today, by the look of it.",
        ],
        "Evening Wrap-Up": [
          "Hope you had a productive day.",
          "Great to have you back.",
          "Wishing you a smooth rest of the day.",
          "Everything’s in order — welcome back.",
          "Glad you're here. Let's pick up where you left off.",
        ],
        "Winding Down": [
          "Hope today went smoothly for you.",
          "Winding down — everything's still on track.",
          "A quiet time to tie up any loose ends.",
          "Thanks for checking in this evening.",
          "Glad you stopped by — nothing urgent waiting.",
        ],
      },
    },
  },
  filterTable: {
    filterApplied: "Filters applied:",
  },
  order: {
    otherRequirements: {
      coffeeInfo: "Coffee Filling Information",
      singleContract: "Single Contract",
      multipleContracts: "Multiple Contracts",
      preShipmentSample: "Pre-Shipment Sample",
      shipmentSample: "Shipment Sample",
      inspection: "Inspection",
      document_req_by_customer: "Documents Required by the Customer",
      other_requirements: "Other Requirements",
    },
    form: {
      noPackingErroReason: "This Quote doesn't have an assigned Packing Unit. Please contact Administration.",
      noPackingErrorMsg: "No Packing Unit Available",
      missingNetsuitId: "Missing NetSuite ID",
      thisAccount: "This account ",
      isNotAvailableNetsuit: " is not available in NetSuite.",
      netsuitErrAction: "Please check with the NetSuite Team and fulfil the necessary requirements for this account to trigger it into NetSuite.",
      noFGAvailable: "No FG Item Available",
      forThisAccount: "For this account ",
      noFGAvailableinNetsuit: ", no FG item is available in NetSuite.",
      actionFG: "Please create the FG Item in Net Suite for this account.",
      changeDispatchDate: "Select Different Dispatch Date",
      order: "Order",
      quotationLineList: "Quotation Line List",
      otherRequirements: "Other Requirements",
    },
    grid: {
      order_number: "Order Number",
      quote_created_by: "Quote Created By",
      quote_number: "Quote Number",
      order_created_date: "Order Created Date",
      end_client_po_number: "End Client PO Number",
      end_client_po_date: "End Client PO Date",
      customer_name: "Customer Name",
      destination: "Destination",
      attachments_count: "Attachments",
    },
    view: {
      salesOrderNumber: "Sales Order Number",
      salesOrderStatus: "Sales Order Status",
      totalQuantity: "Total Quantity",
      totalQuantityPacked: "Total Quantity Packed",
      totalQuantityBilled: "Total Quantity Billed",
      totalQuantityCommitted: "Total Quantity Committed",
      totalQuantityPicked: "Total Quantity Picked",
      totalQuantityFulfilled: "Total Quantity Fulfilled",
      balanceQuantityToBill: "Balance Quantity To Bill",
      itemFullfillmentNo: "Item Fullfillment No",
      packingWorkOrderNumber: "Packing Work Order Number",
      status: "Status",
      packingWorkOrderQuantity: "Packing WO Quantity",
      builtQuantity: "Built Quantity",
      orderInformation: "Order Information",
      relatedQuoteInformation: "Related Quote Information",
      shippingAddress: "Shipping Address",
      billingAddress: "Billing Address",
      lineItemNumber: "Order Line No",
      dispatchSchedule: "Dispatch Schedule",
      skuType: "SKU Type",
      skuUnitWeight: "Sku Unit Weight",
      palletization: "Palletization",
      containerSize: "Container Size",
      noCartons: "No. of Cartons",
      shipmentPeriod: "Shipment Period",
      packingConfiguration: "Packing Configuration",
      grammage: "Grammage",
      recordId: "Record ID",
      orderNo: "Order No",
      brand: "Brand",
      referencePo: "End Client PO Number",
      referencePoDate: "End Client PO Date",
      orderCreationDate: "Order Creation Date",
      relatedQuote: "Related to Quote",
      customerName: "Customer Name",
      documentsRequired: "Documents Required By The Customer",
      accountType: "Account Type",
      finalClient: "Final Client",
      remarksMarketing: "Remarks from Marketing",
      specialClauses: "Special Clauses",
      destination: "Destination",
      quoteCreationDate: "Quote Creation Date",
      quoteStatus: "Quote Status",
      contactName: "Contact Name",
      customerCurrency: "Customer Currency",
      paymentTerms: "Payment Terms",
      modeTransport: "Mode of Transport",
      incoTerms: "Incoterms",
      orderUpdated: "Order Updated",
      street: "Street",
      city: "City",
      province: "Province/State",
      postalCode: "Postal code",
      country: "Country",
    },
    create_order:{
      select_adispatch_date: "Select a dispatch date on or after",
      order_create_success: "Order Created Succesfully",
    }
  },
  orderDispatch: {
    itemFulfillmentDetails: "Item Fullfillment Details",
    packingWorkOrderDetails: "Packing Work Order details",
    fromDate: "From Date",
    toDate: "To Date",
    plannedDate: "Planned Date",
    dispatchDate: "Dispatch Date",
    factoryDispatchDate: "Factory Dispatch Date",
    productionDate: "Production Date",
    fromAndToDateErr: "Please select both the from date and to date",
    fromDateNotAfterToDate: "From Date cannot be after To Date",
    pleaseSelectFromDate: "Please select the From Date",
    readinessDate: "Expected Readiness Date",
    dispatchDateSelection: "Dispatch Date Selection",
    readinessDateSelection: "Readiness Date Selection",
    packingUnit: "Packing Unit",
    odStatus: "OD Status",
    CreatePS: "Create Production Schedule",
    tabs: {
      blendSheet: "Blend Sheet Information",
      productionSchedule: "Production Schedule Information",
      containerDetails: "Container Information"
    },
    productionScheduleTabGrid: {
      record_id: "Production Schedule Record Number",
      production_schedule_start_date: "Production Schedule Start Date",
      production_schedule_end_date: "Production Schedule End Date",
      planned_quantity: "Planned Quantity",
      actual_production_start_date: "Actual Production Start Date",
      actual_production_end_date: "Actual Production End Date",
      actual_produced_quantity: "Actual Produced Quantity"
    },
    calendarCapacityError: "Hello team, there is no calendar capacity available to schedule this order dispatch. Please raise a support ticket or contact the admin for assistance with scheduling the order dispatch.",
    shipmentPeriodError: "Dispatch Date is not with in the Shipment period",
    dispatchDateError1: "Selected Dispatch Date must be between ",
    and: " and ",
    dispatchDateError2: "Please select different Dispatch date",
    rescheduleOD: "Order Dispatch Rescheduled successfully",
    rescheduledNoAudit: "Rescheduled Successfully, but no audit changes recorded",
    failedReschedule: "Failed to reschedule the Order Dispatch. Please contact administrator",
    dispatches: "Dispatches",
    warning: "Warning!",
    wrongDispatchDate: "Wrong Dispatch Date, the date must be between",
    exceededAllowed: "Exceeded the allowed, (Total <=",
    addDispatch: "Add Dispatch",
    addDispatchHeader: "Add Dispatch",
    editDispatchHeader: "Edit Dispatch",
    viewDispatchHeader: "View Dispatch",
    grid: {
      number: "SNo",
      schedule_month: "Schedule Month",
      dispatch_quantity: "Dispatch Quantity(Kgs)",
      dispatch_date: "Dispatch Date",
      customer_date: "Customer Required Date",
      contract_number: "Contract Number",
      contract_date: "Contract Date",
      purchase_date: "PO Date",
      purchase_number: "PO Number",
      shipment_information: "Shipment Information",
      product_description: "Product Description",
      customer_information: "Customer Information",
      actions: "Actions",
      total_dispatch_quantity: "Total Dispatch Quantity(Kgs)"
    },
    view: {
      orderDispatchNo: "Order Dispatch No",
      relatedQuoteLine: "Related to Quote Line",
      relatedOrder: "Related to Order",
      relatedQuote: "Related to Quote",
      relatedOrderLine: "Related to Order Line",
      loadability: "Loadability",
      noBoxes: "No of Boxes",
      noContainers: "No of Containers",
      inventoryStatus: "Inventory Status",
      portOfLoading: "Port of Loading",
      readyForDispatchDate: "Ready for Dispatch Date",
      packingUnitEntity: "Packing Unit (Entity)",
      bomId: "Bom Id",
      bomName: "BOM Name",
      dueAmount: "Due Amount",
      dueTillDate: "Due Till Date",
      advanceAmountPaid: "Advance Amount Paid",
      orderDispatchInformation: "Order Dispatch Information",
      orderItemDetails: "Order Item Details",
      orderDispatchDetails: "Order Dispatch Details",
      orderDispatch: "Order Dispatch",
      bomInformation: "BOM Information",
      orderDispatchUpdated: "Order Dispatch Updated",
      totalQuantityLabel: "Total Quantity :",
      softScheduleLines: "Soft Schedule Lines",
      salesOrderInformation: "Sales Order Information",
      shippingDetails: "Shipping Details",
      financialInformation: "Financial Information",
      scheduleInformation: "Schedule Information",
      recordId: "Record ID",
      netsuiteId: "NetSuite Id",
      netsuiteResponse: "NetSuite Response",
      contractNumber: "Contract Number",
      contractDate: "Contract Date",
      shipmentInformation: "Shipment Information",
      productDescription: "Product Description",
      modeOfTransport: "Mode of Transport",
      status: "Status",
      destination: "Destination",
      shipmentDate: "Dispatch Date",
      expectedDeliveryDate: "Expected Readiness Date",
      customerRequiredDate: "Customer Required Date",
      scheduleMonth: "Schedule Month",
      quantity: "Quantity(Kgs)",
      sample: "Sample",
      packingConfiguration: "Packing Configuration",
      invoiceDate: "Invoice Date",
      softSchedule: "Soft Schedule Date",
      productionSchedule: "Production Schedule Date",
      fgName: "Finished Goods Name",
      brandName: "Brand Name",
    },
    forms: {
      scheduleCreated: "Schedule Created",
      productionCapacityNotAvail: "Production Capacity is not available for this customer sample",
      addDocument: "Add Document",
      selectDocument: "Select Document",
      removeDocument: "Remove document",
      newDocumentOnSave: "The file will be uploaded when you click Save",
      selectFile: "Select a file",
      documentName: "Document Name",
      fileName: "File Name",
      uploadDate: "Upload Date",
      pdfOnly: "Please select a PDF file",
      documentsSaveFailed: "Required documents could not be saved, so the order dispatch was not updated. Reason: ",
      addedDocumentsNeedFile: "Please select a file for the newly added document(s) before saving: ",
      fileRemovedOnSave: "Remove file (removed when you click Save)",
      removeSelectedFile: "Remove selected file",
      requiredDocumentAudit: "Required Document",
      documentFileAuditSuffix: " File",
      documentsRequired: "Documents Required",
      pdfFilesOnly: "(Please upload PDF files only*)",
      noDocuments: "No documents",
      documentsLoadFailed: "Can't load documents",
    },
    lists: {
      documents: {
        invoice: "Invoice",
        packing_list: "Packing List",
        bill_of_loading: "Bill of Lading",
        certificate_origin: "Certificate of Origin / GSP Certificate of Origin / CEPA / AIFTA",
        certificate_analysis: "Certificate of Analysis",
        phytosanitary_certificate: "Phytosanitary Certificate",
        weight_note: "Weight Note",
        fumigation_certificate: "Fumigation Certificate",
        health_cisco: "Health Certificate by CISCO",
        health_eia: "Health Certificate by EIA",
        insurance_certificate: " Insurance certificate",
      },
      otherDocuments: {
        pre_shipment: "Pre-Shipment Sample",
        shipment: "Shipment Sample",
        inspection: "Inspection",
        single_po: "Single PO Date & Number",
        multiple_po: "Multiple PO Date & Number",
      },
      transportModes: {
        sea: "By Sea",
        air: "By Air",
        road: "By Land",
      },
      inventory: {
        current: "Current",
        procurement: "Requires Procurement",
        in_transit: "In-transit",
      },
      orderStatus: {
        initiated: "Initiated",
        contract: "Contract",
        scheduled: "Scheduled",
        planned: "Planned",
        production: "Production",
        packing: "Packing",
        dispatched: "Dispatched",
        dispatch: "Dispatch",
        completed: "Completed",
      },
      entity: {
        EOU1: "EOU1",
        EOU2: "EOU2",
        SEZDEV: "SEZDEV",
        DTA: "DTA",
        HEAD_OFFICE: "HEAD OFFICE",
        SEZ: "SEZ",
      },
    },
    odGrid: {
      order_dispatch_number: "Order Dispatch Number",
      order_line_item_number: "Quote Line Item Number",
      factory_code: "Factory Code",
      dispatch_date: "Factory Dispatch Date",
      destination: "Destination",
      dispatch_status: "Status",
      quantity: "Quantity",
      expected_delivery_date: "Expected Readiness Date",
      ready_for_dispatch_date: "Ready for Dispatch Date",
      attachments_count: "Attachments",
    },
    ppcGrid: {
      order_dispatch_number: "Order Dispatch Number",
      dispatch_status: "Status",
      quote_category: "Sales Business",
      factory_code: "Production Unit",
      packing_unit: "Packing Unit",
      customer_name: "Customer Name",
      customer_brand_name: "Customer Brand Name",
      product_type: "Product Type",
      alternate_sample_code: "Alternative Sample Code",
      sku: "SKU",
      quantity: "Quantity",
      production_capacity_perday: "Output MT/Day",
      dispatch_date: "Factory Dispatch Date",
      expected_delivery_date: "Expected Readiness Date",
      ready_for_dispatch_date: "Ready for Dispatch Date",
      dispatched_date: "Invoice Date",
      company_name: "Company Name",
    },
    productionGrid: {
      order_dispatch_number: "Order Dispatch Number",
      brand_name: "Brand Name",
      finished_goods_name: "Finished Goods Name",
      customer_required_date: "Customer Required Date",
      dispatch_date: "Dispatch Date",
      expected_readiness_date: "Expected Readiness Date",
      production_schedule_date: "Production Schedule Date",
      packing_unit: "Packing Unit",
      packing_configuration: "Packing Configuration",
    },
    containerGrid: {
      production_schedule_record_number: "Production Schedule Record Number",
      order_dispatch_number: "Order Dispatch Number",
      order_dispatch_quantity: "Order Dispatch Quantity",
      account_name: "Customer Name",
      contract_number: "Contract Number",
      indent_quantity: "Indent Quantity",
      destination: "Destination",
      port_of_loading_name: "Port of Loading",
      number_of_containers: "Number of Containers",
      size_of_container: "Container Size",
      vendor_name: "Vendor Name",
      shipping_lines: "Shipping Line",
      container_planned_date: "Container Placement Date",
      freight_status: "Freight Status",
    },
    ODcontainerGrid: {
      production_schedule_record_number: "Production Schedule record",
      logistic_date: "Logistics Date",
      container_planned_date: "Container Planned Date",
      vendor_name: "Vendor Name",
      port_of_loading_name: "Port of Loading",
      empty_container_date: "Empty Container Date",
      shipping_lines: "Shipping Lines",
      container_sail_date: "Container Sail Date",
      actual_dispatch_date: "Actual Dispatch Date",
      actual_delivery_date: "Actual Delivery Date",
      size_of_container: "Size of Container",
      customer_handling_agent: "Customer Handling Agent",
      indent_quantity: "Indent Quantity"
    },
  },
  pdfs: {
    corporateOffice: "Corporate Office: ",
    address:
      "CCL Products (India) Ltd, 8-2-269/4A, Road No.2, Banjara Hills, Hyderabad – 500034, Telangana, India.",
    phNo: "Tel : (040) 23730855.",
    companyBeverages: "CCL FOOD AND BEVERAGES PRIVATE LIMITED",
    companyName: "CCL PRODUCTS (INDIA) LIMITED",
    nclCompany : "Ngon Coffee Company Limited",
    nclAddressLine1: "Cu Kuin Industrial Complex, Dray Bhang Commune",
    nclAddressLine2: "Dak Lak Province, Vietnam",
    nclTaxCode: "Tax Code : 6000916516",
    taxCodeLabel: "Tax Code:",
  },
  inventory: {
    location: "Location",
    totalQuantityOnHand: "Total Quantity On Hand",
    totalQuantityCommitted: "Total Quantity Committed",
    totalQuantityBackOrdered: "Total Quantity Back Order",
    averageCost: "Average Cost",
    sublocationName: "Sub Location",
    quantityOnHand: "Quantity On Hand",
    quantityCommitted: "Quantity Committed",
    quantityBackOrdered: "Quantity Back Order",
    seeLocations: "See Locations",
  },
  launchPadsLabels: {
    sidebar: {
      expandSidebar: 'Expand sidebar',
      goToHome: 'Go to Home',
      home: 'Home',
      collapseSidebar: 'Collapse sidebar',
      expandSidebar: 'Expand sidebar',
      collapse: 'Collapse',
      expand: 'Expand',
      departmentsNav: 'Departments',
      dashboard: 'Dashboard',
    },
    breadcrumb: {
      navAriaLabel: 'breadcrumb',
      actionCreate: 'Create',
      actionView: 'View',
      actionEdit: 'Edit',
      actionDelete: 'Delete',
      actionAdd: 'Add',
      lineItem: 'Line Item',
      sampleLineItem: 'Sample Line Item',
      quotationLineItem: 'Quotation Line Item',
      quotationItem: 'Quotation Item',
      preShipmentSampleLineItem: 'Pre-shipment Sample Line Item',
      typeSampleLineItem: 'Type Sample Line Item',
      tabs: {
        allocationInformation: 'Allocation Information',
        workOrderInformation: 'Work Order Information',
        blendSheetInformation: 'Blend Sheet Information',
        mrin: 'MRIN',
        preShipmentSample: 'Pre-Shipment Sample',
        orderDispatch: 'Order Dispatch',
        orderDispatches: 'Order Dispatches',
        orders: 'Orders',
        orderLineItem: 'Order Line Item',
        orderLineItems: 'Order Line Items',
        quotationDetails: 'Quotation Details',
        salesOrderInformation: 'Sales Order Information',
        softSchedules: 'Soft Schedules',
        sampleLineItemInformation: 'Sample Line Item Information',
      },
      // Page-level breadcrumb label overrides — keyed by route path prefix
      pages: {
        sampleRequests: 'Sample Requests',
        quotations: 'Quotations',
        orders: 'Orders',
        orderLineItems: 'Order Line Items',
        orderDispatches: 'Order Dispatches',
        softSchedules: 'Soft Schedules',
        productionSchedules: 'Production Schedules',
        suppliers: 'Suppliers',
        packingTypes: 'Packing Types',
        blendSheets: 'Blend Sheets',
        certifications: 'Certifications',
        batchOutputs: 'Batch Outputs',
      },
      // Module display labels — used in MODULE_CONFIG and MODULE_DEPT_KEYS
      modules: {
        dashboard: 'Dashboard',
        crm: 'CRM',
        commercial: 'Commercial',
        purchase: 'Purchase',
        production: 'Production',
        finance: 'Finance',
        admin: 'Admin',
        auditReports: 'Audit Reports',
      },
    },
    crm: {
      name: 'CRM',
      modules: ['Home',
        'Lead',
        'Accounts',
        'sample Request',
        'Master Samples',
        'Alternative Samples',
        'Customer samples',
        'Sample Information',
        'Quotation',
        'QLI',
        'FG Validity'],
    },
    commercial: {
      name: 'Commercial',
      modules: ['Order', 'Order Line Item', 'Order Dispatch', 'Soft Schedule', 'Production Schedule'],
    },
    purchase: {
      name: 'Purchase',
      modules: ['Purchase Order',
        'Debit Note GC',
        'MRIN',
        'GC',
        'Supplier',
        'Tax Settings',
        'Packing Type',
        'Dispatch Info',
        'Allocations',
        'GC Required',
        'GC Daily Rates',
        'GC Enquiry',
        'Type / Pre-Shipment Sample',]
    },
    productionAndQuality: {
      name: 'Production & Quality',
      modules: ['Blend Sheet', 'Certification', 'Batch Output'],
    },
    finance: {
      name: 'Finance',
      modules: ['Finance Costing'],
    },
    auditReports: {
      name: 'Audit Reports',
      modules: ['Audit Reports'],
    },
    admin: {
      name: 'Admin',
      modules: ['Users'],
    },
  },

  factoryCode: {
    Duggirala: "Duggirala",
    SEZ: "SEZ",
    Vietnam: "Vietnam",
    Switzerland: "Switzerland",
    FB: "F&B",
  },
  settings: {
    forms: {
      taxMaster: "Tax Master",
      taxName: "Tax Name",
      taxPercentage: "Tax Percentage",
      isActive: "Is Active",
      taxInformation: "Tax Information",
      taxDetails: "Tax Details",
      createdSuccess: "Tax Information Created Successfully",
      updatedSuccess: "Tax Information Updated Successfully",
      upload: "Upload",
      createTax: "Create Tax",
    },
    grid: {
      taxName: "Tax Name",
      taxPercentage: "Tax Percentage",
      status: "Status",
      taxId: "Tax Id",
    },
    view: {
      taxInformation: "Tax Information",
    }
  },
  logout: {
    warningMessage: "Your session will be expire in ",
    warningMessageSecond: " seconds.",
    warningHeader: "Session Expiry Warning",
    stayLoggedIn: "Stay Logged In",
    logout: "Logout",
  },
  login: {
    youHaveBeenLoggedOut: "You have been logged out due to inactivity.",
    login: "Login",
    subtitle: "Please login to your account",
    emailAddress: "Email Address",
    emailPlaceholder: "Enter your email",
    password: "Password",
    passwordPlaceholder: "Enter your password",
    forgotPassword: "Forgot password?",
    loading: "Loading...",
    passwordRequired: "Password cannot be empty",
    invalidName: "Please enter valid name",
    genericError: "Something Went Wrong"
  },
  forgotPasswordPage: {
    title: "Forgot Password",
    resetPassword : "Reset Password",
    subtitle1: "Enter your registered email address and we’ll send you a verification code to reset your password.",
    emailAddress: "Email Address",
    emailPlaceholder: "you@company.com",
    sendResetLink: "Send Verification Code",
    rememberedIt: "Remembered it?",
    backToLogin: "Back to login",
    verificationCode: "Verification Code",
    verificationCodePlaceholder: "Enter your verification code",
    newPassword: "New Password",
    confirmPassword: "Confirm Password",
    confirmPasswordPlaceholder: "Re-enter your new password",
    newPasswordPlaceholder: "Enter your new password",
    changePassword: "Change Password",
    resetCodeSent: "Reset code sent successfully",
    resetSuccess: "Password reset successful. Please log in with your new password.",
    subtitle2: "We’ve sent a verification code to your registered email address. Enter the code to continue resetting your password.",
    resetError: "Some error occurred. Please try again later",
    passwordError: "Password must be minimum 8 characters with uppercase, lowercase, special character and numbers",
    passwordHint: "Use 8+ characters with a mix of uppercase, lowercase, numbers and special characters.",
    codeError: "Please enter a valid 6 digit code",
    passwordMismatch: "Passwords do not match",
    codeRequired: "Please enter verification code",
    passwordRequired: "Please enter password",
    confirmPasswordRequired: "Please re-enter password to confirm",
  }
};

export const factoryCodeStrings = StringBundle.factoryCode;
export const entityNamesStrings = StringBundle.entityNames;
export const masterSampleStrings = StringBundle.CRM.MasterSamlples;
export const alternativeSampleStrings = StringBundle.CRM.AlternativeSamlples;
export const customerSampleString = StringBundle.CRM.customerSample;
export const debitNoteStrings = StringBundle.purchase.debitnote;
export const gcStrings = StringBundle.purchase.GC;
export const blendsheetStrings = StringBundle.ProductionNQuality.blendsheet;
export const financeStrings = StringBundle.finance;
export const FGvalidityStrings = StringBundle.CRM.FGvalidity;
export const QuotationStrings = StringBundle.CRM.Quotation;
export const LeadStrings = StringBundle.CRM.Lead;
export const homeStrings = StringBundle.CRM.Home;
export const accountStrings = StringBundle.CRM.Account;
export const customerSampleStrings = StringBundle.CRM.CustomerSamples;
export const sampleRecepieTabsStrings = StringBundle.CRM.sample_recepie_tabs;
export const commonStrings = StringBundle.commonStrings;
export const attachmentsStrings = StringBundle.attachments;
export const notesStrings = StringBundle.notes;
export const filterTableStrings = StringBundle.filterTable;
export const allocationStrings = StringBundle.purchase.allocation;
export const orderDispatchStrings = StringBundle.orderDispatch;
export const purchaseOrderStrings = StringBundle.purchase.purchaseOrder;
export const mrinStrings = StringBundle.purchase.mrin;
export const productionScheduleStrings =
  StringBundle.commercial.ProductionSchedule;
export const supplierStrings = StringBundle.purchase.supplier;
export const gcEnquiryStrings = StringBundle.purchase.gcEnquiry;
export const pdfStrings = StringBundle.pdfs;
export const PSSStrings = StringBundle.purchase.PSS;
export const orderStrings = StringBundle.order;
export const launchpadStrings = StringBundle.launchPadsLabels;
export const breadcrumbStrings = StringBundle.launchPadsLabels.breadcrumb;
export const contactStrings = StringBundle.CRM.Contacts;
export const logisticsStrings = StringBundle.purchase.logistics;
export const PackingTypeStrings = StringBundle.purchase.packingType;
export const sampleStrings = StringBundle.CRM.SampleInformation;
export const batchOutputStrings = StringBundle.ProductionNQuality.batchOutput;
export const sampleRequestStrings = StringBundle.CRM.SampleRequest;
export const poDispatchStrings = StringBundle.purchase.purchaseOrder.dispatch;
export const poAllocationListStrings = StringBundle.purchase.purchaseOrder.allocationList;
export const dispatchInfoStrings = StringBundle.purchase.dispatchInfo;
export const gcDailyRateStrings = StringBundle.purchase.gcDailyRates;
export const inventoryStrings = StringBundle.inventory;
export const userStrings = StringBundle.users;
export const landingStrings = StringBundle.users.landing;
export const certificationStrings = StringBundle.ProductionNQuality.certification;
export const auditReportStrings = StringBundle.auditReports;
export const orderLineItemStrings = StringBundle.commercial.orderLineItem;
export const softScheduleStrings = StringBundle.commercial.SoftSchedule;
export const gcRequiredStrings = StringBundle.purchase.gcRequired;
export const settingsStrings = StringBundle.settings;
export const QuotesStrings = StringBundle.CRM.Quotes;
export const logoutStrings = StringBundle.logout;
export const loginStrings = StringBundle.login;
export const authenticatorStrings = StringBundle.authenticator;
export const forgotPasswordStrings = StringBundle.forgotPasswordPage;
